/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps, no-useless-escape */
// frontend/src/components/AcceptedJobs.js
import '../api/axiosConfig';
import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import axios from 'axios';
import {
  Accordion,
  Button,
  Modal,
  Form,
  Spinner,
  Alert,
  Dropdown,
  // OverlayTrigger,
  // Tooltip,
  Row,
  Col,
  Table,
  Badge,
  Card
} from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useJsApiLoader, GoogleMap, Marker, DirectionsRenderer } from '@react-google-maps/api';
import SimplePhoneInput from './SimplePhoneInput';
import locationService from '../services/locationService';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { setHours, setMinutes, isSameDay } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useLeadNotifications from '../hooks/useLeadNotifications';
import useAudioToast from '../hooks/useAudioToast';
import DiaryModal from './DiaryModal';
import JobCancellationModal from './JobCancellationModal';
import CustomerReviewIndicator from './CustomerReviewIndicator';
import CustomerReviewModal from './CustomerReviewModal';
import JobCardReviewIndicator from './JobCardReviewIndicator';
import { FaStar, FaPlus, FaTimes } from 'react-icons/fa';
import audioNotificationService from '../services/audioNotificationService';
import TaxiMeter from './TaxiMeter';
// import DateTimePicker from './DateTimePicker';

// Add CSS for booking link job flashing effect and accordion styling
const bookingLinkStyles = `
  .booking-link-job {
    animation: bookingLinkFlash 2s infinite;
    border: 2px solid #007bff !important;
  }
  
  @keyframes bookingLinkFlash {
    0%, 100% { 
      background-color: rgba(0, 123, 255, 0.1);
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
    }
    50% { 
      background-color: rgba(0, 123, 255, 0.2);
      box-shadow: 0 0 15px rgba(0, 123, 255, 0.5);
    }
  }
  
  /* Flashing chevron after booking link text */
  .booking-link-flash-arrow {
    display: inline-block;
    margin-left: 8px;
    animation: chevronFlash 0.8s infinite;
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1;
    vertical-align: middle;
    color: #FFD700 !important;
  }
  
  @keyframes chevronFlash {
    0%, 100% { 
      color: #FFD700 !important;
      opacity: 1;
      transform: scale(1);
      text-shadow: 0 0 5px rgba(255, 215, 0, 0.8), 0 0 10px rgba(255, 215, 0, 0.5);
    }
    50% { 
      color: #FFFF00 !important;
      opacity: 0.9;
      transform: scale(1.2);
      text-shadow: 0 0 10px rgba(255, 255, 0, 1), 0 0 20px rgba(255, 215, 0, 0.8);
    }
  }
  
  /* Force white text for booking link and wait & return headers */
  .booking-link-header {
    color: white !important;
  }
  
  .booking-link-header strong {
    color: white !important;
  }
  
  .wait-return-header {
    color: white !important;
  }
  
  .wait-return-header strong {
    color: white !important;
  }
  
  /* Override accordion header text colors specifically */
  .accordion-header .booking-link-header {
    color: white !important;
  }
  
  .accordion-header .booking-link-header strong {
    color: white !important;
  }
  
  .accordion-header .wait-return-header {
    color: white !important;
  }
  
  .accordion-header .wait-return-header strong {
    color: white !important;
  }
  
  /* More specific targeting for accordion header text */
  .accordion-button .booking-link-header,
  .accordion-button .wait-return-header {
    color: white !important;
  }
  
  .accordion-button .booking-link-header strong,
  .accordion-button .wait-return-header strong {
    color: white !important;
  }
  
  /* Ultra-specific targeting for Bootstrap accordion override */
  .accordion-item .accordion-header .accordion-button .booking-link-header,
  .accordion-item .accordion-header .accordion-button .wait-return-header {
    color: white !important;
  }
  
  .accordion-item .accordion-header .accordion-button .booking-link-header strong,
  .accordion-item .accordion-header .accordion-button .wait-return-header strong {
    color: white !important;
  }
  
  /* Target all text within these specific elements - but not chevrons */
  .booking-link-header *:not(.booking-link-flash-arrow),
  .wait-return-header *:not(.booking-link-flash-arrow) {
    color: white !important;
  }
  
  /* Ensure chevrons stay yellow */
  .booking-link-header .booking-link-flash-arrow,
  .wait-return-header .booking-link-flash-arrow {
    color: #FFD700 !important;
  }
  
  /* Slide Panel Styles */
  .slide-panel-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  
  .slide-panel-overlay.show {
    opacity: 1;
    visibility: visible;
  }
  
  .slide-panel {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    max-width: 450px;
    background-color: #ffffff;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
    z-index: 1041;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .slide-panel.show {
    transform: translateX(0);
  }
  
  .slide-panel-header {
    position: sticky;
    top: 0;
    background-color: #ffc107;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  
  .slide-panel-body {
    padding: 0;
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }
  
  /* Swipe gesture support */
  .slide-panel {
    touch-action: pan-y;
    user-select: none;
  }
  
  .slide-panel-swipe-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.1);
    cursor: grab;
  }
  
  .slide-panel-swipe-indicator:active {
    cursor: grabbing;
  }
  
  .navigation-map-container {
    width: 100%;
    height: 400px;
    min-height: 400px;
  }
  
  /* Navigation accordion night mode styling */
  .navigation-night-mode-accordion .accordion-button {
    background-color: #000000 !important;
    color: #ffffff !important;
    border: none !important;
    box-shadow: none !important;
  }
  
  .navigation-night-mode-accordion .accordion-button:not(.collapsed),
  .navigation-night-mode-accordion .accordion-button.show {
    background-color: #000000 !important;
    color: #ffffff !important;
    box-shadow: none !important;
  }
  
  .navigation-night-mode-accordion .accordion-button:hover {
    background-color: #1a1a1a !important;
    color: #ffffff !important;
  }
  
  .navigation-night-mode-accordion .accordion-button:focus {
    background-color: #000000 !important;
    color: #ffffff !important;
    box-shadow: none !important;
    border: none !important;
  }
  
  .navigation-night-mode-accordion .accordion-button::after {
    filter: invert(1);
  }
  
  .navigation-night-mode-accordion .accordion-item {
    background-color: #000000 !important;
    border: none !important;
  }
  
  .navigation-night-mode-accordion .accordion-body,
  .navigation-night-mode-accordion .accordion-collapse.show .accordion-body,
  .navigation-night-mode-accordion .accordion-collapse:not(.collapse) .accordion-body {
    background-color: #000000 !important;
    color: #ffffff !important;
  }
  
  .navigation-night-mode-accordion .accordion-body *,
  .navigation-night-mode-accordion .accordion-collapse.show .accordion-body *,
  .navigation-night-mode-accordion .accordion-collapse:not(.collapse) .accordion-body * {
    color: #ffffff !important;
  }
  
  .navigation-night-mode-accordion .accordion-body strong,
  .navigation-night-mode-accordion .accordion-collapse.show .accordion-body strong,
  .navigation-night-mode-accordion .accordion-collapse:not(.collapse) .accordion-body strong {
    color: #ffffff !important;
  }
  
  .navigation-night-mode-accordion .accordion-body div,
  .navigation-night-mode-accordion .accordion-collapse.show .accordion-body div,
  .navigation-night-mode-accordion .accordion-collapse:not(.collapse) .accordion-body div {
    color: #ffffff !important;
  }
  
  @media (max-width: 768px) {
    .slide-panel {
      max-width: 100%;
    }
  }

  /* Accordion styling - will be overridden by night mode */
  .accordion-item {
    background-color: #ffffff !important;
    border: 1px solid #dee2e6 !important;
  }
  
  .accordion-header {
    background-color: #ffffff !important;
  }
  
  .accordion-body {
    background-color: #ffffff !important;
  }
  
  /* Preserve day separation borders */
  .accordion-item.day-change-border {
    border-top: 3px solid #000000 !important;
  }
  
  /* Night mode job card styling - only applied when night mode is active */
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body .card,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body .form-control {
    background-color: #404040 !important;
    color: #e0e0e0 !important;
    border-color: #666666 !important;
  }
  
  /* Night mode accordion styling */
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-header {
    background-color: #404040 !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-item {
    background-color: #404040 !important;
  }
  
  /* Ensure action buttons keep their original colors in night mode */
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body .btn {
    background-color: unset !important;
    color: unset !important;
    border-color: unset !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-header .btn {
    background-color: unset !important;
    color: unset !important;
    border-color: unset !important;
  }
  
  /* Force button colors to stay original in night mode */
  body[style*="background-color: rgb(44, 44, 44)"] .btn-primary {
    background-color: #0d6efd !important;
    border-color: #0d6efd !important;
    color: #ffffff !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .btn-success {
    background-color: #198754 !important;
    border-color: #198754 !important;
    color: #ffffff !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .btn-warning {
    background-color: #ffc107 !important;
    border-color: #ffc107 !important;
    color: #000000 !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .btn-danger {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
    color: #ffffff !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .btn-info {
    background-color: #0dcaf0 !important;
    border-color: #0dcaf0 !important;
    color: #000000 !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .btn-secondary {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
    color: #ffffff !important;
  }
  
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body p,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body div,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body span,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body small,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body strong,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body label,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body input,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body textarea,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h1,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h2,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h3,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h4,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h5,
  body[style*="background-color: rgb(44, 44, 44)"] .accordion-body h6 {
    color: #e0e0e0 !important;
    background-color: transparent !important;
  }
`;

// Inject the styles
if (!document.getElementById('booking-link-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'booking-link-styles';
  styleSheet.textContent = bookingLinkStyles;
  document.head.appendChild(styleSheet);
}

// ── Helpers ─────────────────────────────────────────
// Format time for digital clock display (same as MyDiary header)
function formatTime(date) {
  return date.toLocaleTimeString('en-GB', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).replace(/\s(AM|PM)/i, ''); // Remove AM/PM
}

function formatWhen(iso) {
  try {
    const date = new Date(iso);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date in formatWhen:', iso);
      return 'Invalid Date';
    }
    const parts = new Intl.DateTimeFormat('en-GB', {
      hour: 'numeric', minute: '2-digit', hour12: true,
      weekday: 'short', day: 'numeric', month: 'short',
      timeZone: 'Europe/London'
    }).formatToParts(date);
    const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
    return `${p.hour}:${p.minute} ${p.dayPeriod?.toLowerCase()}, ${p.weekday} ${p.day} ${p.month}`;
  } catch (error) {
    console.warn('Error formatting date:', iso, error);
    return 'Invalid Date';
  }
}
function extractTowns(a, b) {
  const town = s => s.split(',').slice(-2, -1)[0]?.trim() || s;
  return `${town(a)} → ${town(b)}`;
}

/**
 * Clean Google Maps formatted address by removing unwanted information
 * Removes: "UK", double town names, "Managed by..." text
 */
function cleanGoogleMapsAddress(address) {
  if (!address || typeof address !== 'string') {
    return address;
  }
  
  let cleaned = address.trim();
  
  // Remove "Managed by..." text and everything after it
  const managedByIndex = cleaned.indexOf('Managed by');
  if (managedByIndex !== -1) {
    cleaned = cleaned.substring(0, managedByIndex).trim();
  }
  
  // Remove ", UK" or "UK" at the end (case insensitive)
  cleaned = cleaned.replace(/,\s*UK\s*$/i, '').trim();
  cleaned = cleaned.replace(/\s+UK\s*$/i, '').trim();
  
  // Remove duplicate town names
  // Split by comma and process each part
  const parts = cleaned.split(',').map(p => p.trim()).filter(p => p.length > 0);
  const uniqueParts = [];
  const seen = new Set();
  
  // Common street suffixes to ignore when comparing
  const streetSuffixes = ['road', 'street', 'avenue', 'lane', 'drive', 'way', 'close', 'place', 
    'court', 'gardens', 'park', 'hill', 'terrace', 'row', 'crescent', 'grove', 'walk', 
    'square', 'yard', 'mews', 'end', 'corner', 'view', 'rise', 'vale', 'green', 'mead', 
    'bank', 'bridge', 'gate', 'side', 'wood', 'heath', 'ford', 'well'];
  
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];
    // Normalize for comparison (lowercase, remove common street suffixes)
    const normalized = part.toLowerCase()
      .replace(new RegExp(`\\s+(${streetSuffixes.join('|')})$`, 'i'), '')
      .trim();
    
    // Skip if we've seen this normalized part before (avoid duplicates)
    // But always keep the last part (usually postcode or main area) and postcodes (contain numbers/letters pattern)
    const isPostcode = /^[A-Z]{1,2}\d{1,2}\s?\d[A-Z]{2}$/i.test(part);
    if (!seen.has(normalized) || i === parts.length - 1 || isPostcode) {
      uniqueParts.push(part);
      if (!isPostcode) {
        seen.add(normalized);
      }
    }
  }
  
  cleaned = uniqueParts.join(', ').trim();
  
  // Final cleanup: remove trailing commas
  cleaned = cleaned.replace(/,\s*$/, '').trim();
  
  return cleaned;
}
function toISOStringLocal(d) {
  try {
    const dt = new Date(d);
    if (isNaN(dt.getTime())) {
      console.warn('Invalid date in toISOStringLocal:', d);
      return new Date().toISOString(); // Return current date as fallback
    }
    return new Date(
      dt.getFullYear(), dt.getMonth(), dt.getDate(),
      dt.getHours(), dt.getMinutes()
    ).toISOString();
  } catch (error) {
    console.warn('Error in toISOStringLocal:', d, error);
    return new Date().toISOString(); // Return current date as fallback
  }
}

const formatTimestamp = iso => {
  if (!iso) return 'Not available';
  const dt = new Date(iso);
  const hours = dt.getHours().toString().padStart(2, '0');
  const minutes = dt.getMinutes().toString().padStart(2, '0');
  const day = dt.getDate().toString().padStart(2, '0');
  const month = dt.toLocaleDateString('en-GB', { month: 'short', timeZone: 'Europe/London' });
  const year = dt.getFullYear().toString().slice(-2);
  return `${hours}:${minutes}-${day}/${month}/${year}`;
};

// Google Maps configuration for Journey Estimator
const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'drawing'];

// Tariff configuration for Journey Estimator
const councils = {
  'East Devon District Council': {
    name: 'East Devon District Council',
    tariffs: {
      tariff1: { name: 'Tariff 1', firstMile: 5.96, subsequentMile: 2.73, description: 'TARIFF 1:- Weekday Daytime Rate (Applies on weekdays between 7 am and 7 pm)' },
      tariff2: { name: 'Tariff 2', firstMile: 6.93, subsequentMile: 3.3, description: 'TARIFF 2:- Evening/Night & Sunday Rate (Applies on weekdays between 7 pm and 7 am and on Sundays)' },
      tariff3: { name: 'Tariff 3', firstMile: 9.02, subsequentMile: 3.85, description: 'TARIFF 3:- Bank Holiday, Christmas and New Year Rate' }
    }
  },
  'Dorset District Council': {
    name: 'Dorset District Council',
    tariffs: {
      tariff1: { name: 'Tariff 1', firstMile: 6.6, subsequentMile: 2.8, description: 'TARIFF 1:- Day Rate (7 am until 11 pm)' },
      tariff2: { name: 'Tariff 2', firstMile: 9.9, subsequentMile: 4.2, description: 'TARIFF 2:- Unsocial Hours' },
      tariff3: { name: 'Tariff 3', firstMile: 13.2, subsequentMile: 5.6, description: 'TARIFF 3:- Special Rate (Christmas & New Year)' }
    }
  },
  // Default tariff for other councils
  'Default': {
    name: 'Default',
    tariffs: {
      tariff1: { name: 'Tariff 1', firstMile: 6.0, subsequentMile: 2.75, description: 'TARIFF 1:- Weekday Daytime Rate' },
      tariff2: { name: 'Tariff 2', firstMile: 7.0, subsequentMile: 3.5, description: 'TARIFF 2:- Evening/Night & Sunday Rate' },
      tariff3: { name: 'Tariff 3', firstMile: 9.0, subsequentMile: 4.0, description: 'TARIFF 3:- Bank Holiday, Christmas and New Year Rate' }
    }
  }
};

const DEFAULT_TARIFFS = councils?.Default?.tariffs || {};

const findTariffsForJob = (job) => {
  if (!job) {
    return DEFAULT_TARIFFS;
  }

  const licensingAuthority = job.acceptedBy?.licensingAuthority || job.licensingAuthority || '';
  const normalizedAuthority = licensingAuthority.trim().toLowerCase();

  if (!normalizedAuthority) {
    return DEFAULT_TARIFFS;
  }

  const matchedKey = Object.keys(councils).find(
    (key) => key.trim().toLowerCase() === normalizedAuthority
  );

  return councils[matchedKey]?.tariffs || DEFAULT_TARIFFS;
};

const calculateTariffEstimates = (distanceMiles, job) => {
  if (!distanceMiles || Number.isNaN(distanceMiles) || distanceMiles <= 0) {
    return null;
  }

  const tariffs = findTariffsForJob(job);

  const estimateForTariff = (tariff) => {
    if (!tariff) return null;

    const firstMile = Number.parseFloat(tariff.firstMile);
    const subsequentMile = Number.parseFloat(tariff.subsequentMile);

    if (Number.isNaN(firstMile) || Number.isNaN(subsequentMile)) {
      return null;
    }

    if (distanceMiles <= 1) {
      return firstMile;
    }

    const remainingMiles = distanceMiles - 1;
    return firstMile + remainingMiles * subsequentMile;
  };

  return {
    T1: estimateForTariff(tariffs.tariff1),
    T2: estimateForTariff(tariffs.tariff2),
    T3: estimateForTariff(tariffs.tariff3)
  };
};

const formatFareEstimate = (value) =>
  typeof value === 'number' && Number.isFinite(value) ? `£${value.toFixed(2)}` : 'N/A';

const hasFareEstimateValue = (value) => typeof value === 'number' && Number.isFinite(value);

// Helper function to show flash notification for waiting jobs
const showWaitingJobsFlashNotification = (jobCount) => {
  // Create a flash overlay
  const flashOverlay = document.createElement('div');
  flashOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(40, 167, 69, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: flash 0.5s ease-in-out;
  `;
  
  // Add flash animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes flash {
      0%, 100% { opacity: 0; }
      50% { opacity: 1; }
    }
  `;
  document.head.appendChild(style);
  
  // Add text
  const text = document.createElement('div');
  text.textContent = `You have ${jobCount} job${jobCount > 1 ? 's' : ''} waiting for action!`;
  text.style.cssText = `
    color: white;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  `;
  flashOverlay.appendChild(text);
  
  document.body.appendChild(flashOverlay);
  
  // Remove after animation
  setTimeout(() => {
    if (document.body.contains(flashOverlay)) {
      document.body.removeChild(flashOverlay);
    }
    if (document.head.contains(style)) {
      document.head.removeChild(style);
    }
  }, 2000);
};

// Helper function to play notification sound for waiting jobs
const playWaitingJobsSound = async () => {
  try {
    // Use the audio mapping service for MyLink booking notifications
    await audioNotificationService.playNewJobAudio('mylink');
  } catch (error) {
    console.error('Audio notification failed:', error);
  }
};

// Helper function to check for jobs waiting for action
// Only notify for jobs with flashing chevron (requiring action):
// 1. Web-Link jobs (from Fare Calculator) that are still pending review
// Note: MyLink booking link jobs are excluded - they're handled by the popup system
const checkForWaitingJobs = (jobs, incomingHandshakes = []) => {
  const now = new Date();
  const waitingJobs = [];
  
  // Only check jobs that have the flashing chevron header (need action)
  jobs.forEach(job => {
    const jobDate = new Date(job.dateTime);
    const hoursDiff = (jobDate - now) / (1000 * 60 * 60);
    
    // Only include future jobs
    if (hoursDiff <= 0) return;
    
    // Exclude MyLink booking link jobs - they're handled by the popup system
    if (job.bookingLinkId && !job.acceptedAt) {
      // Skip MyLink jobs - popup system handles them
      return;
    }
    
    // Web-Link jobs from Fare Calculator that are still pending review
    const isWebLinkJob = !job.bookingLinkId && !job.createdByDispatcher && !job.isManualDiaryEntry;
    const isPendingWebLink = isWebLinkJob && (!job.status || job.status === 'pending');
    if (isPendingWebLink) {
      waitingJobs.push(job);
      return;
    }
  });
  
  // Add incoming handshakes to waiting jobs (these also need action)
  const totalWaiting = waitingJobs.length + (incomingHandshakes?.length || 0);
  
  return {
    waitingJobs,
    incomingHandshakes: incomingHandshakes || [],
    totalCount: totalWaiting
  };
};

// Helper function to notify about waiting jobs
const notifyAboutWaitingJobs = async (waitingJobsData) => {
  const { waitingJobs, incomingHandshakes, totalCount } = waitingJobsData;
  
  if (totalCount === 0) return;
  
  console.log(`🔔 Found ${totalCount} job(s) waiting for action`);
  
  // Show flash notification
  showWaitingJobsFlashNotification(totalCount);
  
  // Play audio sound
  await playWaitingJobsSound();
  
  // Show toast notification with details
  let message = `📋 You have ${totalCount} job${totalCount > 1 ? 's' : ''} waiting for action!\n\n`;
  
  // Add details about waiting jobs (max 3 to avoid overwhelming)
  const jobsToShow = waitingJobs.slice(0, 3);
  jobsToShow.forEach((job, index) => {
    const timingInfo = job.isASAP ? '⚡ ASAP' : `📅 ${formatWhen(job.dateTime)}`;
    
    // Determine job type label
    let jobType = '';
    // Note: MyLink booking link jobs are excluded from this notification
    if (!job.bookingLinkId && !job.createdByDispatcher && !job.isManualDiaryEntry) {
      jobType = '🔗 Web-Link - ';
    }
    
    message += `${index + 1}. ${jobType}${timingInfo}\n📍 ${job.from} → ${job.to}\n`;
  });
  
  if (waitingJobs.length > 3) {
    message += `\n...and ${waitingJobs.length - 3} more job${waitingJobs.length - 3 > 1 ? 's' : ''}`;
  }
  
  // Add incoming handshakes info
  if (incomingHandshakes.length > 0) {
    message += `\n\n🤝 ${incomingHandshakes.length} incoming handshake offer${incomingHandshakes.length > 1 ? 's' : ''}`;
  }
  
  toast.info(message, {
    autoClose: false,
    closeOnClick: false,
    draggable: false,
    style: {
      background: '#28a745',
      color: 'white',
      fontSize: '16px',
      fontWeight: 'bold',
      whiteSpace: 'pre-line',
      maxWidth: '500px'
    }
  });
};

export default function AcceptedJobs() {
  useLeadNotifications();
  const audioToast = useAudioToast();

  // Load Google Maps API for Journey Estimator
  const { isLoaded: isGoogleMapsLoaded, loadError: googleMapsLoadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES
  });

  // ── Navigation state ─────────────────────────────────
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const navigate = useNavigate();
  const location = useLocation();
  const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);

  const navCollapse = () => {
    document.querySelectorAll('.navbar-collapse.show').forEach(el => el.classList.remove('show'));
    setAdminDropdownOpen(false);
  };

  const toggleAdminDropdown = (e) => {
    e.preventDefault();
    setAdminDropdownOpen(!adminDropdownOpen);
  };

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const handleCloseSlidePanel = useCallback(() => {
    setShowSlidePanel(false);
    setNavigationJob(null);
    setFareEstimates(null);
  }, []);

  // ── State ────────────────────────────────────────────
  const [jobs, setJobs]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg]         = useState('');
  


  // Add-to-Diary
  const [showAdd, setShowAdd]                 = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showPastDateWarning, setShowPastDateWarning] = useState(false);
  const [pendingDateSelection, setPendingDateSelection] = useState(null);
  // Removed advanced search UI in favor of simple filter
  // Simple inline search (like Completed Jobs)
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [isHeaderSticky, setIsHeaderSticky] = useState(false);
  const [showDiaryMonthModal, setShowDiaryMonthModal] = useState(false);
  const [showDiaryYearModal, setShowDiaryYearModal] = useState(false);
  const [showDiaryHourModal, setShowDiaryHourModal] = useState(false);
  const [showDiaryMinuteModal, setShowDiaryMinuteModal] = useState(false);

  const [showEditMonthModal, setShowEditMonthModal] = useState(false);
  const [showEditYearModal, setShowEditYearModal] = useState(false);
  const [showEditHourModal, setShowEditHourModal] = useState(false);
  const [showEditMinuteModal, setShowEditMinuteModal] = useState(false);

  // Slide panel state
  const [showSlidePanel, setShowSlidePanel] = useState(false);
  const [slidePanelType, setSlidePanelType] = useState(null); // 'navigation' or 'taximeter'
  const [navigationDestination, setNavigationDestination] = useState(null); // Job location for navigation
  const [navigationOrigin, setNavigationOrigin] = useState(null); // Origin location for navigation
const [navigationJob, setNavigationJob] = useState(null); // Job currently used for navigation panel
  const [directionsResponse, setDirectionsResponse] = useState(null); // Directions response for map
  const [routePath, setRoutePath] = useState(null); // Store route path for deviation detection
  const [previousLocation, setPreviousLocation] = useState(null); // Track previous location for heading
  const [isNearJunction, setIsNearJunction] = useState(false); // Track if approaching junction
  const [speedLimitWarning, setSpeedLimitWarning] = useState(null); // Speed limit warning message
  const [currentHeading, setCurrentHeading] = useState(null); // Current heading/direction
  const [directionsError, setDirectionsError] = useState(null); // Directions error
  const [junctionPopup, setJunctionPopup] = useState(null); // Junction popup data { visible, step, distance }
  const [destinationDetails, setDestinationDetails] = useState(null); // Destination details when close { visible, address, houseNumber }
  const [directionOfTravel, setDirectionOfTravel] = useState(null); // Direction of travel for route recalculation
  const [currentTime, setCurrentTime] = useState(new Date()); // Current time for clock display
  const [mapInitialized, setMapInitialized] = useState(false); // Flag to prevent initial zoom animation
  const [directionsSteps, setDirectionsSteps] = useState([]); // Directions steps from route
  const [currentStepIndex, setCurrentStepIndex] = useState(0); // Current step index based on driver location
  const [navigationNightMode, setNavigationNightMode] = useState(false); // Night mode for navigation pane
  const [navigationAccordionExpanded, setNavigationAccordionExpanded] = useState(false); // Whether navigation accordion is expanded
  const [originCoords, setOriginCoords] = useState(null); // Geocoded origin coordinates
  const [destinationCoords, setDestinationCoords] = useState(null); // Geocoded destination coordinates
  const [currentLocationCoords, setCurrentLocationCoords] = useState(null); // Current GPS location
  const [travelTimeFromCurrent, setTravelTimeFromCurrent] = useState(null); // Travel time from current location
  const [travelDistanceFromCurrent, setTravelDistanceFromCurrent] = useState(null); // Travel distance from current location
  const [isGettingCurrentLocation, setIsGettingCurrentLocation] = useState(false); // Loading state for getting location
  const [geocodeOriginError, setGeocodeOriginError] = useState(false); // Track if origin geocoding failed
  const [routeTime, setRouteTime] = useState(null); // Travel time for full route (from → to)
  const [routeDistance, setRouteDistance] = useState(null); // Travel distance for full route (from → to)
  const [etaFromCurrent, setEtaFromCurrent] = useState(null); // ETA when clicking "From"
  const [etaFromTo, setEtaFromTo] = useState(null); // ETA when clicking "To" (full route)
  const [timeToFrom, setTimeToFrom] = useState(null); // Time to get to "From" address when clicking "To"
  const [fareEstimates, setFareEstimates] = useState(null); // Fare estimates for T1/T2/T3 in navigation panel

  // Location tracking state
  const [locationTracking, setLocationTracking] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  // Helper function to validate and create safe dates
  const createSafeDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate.getTime())) {
      throw new Error('Invalid date value');
    }
    return newDate;
  };


  const [showDailyTotalsModal, setShowDailyTotalsModal] = useState(false);
  const [dailyTotals, setDailyTotals] = useState({});
  const [selectedWeekOffset, setSelectedWeekOffset] = useState(0); // 0 = current week, -1 = previous week, etc.
  
  // Drill-down functionality state
  const [drillDownData, setDrillDownData] = useState(null);
  const [showDrillDown, setShowDrillDown] = useState(false);
  const [drillDownLoading, setDrillDownLoading] = useState(false);
  const [diaryData, setDiaryData] = useState({
    customer: '',
    phone: '',
    phone2: '',
    pickup: '',
    destination: '',
    notes: '',
    price: '',
    date: '',
    time: '',
    email: 'NoReply@taxi-local.com',
    passengers: 1,
    groupId: null,
    bookingLinkId: null
  });
  const [showPhone2, setShowPhone2] = useState(false);
  const [isPhoneAutoDetected, setIsPhoneAutoDetected] = useState(false);

  const [diaryLoading, setDiaryLoading]         = useState(false);
  
  // Journey Estimator state
  const [showJourneyEstimator, setShowJourneyEstimator] = useState(false);
  const [estimatorFrom, setEstimatorFrom] = useState('');
  const [estimatorTo, setEstimatorTo] = useState('');
  const [estimatorDistance, setEstimatorDistance] = useState(0);
  const [estimatorDuration, setEstimatorDuration] = useState(0);
  const [estimatorFares, setEstimatorFares] = useState({});
  const [estimatorCalculating, setEstimatorCalculating] = useState(false);
  const [estimatorCalculated, setEstimatorCalculated] = useState(false);
  const [driverLicensingAuthority, setDriverLicensingAuthority] = useState('');
  
  // Journey Estimator refs for autocomplete
  const estimatorFromRef = useRef(null);
  const estimatorToRef = useRef(null);
  const fromAutocompleteRef = useRef(null);
  const toAutocompleteRef = useRef(null);
  
  // Customer search functionality
  const [searchResults, setSearchResults]       = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchLoading, setSearchLoading]       = useState(false);
  const [isContactAutoPopulated, setIsContactAutoPopulated] = useState(false);
  const searchTimeoutRef = useRef(null);

  // Edit
  const [editLead, setEditLead]               = useState(null);
  const [form, setForm]                       = useState({});

  const [saving, setSaving]                   = useState(false);

  // Return
  // Return flow now reuses Add Job form; legacy return state removed

  // Confirm (cancel/release/complete)
  const [confirmAction, setConfirmAction]     = useState(null);
  const jobBeingConfirmed = useMemo(() => {
    if (!confirmAction) return null;
    return jobs.find(j => j._id === confirmAction.id) || null;
  }, [confirmAction, jobs]);
  const [reassignAction, setReassignAction]   = useState(null);
  const [cancellationReason, setCancellationReason] = useState('');
  const [availableDrivers, setAvailableDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  
  // Job Cancellation Modal state
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const [jobToCancel, setJobToCancel] = useState(null);
  
  // Customer Review Modal state
  const [showCustomerReviewModal, setShowCustomerReviewModal] = useState(false);
  const [customerReviewData, setCustomerReviewData] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  
  // New state for enhanced reassignment features
  const [favouriteDrivers, setFavouriteDrivers] = useState([]);
  const [handshakeJobs, setHandshakeJobs] = useState([]);
  const [handshakeAction, setHandshakeAction] = useState(null);
  const [selectedHandshakeDriver, setSelectedHandshakeDriver] = useState('');
  const [reassigningJobs, setReassigningJobs] = useState(new Set());
  const [reassigningTargetDrivers, setReassigningTargetDrivers] = useState(new Map()); // Store target driver info for reassigned jobs
  const [sendingEmails, setSendingEmails] = useState(new Set());
  
  // Review & Blacklist state (in Confirm modal)
  const [starRating, setStarRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [blacklistReason, setBlacklistReason] = useState('');
  const [completionReason, setCompletionReason] = useState('');
  
  // Blacklist warning when adding job
  const [showBlacklistWarning, setShowBlacklistWarning] = useState(false);
  const [blacklistWarningData, setBlacklistWarningData] = useState(null);
  // Duplicate modal
  const [duplicateAction, setDuplicateAction] = useState(null); // { job, dateTime, from, to }
  // Incoming handshake offers (jobs sent TO me)
  const [incomingHandshakes, setIncomingHandshakes] = useState([]);

  // Diary-viewer
  const [showDiaryModal, setShowDiaryModal]   = useState(false);
  // Used to force remount of accordions so they return to collapsed state
  const [accordionResetKey, setAccordionResetKey] = useState(0);
  
  // Track initial load to show notifications only once
  const [isInitialLoad, setIsInitialLoad] = useState(true);



  // Helper: send receipt with small retries to avoid race with completion write
  const sendReceiptWithRetry = async (jobId, amountNumber, email, maxAttempts = 3) => {
    let attempt = 0;
    // brief jittered delays: 150ms, 300ms
    const delay = (ms) => new Promise(r => setTimeout(r, ms));
    while (attempt < maxAttempts) {
      try {
        await axios.post('/view-leads/receipt', {
          jobId,
          amount: amountNumber,
          customerEmail: email,
          type: 'receipt'
        });
        return; // success
      } catch (err) {
        // if 404, likely not yet visible as completed; wait and retry
        if (err?.response?.status === 404 && attempt < maxAttempts - 1) {
          await delay(150 * (attempt + 1));
          attempt += 1;
          continue;
        }
        throw err;
      }
    }
  };

  // Load incoming handshakes from server and store
  const loadIncomingHandshakes = async () => {
    try {
      const { data } = await axios.get('/view-leads/incoming-handshakes');
      setIncomingHandshakes(Array.isArray(data) ? data : []);
      if (Array.isArray(data) && data.length > 0) {
        toast.info(`You have ${data.length} incoming handshake offer(s)!`);
      }
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.error('Failed to load incoming handshakes:', err);
      return [];
    }
  };

  // REMOVED: Driver location tracking when navigation opens
  // This was causing expensive Google API calls
  // Only initial address lookup and route planning are now allowed
  useEffect(() => {
    if (slidePanelType !== 'navigation') {
      setCurrentLocationCoords(null);
      setTravelTimeFromCurrent(null);
      setTravelDistanceFromCurrent(null);
      setIsGettingCurrentLocation(false);
    }
  }, [slidePanelType]);

  // Geocode addresses and calculate directions when origin and destination are set
  useEffect(() => {
    if (slidePanelType === 'navigation' && navigationDestination && isGoogleMapsLoaded && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      
      // Geocode destination
      geocoder.geocode({ address: navigationDestination }, (results, status) => {
        if (status === 'OK' && results[0]) {
          setDestinationCoords({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          });
        } else {
          setDestinationCoords(null);
          console.warn('Failed to geocode destination:', navigationDestination, status);
        }
      });
      
      // Geocode origin if provided
      if (navigationOrigin) {
        geocoder.geocode({ address: navigationOrigin }, (results, status) => {
          if (status === 'OK' && results[0]) {
            setOriginCoords({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            });
            
            // REMOVED: Calculation of time from current location to "From" address
            // This required driver location tracking which has been removed to reduce Google API costs
            setTimeToFrom(null);
            
            // Calculate directions when both are geocoded
            const svc = new window.google.maps.DirectionsService();
            svc.route(
              {
                origin: navigationOrigin,
                destination: navigationDestination,
                travelMode: window.google.maps.TravelMode.DRIVING
              },
              (resp, routeStatus) => {
                if (routeStatus === 'OK') {
                  setDirectionsResponse(resp);
                  setDirectionsError(null);
                  // Extract time and distance from the route
                  if (resp.routes && resp.routes[0] && resp.routes[0].legs && resp.routes[0].legs[0]) {
                    const leg = resp.routes[0].legs[0];
                    const durationMinutes = Math.round(leg.duration.value / 60);
                    const distanceMiles = (leg.distance.value / 1609.34).toFixed(2);
                    const numericDistance = parseFloat(distanceMiles);
                    setRouteTime(durationMinutes);
                    setRouteDistance(numericDistance);
                    setFareEstimates(calculateTariffEstimates(numericDistance, navigationJob));
                    
                    // Extract route path for deviation detection
                    if (resp.routes && resp.routes[0] && resp.routes[0].overview_polyline && window.google && window.google.maps && window.google.maps.geometry && window.google.maps.geometry.encoding) {
                      const encodedPath = resp.routes[0].overview_polyline.points;
                      const path = window.google.maps.geometry.encoding.decodePath(encodedPath);
                      setRoutePath(path);
                    }
                    
                    // Extract directions steps
                    const steps = extractDirectionsSteps(resp);
                    setDirectionsSteps(steps);
                    // Calculate current step immediately if we have driver location
                    if (currentLocationCoords && steps.length > 0) {
                      const currentStep = getCurrentStepIndex(currentLocationCoords, steps);
                      setCurrentStepIndex(currentStep);
                    } else {
                      // Default to first step if no location yet
                      setCurrentStepIndex(0);
                    }
                  } else {
                    setRouteTime(null);
                    setRouteDistance(null);
                    setEtaFromTo(null);
                    setFareEstimates(null);
                    setDirectionsSteps([]);
                    setCurrentStepIndex(0);
                  }
                } else {
                  setDirectionsError(routeStatus);
                  setDirectionsResponse(null);
                  setRouteTime(null);
                  setRouteDistance(null);
                  setEtaFromTo(null);
                  setFareEstimates(null);
                  setDirectionsSteps([]);
                  setCurrentStepIndex(0);
                  console.warn('Failed to calculate route:', routeStatus);
                }
              }
            );
          } else {
            setOriginCoords(null);
            setDirectionsResponse(null);
            setRouteTime(null);
            setRouteDistance(null);
            setTimeToFrom(null);
            setDirectionsSteps([]);
            setCurrentStepIndex(0);
            // Set error flag to show hint message
            if (status === 'ZERO_RESULTS' || status === 'INVALID_REQUEST') {
              setGeocodeOriginError(true);
            } else {
              setGeocodeOriginError(false);
            }
            console.warn('Failed to geocode origin:', navigationOrigin, status);
          }
        });
      } else {
        setOriginCoords(null);
        setDirectionsResponse(null);
        setDirectionsError(null);
        setRouteTime(null);
        setRouteDistance(null);
        setEtaFromTo(null);
        setTimeToFrom(null);
        setGeocodeOriginError(false);
        setDirectionsSteps([]);
        setCurrentStepIndex(0);
      }
    } else if (slidePanelType !== 'navigation') {
      // Clear everything when not in navigation mode
      setDirectionsResponse(null);
      setDirectionsError(null);
      setOriginCoords(null);
      setDestinationCoords(null);
      setCurrentLocationCoords(null);
      setTravelTimeFromCurrent(null);
      setTravelDistanceFromCurrent(null);
      setRouteTime(null);
      setRouteDistance(null);
      setEtaFromCurrent(null);
      setEtaFromTo(null);
      setTimeToFrom(null);
      setFareEstimates(null);
      setNavigationJob(null);
      setDirectionsSteps([]);
      setCurrentStepIndex(0);
    }
  }, [slidePanelType, navigationOrigin, navigationDestination, isGoogleMapsLoaded, navigationJob]);

  // Update ETA for "To" screen when timeToFrom or routeTime changes
  useEffect(() => {
    if (navigationOrigin && routeTime !== null) {
      const now = new Date();
      const timeToFromMinutes = timeToFrom || 0;
      const totalMinutes = timeToFromMinutes + routeTime;
      const eta = new Date(now.getTime() + totalMinutes * 60 * 1000);
      setEtaFromTo(eta);
    }
  }, [timeToFrom, routeTime, navigationOrigin]);

  // Helper function to calculate distance between two coordinates in miles (Haversine formula)
  const calculateDistance = useCallback((lat1, lng1, lat2, lng2) => {
    const R = 3959; // Earth's radius in miles
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }, []);

  // Google Maps night mode styles
  const googleMapsNightModeStyles = [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }]
    },
    // Hide POIs in night mode
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.business',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.attraction',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.place_of_worship',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.school',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.sports_complex',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.park',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.government',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.medical',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    // Show road labels (includes house numbers)
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'on' }]
    }
  ];

  // Helper function to extract directions steps from directions response
  const extractDirectionsSteps = useCallback((directionsResponse) => {
    if (!directionsResponse || !directionsResponse.routes || !directionsResponse.routes[0]) {
      return [];
    }
    
    const route = directionsResponse.routes[0];
    const steps = [];
    
    route.legs.forEach((leg) => {
      if (leg.steps && leg.steps.length > 0) {
        leg.steps.forEach((step, index) => {
          steps.push({
            index: steps.length,
            instruction: step.instructions,
            distance: step.distance?.text || '',
            duration: step.duration?.text || '',
            startLocation: step.start_location,
            endLocation: step.end_location,
            maneuver: step.maneuver || 'straight'
          });
        });
      }
    });
    
    return steps;
  }, []);

  // Helper function to determine current step based on driver location
  const getCurrentStepIndex = useCallback((driverCoords, steps) => {
    if (!driverCoords || !steps || steps.length === 0 || !window.google || !window.google.maps || !window.google.maps.geometry) {
      return 0;
    }

    const driverLatLng = new window.google.maps.LatLng(driverCoords.lat, driverCoords.lng);
    let currentStepIndex = 0;
    let minDistanceToStep = Infinity;

    // Find the step the driver is currently on or approaching
    // Check distance to both start and end of each step
    steps.forEach((step, index) => {
      let stepDistance = Infinity;
      
      // Calculate distance to step's start location
      if (step.startLocation) {
        const distanceToStart = window.google.maps.geometry.spherical.computeDistanceBetween(
          driverLatLng,
          step.startLocation
        );
        stepDistance = Math.min(stepDistance, distanceToStart);
      }
      
      // Calculate distance to step's end location
      if (step.endLocation) {
        const distanceToEnd = window.google.maps.geometry.spherical.computeDistanceBetween(
          driverLatLng,
          step.endLocation
        );
        stepDistance = Math.min(stepDistance, distanceToEnd);
      }
      
      // If this step is closer than the current best, and we haven't passed it yet
      if (stepDistance < minDistanceToStep) {
        // Check if we're very close to the end of this step (within 30m)
        // If so, move to the next step if available
        if (step.endLocation) {
          const distanceToEnd = window.google.maps.geometry.spherical.computeDistanceBetween(
            driverLatLng,
            step.endLocation
          );
          
          // If we're within 30m of the end and there's a next step, use the next step
          if (distanceToEnd < 30 && index < steps.length - 1) {
            // Check if next step's start is closer
            const nextStep = steps[index + 1];
            if (nextStep && nextStep.startLocation) {
              const distanceToNextStart = window.google.maps.geometry.spherical.computeDistanceBetween(
                driverLatLng,
                nextStep.startLocation
              );
              if (distanceToNextStart < distanceToEnd) {
                currentStepIndex = index + 1;
                minDistanceToStep = distanceToNextStart;
                return;
              }
            }
          }
        }
        
        // Otherwise, use this step
        currentStepIndex = index;
        minDistanceToStep = stepDistance;
      }
    });

    return currentStepIndex;
  }, []);

  // Ref to store map instance for zoom control
  const mapRef = useRef(null);
  const userHasZoomed = useRef(false); // Track if user has manually zoomed/zoomed the map
  const lastDriverLocationForBounds = useRef(null); // Track last driver location used for bounds update
  const geocodingDoneForJob = useRef(null); // Track if geocoding has been done for current job to prevent repeated calls

  // REMOVED: updateLocationAndRecalculate function
  // This function was causing expensive Google API calls by updating driver location and recalculating routes
  // Only initial address lookup and route planning are now allowed

  // Update map bounds when coordinates change during navigation (with 3% padding on left/right)
  // REMOVED: Driver location tracking - only update based on origin/destination changes
  useEffect(() => {
    if (slidePanelType === 'navigation' && showSlidePanel && mapRef.current && !isNearJunction && !userHasZoomed.current) {
      // Only update if origin or destination coordinates changed (not driver location)
      const originOrDestinationChanged = 
        (originCoords && (!lastDriverLocationForBounds.current || 
          originCoords.lat !== lastDriverLocationForBounds.current.originLat ||
          originCoords.lng !== lastDriverLocationForBounds.current.originLng)) ||
        (destinationCoords && (!lastDriverLocationForBounds.current || 
          destinationCoords.lat !== lastDriverLocationForBounds.current.destLat ||
          destinationCoords.lng !== lastDriverLocationForBounds.current.destLng));
      
      // For "To" link: if we have both origin and destination, always show them (priority case)
      const hasBothOriginAndDestination = originCoords && destinationCoords;
      
      if (originOrDestinationChanged || !lastDriverLocationForBounds.current || hasBothOriginAndDestination) {
        // Update coordinates (but not driver location)
        if (lastDriverLocationForBounds.current) {
          lastDriverLocationForBounds.current = {
            ...lastDriverLocationForBounds.current,
            originLat: originCoords?.lat,
            originLng: originCoords?.lng,
            destLat: destinationCoords?.lat,
            destLng: destinationCoords?.lng
          };
        } else {
          lastDriverLocationForBounds.current = {
            originLat: originCoords?.lat,
            originLng: originCoords?.lng,
            destLat: destinationCoords?.lat,
            destLng: destinationCoords?.lng
          };
        }
        
        // Priority: If we have A to B (origin to destination), show both with 3% padding on left/right
        // This handles the "To" link case
        if (originCoords && destinationCoords) {
          const bounds = new window.google.maps.LatLngBounds();
          bounds.extend(new window.google.maps.LatLng(originCoords.lat, originCoords.lng));
          bounds.extend(new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng));
          mapRef.current.fitBounds(bounds, { 
            left: window.innerWidth * 0.03,
            right: window.innerWidth * 0.03,
            top: 0,
            bottom: 0
          });
        }
        // If we have a route, use route bounds with 3% padding on left/right
        else if (directionsResponse && directionsResponse.routes && directionsResponse.routes[0]) {
          const bounds = directionsResponse.routes[0].bounds;
          if (bounds) {
            mapRef.current.fitBounds(bounds, { 
              left: window.innerWidth * 0.03,
              right: window.innerWidth * 0.03,
              top: 0,
              bottom: 0
            });
          }
        }
        // If we have only destination, show it centered
        else if (destinationCoords) {
          mapRef.current.setCenter(new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng));
          mapRef.current.setZoom(15);
        }
      }
    } else if (slidePanelType !== 'navigation') {
      // Reset flags when navigation closes
      setMapInitialized(false);
      userHasZoomed.current = false;
      lastDriverLocationForBounds.current = null;
      setDirectionsSteps([]);
      setCurrentStepIndex(0);
    }
  }, [originCoords, destinationCoords, directionsResponse, slidePanelType, showSlidePanel, isNearJunction, mapInitialized]);

  // Reset location tracking when navigation opens to ensure bounds are set immediately
  useEffect(() => {
    if (slidePanelType === 'navigation' && showSlidePanel) {
      // Reset location tracking when navigation opens so bounds update immediately
      lastDriverLocationForBounds.current = null;
      userHasZoomed.current = false;
      // Keep night mode state when navigation reopens (don't reset it)
    } else if (slidePanelType !== 'navigation') {
      // Reset night mode when navigation closes
      setNavigationNightMode(false);
    }
  }, [slidePanelType, showSlidePanel]);

  // Update Google Map styles when night mode changes
  useEffect(() => {
    if (mapRef.current && slidePanelType === 'navigation' && showSlidePanel) {
      const map = mapRef.current;
      map.setOptions({
        styles: navigationNightMode ? googleMapsNightModeStyles : [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.business',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.attraction',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.place_of_worship',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.school',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.sports_complex',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.park',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.government',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi.medical',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'transit',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [{ visibility: 'on' }]
          }
        ]
      });
    }
  }, [navigationNightMode, slidePanelType, showSlidePanel]);

  // REMOVED: Periodic location updates and route recalculation
  // This was causing expensive Google API calls by updating driver location and recalculating routes
  // Only initial address lookup and route planning are now allowed

  // Swipe gesture handler - only responds to single finger touches
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  
  const minSwipeDistance = 50;
  
  const onTouchStart = (e) => {
    // Only process single-finger touches (allow two-finger gestures for map interaction)
    if (e.touches.length !== 1) {
      setTouchStart(null);
      setTouchEnd(null);
      return;
    }
    setTouchEnd(null);
    setTouchStart(e.touches[0].clientX);
  };
  
  const onTouchMove = (e) => {
    // Only process single-finger touches
    if (e.touches.length !== 1) {
      setTouchEnd(null);
      return;
    }
    setTouchEnd(e.touches[0].clientX);
  };
  
  const onTouchEnd = (e) => {
    // Only process single-finger touches
    if (e && e.changedTouches && e.changedTouches.length !== 1) {
      setTouchStart(null);
      setTouchEnd(null);
      return;
    }
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    if (isLeftSwipe && showSlidePanel) {
      handleCloseSlidePanel();
    }
  };

  const showJobTimestamps = (job) => {
    const timestamps = [
      `📅 Job Date/Time: ${formatTimestamp(job.dateTime)}`,
      `📝 Created: ${formatTimestamp(job.dateSubmitted)}`,
      job.updatedAt ? `✏️ Last Modified: ${formatTimestamp(job.updatedAt)}` : null,
      job.acceptedAt ? `✅ Accepted: ${formatTimestamp(job.acceptedAt)}` : null,
      job.reassignedAt ? `🔄 Reassigned: ${formatTimestamp(job.reassignedAt)}` : null,
      job.completedAt ? `🏁 Completed: ${formatTimestamp(job.completedAt)}` : null
    ].filter(Boolean);

    const timestampText = timestamps.join('\n');
    toast.info(timestampText, {
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      style: { whiteSpace: 'pre-line' }
    });
  };

  // Location tracking functions
  const startLocationTracking = async () => {
    try {
      if (locationTracking) {
        console.log('Location tracking already active');
        return;
      }

      console.log('📍 Starting location tracking for My Diary...');
      setLocationError(null);

      await locationService.startTracking({
        interval: 30000, // 30 seconds
        highAccuracy: true,
        timeout: 10000
      });

      setLocationTracking(true);
      localStorage.setItem('locationTrackingActive', 'true');
      
      // Update working status to true (Running Man = Working)
      try {
        await axios.post('/user/working-status', { isWorking: true });
      } catch (error) {
        console.error('Error updating working status:', error);
      }
      
      // Play specialized Stop/Go audio for Running Man (no duplicate toast audio)
      await audioToast.audioService.playStopGoAudio(true);
      
      // Show success toast (no audio)
      toast.success('Welcome you are now Online and Working');
      
      console.log('✅ Location tracking started for My Diary');
    } catch (error) {
      console.error('Error starting location tracking:', error);
      setLocationError(error.message);
    }
  };

  const stopLocationTracking = async () => {
    if (!locationTracking) {
      console.log('Location tracking is not active');
      return;
    }

    console.log('📍 Stopping location tracking for My Diary...');
    locationService.stopTracking();
    setLocationTracking(false);
    localStorage.setItem('locationTrackingActive', 'false');
    
    // Update working status to false (Standing Man = Not Working)
    try {
      await axios.post('/user/working-status', { isWorking: false });
    } catch (error) {
      console.error('Error updating working status:', error);
    }
    
    // Play specialized Stop/Go audio for Standing Man (no duplicate toast audio)
    await audioToast.audioService.playStopGoAudio(false);
    
    // Show warning toast (no audio)
    toast.warning('Goodbye you are now Offline');
    
    setCurrentLocation(null);
    setLocationError(null);
  };

  const getCurrentLocation = async () => {
    try {
      const location = await locationService.getCurrentLocation({
        highAccuracy: true,
        timeout: 10000
      });
      
      setCurrentLocation(location);
      setLocationError(null);
      
      // Send location to server
      await locationService.sendLocationToServer(location);
      
      console.log('📍 Location updated for My Diary:', location);
    } catch (error) {
      console.error('Error getting current location:', error);
      setLocationError(error.message);
      
      // Show user-friendly toast notification
      if (error.message.includes('denied')) {
        toast.warning('Location access denied. Please enable location permissions in your browser settings to track your location.');
      } else if (error.message.includes('unavailable')) {
        toast.warning('Location unavailable. Please check your GPS/network connection.');
      } else if (error.message.includes('timeout')) {
        toast.warning('Location request timed out. Please try again.');
      } else if (error.message.includes('not supported')) {
        toast.error('Location services not supported. Please use a modern browser.');
      } else {
        toast.error(`Location error: ${error.message}`);
      }
    }
  };

  // Helper function to update location after diary operations
  const updateLocationAfterDiaryOperation = async () => {
    if (locationTracking) {
      try {
        await getCurrentLocation();
        console.log('📍 Location updated after diary operation');
      } catch (error) {
        console.error('Error updating location after diary operation:', error);
      }
    }
  };

  // Centralized load/refresh for accepted jobs
  const refreshDiary = async () => {
    try {
      setLoading(true);
      const me = localStorage.getItem('userId');
      const { data } = await axios.get('/view-leads');
      
      // Debug: Check if declined reassigned jobs are in the API response
      const declinedJobs = data.filter(l => l.status === 'accepted' && l.cancellationReason === 'Declined by driver from reassignment');
      console.log('🔍 DECLINED REASSIGNED JOBS IN API:', declinedJobs.length);
      declinedJobs.forEach(job => {
        console.log('  - Job:', job._id, 'Customer:', job.customerName, 'AcceptedBy:', job.acceptedBy?._id);
      });
      
      const acceptedJobs = data
        .filter(l => {
          // Use a single return statement to prevent multiple matches
          return (
            // Show jobs accepted by current user (main condition)
            (l.status === 'accepted' && l.acceptedBy?._id === me) ||
            // Show pending re-assigned jobs that were originally accepted by current user
            (l.status === 'pending' && l.reassignedBy?._id === me) ||
            // Show jobs that were re-assigned FROM current user (until accepted by new driver)
            (l.status === 'accepted' && l.acceptedBy?._id !== me && l.reassignedBy?._id === me && !l.acceptedAt) ||
            // Show pending WebLink jobs assigned to current user (webLinksToDiary preference)
            (l.status === 'pending' && l.webLinkAssignedToDrivers && l.webLinkAssignedToDrivers.some(driverId => driverId === me || driverId._id === me))
          );
        })
        .sort((a,b)=> {
          try {
            const dateA = createSafeDate(a.dateTime);
            const dateB = createSafeDate(b.dateTime);
            return dateA - dateB;
          } catch (error) {
            console.warn('Error sorting jobs by date:', error);
            return 0;
          }
        });
      
      // Remove any potential duplicates by ID (safety measure)
      const uniqueJobs = acceptedJobs.reduce((acc, current) => {
        const exists = acc.find(job => job._id.toString() === current._id.toString());
        if (!exists) {
          acc.push(current);
        }
        return acc;
      }, []);
      
      // Debug: Check for duplicate jobs after filtering and deduplication
      const jobIds = uniqueJobs.map(j => j._id.toString());
      const uniqueJobIds = [...new Set(jobIds)];
      if (jobIds.length !== uniqueJobIds.length) {
        console.log('⚠️ FRONTEND DUPLICATE JOBS DETECTED AFTER DEDUPLICATION!');
        console.log('Total filtered jobs:', jobIds.length, 'Unique IDs:', uniqueJobIds.length);
      }
      
      if (acceptedJobs.length !== uniqueJobs.length) {
        console.log(`🔧 Removed ${acceptedJobs.length - uniqueJobs.length} duplicate jobs during filtering`);
      }
      
      // Additional debugging - show first few jobs with their dates
      console.log('📅 First 5 jobs in My Diary:');
      uniqueJobs.slice(0, 5).forEach((job, index) => {
        console.log(`${index + 1}. ${job.customerName} - ${job.dateTime} (ID: ${job._id})`);
      });
      
      // Check for any jobs with same customer and date
      const customerDateGroups = uniqueJobs.reduce((acc, job) => {
        const key = `${job.customerName}-${job.dateTime}`;
        if (!acc[key]) acc[key] = [];
        acc[key].push(job);
        return acc;
      }, {});
      
      Object.entries(customerDateGroups).forEach(([key, jobs]) => {
        if (jobs.length > 1) {
          console.log(`⚠️ Found ${jobs.length} jobs with same customer and date: ${key}`);
          jobs.forEach((job, index) => {
            console.log(`  ${index + 1}. ID: ${job._id}, Status: ${job.status}, AcceptedBy: ${job.acceptedBy?._id}`);
          });
        }
      });
      

      
      setJobs(uniqueJobs);
      // Initialize filtered view
      setFilteredJobs(uniqueJobs);

      // Load handshake jobs - only jobs where current user is the receiver (toDriver)
      const nextHandshakeJobs = uniqueJobs
        .filter(job => job.handshake && job.handshake.status === 'pending' && job.handshake.toDriver === me)
        .map(job => ({
          jobId: job._id,
          fromDriverId: job.handshake.fromDriver,
          status: job.handshake.status
        }));
      setHandshakeJobs(nextHandshakeJobs);

      // Load incoming handshake offers (jobs sent TO me)
      const loadedIncomingHandshakes = await loadIncomingHandshakes();

      // Check for jobs waiting for action and notify on initial load
      if (isInitialLoad && uniqueJobs.length > 0) {
        const waitingJobsData = checkForWaitingJobs(uniqueJobs, loadedIncomingHandshakes);
        if (waitingJobsData.totalCount > 0) {
          // Small delay to ensure the page is loaded before showing notifications
          setTimeout(() => {
            notifyAboutWaitingJobs(waitingJobsData);
          }, 1000);
        }
        setIsInitialLoad(false);
      }

      // Force accordions to remount so they start collapsed
      setAccordionResetKey(prev => prev + 1);
      
      // Check for MyLink jobs that need action and notify the popup system
      const myLinkJobs = uniqueJobs.filter(job => 
        job.bookingLinkId && !job.acceptedAt
      );
      
      if (myLinkJobs.length > 0) {
        console.log(`📋 Found ${myLinkJobs.length} MyLink job(s) in diary that need action`);
        // Dispatch event with the jobs so the popup system can show them
        window.dispatchEvent(new CustomEvent('mylink-jobs-in-diary', {
          detail: { jobs: myLinkJobs }
        }));
      }
      
      // Return the loaded data so it can be used by the header click handler
      return { uniqueJobs, loadedIncomingHandshakes };
    } catch (e) {
      console.error('=== REFRESH DIARY ERROR ===');
      console.error('Error details:', e);
      console.error('Error message:', e.message);
      console.error('Error response:', e.response?.data);
      setMsg('Failed to load diary.');
      setJobs([]);
      setFilteredJobs([]);
      return { uniqueJobs: [], loadedIncomingHandshakes: [] };
    } finally {
      setLoading(false);
      // Update location after diary operation if tracking is active
      updateLocationAfterDiaryOperation();
    }
  };

  // Initial load
  useEffect(() => {
    refreshDiary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch driver's licensing authority for Journey Estimator and car seats for capacity checks
  useEffect(() => {
    const fetchDriverProfile = async () => {
      try {
        const response = await axios.get('/user-profile/profile', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setDriverLicensingAuthority(response.data.licensingAuthority || 'Default');
        
        // Store car seats in localStorage for passenger capacity checks
        if (response.data.carSeats) {
          localStorage.setItem('userCarSeats', response.data.carSeats);
        }
      } catch (error) {
        console.error('Error fetching driver profile:', error);
        setDriverLicensingAuthority('Default');
      }
    };
    fetchDriverProfile();
  }, [token]);

  // URL Parameter Detection for Phone Number Auto-Population
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const phoneParam = params.get('phone');
    
    if (phoneParam) {
      console.log('📱 Phone number detected from URL:', phoneParam);
      
      // Auto-populate the phone field
      setDiaryData(prev => ({
        ...prev,
        phone: phoneParam
      }));
      
      // Set auto-detection flag
      setIsPhoneAutoDetected(true);
      
      // Automatically open the "Add Job" modal
      setShowAdd(true);
      
      // Auto-search for existing customers with this phone number
      const searchCustomerByPhone = async () => {
        try {
          setSearchLoading(true);
          const response = await axios.get('/leads/search', {
            params: { query: phoneParam },
            headers: { Authorization: `Bearer ${token}` }
          });
          
          if (response.data && response.data.length > 0) {
            console.log('✅ Found existing customer(s) with phone:', phoneParam);
            setSearchResults(response.data);
            setShowSearchResults(true);
            
            // Show toast notification
            toast.info(`Found ${response.data.length} existing customer${response.data.length > 1 ? 's' : ''} with this number`, {
              position: 'top-center',
              autoClose: 3000
            });
          } else {
            console.log('ℹ️ No existing customers found with phone:', phoneParam);
            toast.info('New customer - no existing records found', {
              position: 'top-center',
              autoClose: 2000
            });
          }
        } catch (error) {
          console.error('Error searching for customer by phone:', error);
        } finally {
          setSearchLoading(false);
        }
      };
      
      searchCustomerByPhone();
      
      // Clean up URL parameter after processing (optional - keeps URL clean)
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search, token]);

  // Initialize Google Places Autocomplete when Journey Estimator opens
  useEffect(() => {
    if (!showJourneyEstimator) {
      // Cleanup when modal closes
      if (fromAutocompleteRef.current) {
        window.google?.maps?.event?.clearInstanceListeners?.(fromAutocompleteRef.current);
        fromAutocompleteRef.current = null;
      }
      if (toAutocompleteRef.current) {
        window.google?.maps?.event?.clearInstanceListeners?.(toAutocompleteRef.current);
        toAutocompleteRef.current = null;
      }
      return;
    }

    if (isGoogleMapsLoaded && !googleMapsLoadError) {
      const initializeAutocomplete = () => {
        try {
          console.log('Initializing autocomplete...', {
            showJourneyEstimator,
            isGoogleMapsLoaded,
            googleMapsLoadError,
            fromRef: !!estimatorFromRef.current,
            toRef: !!estimatorToRef.current
          });

          // Initialize From field autocomplete
          if (estimatorFromRef.current && !fromAutocompleteRef.current) {
            console.log('Creating From autocomplete...');
            fromAutocompleteRef.current = new window.google.maps.places.Autocomplete(
              estimatorFromRef.current,
              { 
                componentRestrictions: { country: 'uk' },
                fields: ['formatted_address', 'geometry', 'name'],
                types: ['address']
              }
            );
            
            fromAutocompleteRef.current.addListener('place_changed', () => {
              const place = fromAutocompleteRef.current.getPlace();
              console.log('From place changed:', place);
              if (place && place.formatted_address) {
                const cleanedAddress = cleanGoogleMapsAddress(place.formatted_address);
                setEstimatorFrom(cleanedAddress);
              }
            });
            console.log('From autocomplete created successfully');
          }
          
          // Initialize To field autocomplete
          if (estimatorToRef.current && !toAutocompleteRef.current) {
            console.log('Creating To autocomplete...');
            toAutocompleteRef.current = new window.google.maps.places.Autocomplete(
              estimatorToRef.current,
              { 
                componentRestrictions: { country: 'uk' },
                fields: ['formatted_address', 'geometry', 'name'],
                types: ['address']
              }
            );
            
            toAutocompleteRef.current.addListener('place_changed', () => {
              const place = toAutocompleteRef.current.getPlace();
              console.log('To place changed:', place);
              if (place && place.formatted_address) {
                const cleanedAddress = cleanGoogleMapsAddress(place.formatted_address);
                setEstimatorTo(cleanedAddress);
              }
            });
            console.log('To autocomplete created successfully');
          }
        } catch (error) {
          console.error('Error initializing autocomplete:', error);
        }
      };

      // Multiple attempts with increasing delays to ensure modal is ready
      const timer1 = setTimeout(initializeAutocomplete, 100);
      const timer2 = setTimeout(initializeAutocomplete, 300);
      const timer3 = setTimeout(initializeAutocomplete, 500);
      
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
      };
    }
  }, [showJourneyEstimator, isGoogleMapsLoaded, googleMapsLoadError]);

  // Location tracking is now optional and user-initiated
  // Removed auto-start to avoid geolocation violations
  useEffect(() => {
    // Check if location tracking was previously active and restore state
    const wasTracking = localStorage.getItem('locationTrackingActive');
    if (wasTracking === 'true') {
      setLocationTracking(true);
      // Note: We don't auto-start tracking here to avoid geolocation violations
      // User will need to click the button to actually start tracking
    }
    
    // Cleanup: stop location tracking when component unmounts
    return () => {
      stopLocationTracking();
    };
  }, []); // Empty dependency array means this runs once on mount and cleanup on unmount

  // Listen for diary refresh events
  useEffect(() => {
    const handleRefreshDiaryData = async (event) => {
      console.log('🔄 Refreshing diary data due to diary entry:', event.detail);
      
      try {
        await refreshDiary();
        console.log('✅ Diary data refreshed successfully');
      } catch (error) {
        console.error('Failed to refresh diary data:', error);
        setMsg('Failed to refresh diary data');
      }
    };

    // Add event listener
    window.addEventListener('refreshDiaryData', handleRefreshDiaryData);
    
    // Cleanup
    return () => {
      window.removeEventListener('refreshDiaryData', handleRefreshDiaryData);
    };
  }, []);

  // ── Search functionality (inline filter like Completed Jobs) ───────────────
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredJobs(jobs);
      return;
    }

    const needle = searchTerm.toLowerCase();
    const filtered = jobs.filter(job => {
      try {
        return job.customerName?.toLowerCase().includes(needle) ||
          job.name?.toLowerCase().includes(needle) ||
          job.customerPhone?.toLowerCase().includes(needle) ||
          job.phone?.toLowerCase().includes(needle) ||
          job.customerEmail?.toLowerCase().includes(needle) ||
          job.email?.toLowerCase().includes(needle) ||
          job.from?.toLowerCase().includes(needle) ||
          job.to?.toLowerCase().includes(needle) ||
          job.notes?.toLowerCase().includes(needle) ||
          formatWhen(job.dateTime).toLowerCase().includes(needle);
      } catch (error) {
        console.warn('Error filtering job:', job._id, error);
        // If there's an error with this job, exclude it from search results
        return false;
      }
    });
    setFilteredJobs(filtered);
  }, [searchTerm, jobs]);

  // ── CSV helpers ──────────────────────────────────────
  const toCsv = (rows) => rows.map(r => r.map(v => {
    if (v == null) return '';
    const s = String(v);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }).join(',')).join('\n');

  const handleDownloadCsv = () => {
    const headers = ['Date','Time','From','To','Customer Name','Customer Phone','Customer Email','Passengers','Fare (£)','Payment Method','Notes','Status'];
    const fmtDate = (iso) => new Date(iso).toLocaleDateString('en-GB', { timeZone: 'Europe/London' });
    const fmtTime = (iso) => new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Europe/London' });
    // Use filteredJobs if search is active, otherwise use all jobs
    const jobsToExport = searchTerm.trim() ? filteredJobs : jobs;
    const rows = jobsToExport.map(j => [
      fmtDate(j.dateTime),
      fmtTime(j.dateTime),
      j.from || '',
      j.to || '',
      j.customerName || j.name || '',
      j.customerPhone || j.phone || '',
      j.customerEmail || j.email || '',
      j.passengers ?? '',
      j.fareAmount ?? '',
      j.paymentMethod || 'Cash',
      j.notes || '',
      j.status || ''
    ]);
    const csv = toCsv([headers, ...rows]);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const todayStr = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/London' });
    a.href = url;
    a.download = `my-diary-${todayStr}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleEmailCsv = async () => {
    try {
      // Send filtered job IDs if search is active, otherwise send empty array to get all jobs
      const jobIds = searchTerm.trim() ? filteredJobs.map(j => j._id) : [];
      await axios.post('/view-leads/accepted/email-csv', { jobIds });
      toast.success('CSV email queued. Check your inbox.');
    } catch (e) {
      console.error(e);
      toast.error('Failed to queue CSV email.');
    }
  };

  // ── Extract postcode from address ─────────────────────
  const extractPostcode = (address) => {
    if (!address) return null;
    // UK postcode regex pattern
    const postcodeRegex = /[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}/i;
    const match = address.match(postcodeRegex);
    return match ? match[0] : null;
  };

  // Format a Date to yyyy-MM-ddTHH:mm for datetime-local (LOCAL time, not UTC)
  const toLocalInputValue = (d) => {
    if (!d) return '';
    try {
      const date = new Date(d);
      if (isNaN(date.getTime())) {
        console.warn('Invalid date in toLocalInputValue:', d);
        return '';
      }
      const pad = (n) => String(n).padStart(2, '0');
      const yyyy = date.getFullYear();
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const mi = pad(date.getMinutes());
      return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
    } catch (error) {
      console.warn('Error formatting date in toLocalInputValue:', d, error);
      return '';
    }
  };

  // ── Load favourite drivers from localStorage ───────────
  useEffect(() => {
    const savedFavourites = localStorage.getItem('favouriteDrivers');
    if (savedFavourites) {
      setFavouriteDrivers(JSON.parse(savedFavourites));
    }
  }, []);

  // ── Toggle favourite driver ───────────────────────────
  const toggleFavouriteDriver = (driverId) => {
    setFavouriteDrivers(prev => {
      const newFavourites = prev.includes(driverId) 
        ? prev.filter(id => id !== driverId)
        : [...prev, driverId];
      localStorage.setItem('favouriteDrivers', JSON.stringify(newFavourites));
      return newFavourites;
    });
  };

  // ── Get sorted drivers with favourites first ──────────
  const getSortedDrivers = (drivers) => {
    return drivers.sort((a, b) => {
      const aIsFavourite = favouriteDrivers.includes(a._id);
      const bIsFavourite = favouriteDrivers.includes(b._id);
      if (aIsFavourite && !bIsFavourite) return -1;
      if (!aIsFavourite && bIsFavourite) return 1;
      return (a.name || a.email).localeCompare(b.name || b.email);
    });
  };

  // ── Fetch available drivers for reassignment (Active drivers only) ─────────
  const fetchAvailableDrivers = async (job) => {
    try {
      console.log('Fetching all active drivers for reassignment...');
      // Get all active professional drivers
      const response = await axios.get(`/user/drivers-in-postcode?postcode=ALL`);
      console.log('Active drivers response:', response.data);
      // Filter out current user from available drivers
      const currentUserId = localStorage.getItem('userId');
      const filteredDrivers = response.data.filter(driver => driver._id !== currentUserId);
      setAvailableDrivers(filteredDrivers);
    } catch (err) {
      console.error('Failed to fetch available drivers:', err);
      setAvailableDrivers([]);
    }
  };

  // ── Reassign job ─────────────────────────────────────
  const handleReassign = async (jobId, reassignType, targetDriver = null) => {
    try {
      // Set the job as being reassigned for visual feedback
      setReassigningJobs(prev => new Set([...prev, jobId]));
      
      if (reassignType === 'pool') {
        await axios.post(`/view-leads/reassign/${jobId}`, { reassignType: 'pool' });
        
        // For pool reassignment, remove the job immediately after delay
        setTimeout(() => {
          setJobs(js => js.filter(j => j._id !== jobId));
          setMsg('Job reassigned to pool successfully.');
          // Remove from reassigning set after delay
          setReassigningJobs(prev => {
            const newSet = new Set(prev);
            newSet.delete(jobId);
            return newSet;
          });
        }, 1000); // 1 second delay
        
      } else if (reassignType === 'driver' && targetDriver) {
        await axios.post(`/view-leads/reassign/${jobId}`, { 
          reassignType: 'driver', 
          targetDriverId: targetDriver 
        });
        
        // Store the target driver information for display in headers
        const targetDriverInfo = availableDrivers.find(d => d._id === targetDriver);
        if (targetDriverInfo) {
          setReassigningTargetDrivers(prev => new Map(prev.set(jobId, targetDriverInfo)));
        }
        
        // For driver reassignment, keep the job in the diary but mark it as reassigned
        // The job will be removed when the receiving driver accepts it
        // Keep the job in reassigningJobs until it's accepted/declined
        setTimeout(() => {
          setMsg('Job reassigned to driver. It will remain in your diary until accepted.');
          // Don't remove from reassigningJobs - keep it there until accepted/declined
        }, 1000); // 1 second delay
      }
      
    } catch (err) {
      console.error('Failed to reassign job:', err);
      // Show specific error message for self-reassignment
      if (err.response?.data?.error === 'Cannot reassign job to yourself') {
        setMsg('Cannot reassign job to yourself.');
      } else {
        setMsg('Failed to reassign job.');
      }
      // Remove from reassigning set on error
      setReassigningJobs(prev => {
        const newSet = new Set(prev);
        newSet.delete(jobId);
        return newSet;
      });
    } finally {
      setReassignAction(null);
      setSelectedDriver('');
    }
  };

  // ── Generic action (cancel/release/complete) ─────────
  const doAction = async (id, verb) => {
  try {
    // 1️⃣ Handle "complete" in-line
    if (verb === 'complete') {
      // 🔹 call your complete endpoint
      await axios.post(`/view-leads/${verb}/${id}`);
      // 🔹 update the local job list however you did before:
      //    here we remove it from the list, but you could also
      //    update its status in place instead:
      setJobs(js => js.filter(j => j._id !== id));
      setMsg('Job completed.');
    } else if (verb === 'cancel') {
      // Handle cancel with reason
      await axios.post(`/view-leads/${verb}/${id}`, {
        cancellationReason: cancellationReason
      });
      setJobs(js => js.filter(j => j._id !== id));
      setMsg(`Job ${verb}ed.`);
    } else {
      // 2️⃣ all your other verbs use the generic endpoint
      await axios.post(`/view-leads/${verb}/${id}`);
      setJobs(js => js.filter(j => j._id !== id));
      setMsg(`Job ${verb}ed.`);
    }
  } catch (err) {
    console.error(`Failed to ${verb} job:`, err);
    setMsg(`Failed to ${verb} job.`);
  } finally {
    // 3️⃣ always clear the confirmation dialog
    setConfirmAction(null);
    setCancellationReason('');
  }
};

  // ── Handle job cancellation with review and blacklist ─────────
  const handleJobCancellation = async (cancellationData) => {
    try {
      setSaving(true);
      
      // Cancel the job with review and blacklist data
      await axios.post(`/view-leads/cancel/${jobToCancel._id}`, {
        cancellationReason: cancellationData.cancellationReason,
        starRating: cancellationData.starRating,
        reviewText: cancellationData.reviewText,
        isBlacklisted: cancellationData.isBlacklisted,
        blacklistReason: cancellationData.blacklistReason
      });
      
      // Remove job from list
      setJobs(js => js.filter(j => j._id !== jobToCancel._id));
      setMsg('Job cancelled successfully.');
      
      // Close modal
      setShowCancellationModal(false);
      setJobToCancel(null);
      
    } catch (err) {
      console.error('Failed to cancel job:', err);
      setMsg('Failed to cancel job.');
    } finally {
      setSaving(false);
    }
  };

  // ── Handle customer review click ─────────────────────────
  const handleCustomerReviewClick = (reviewData, job = null) => {
    setCustomerReviewData(reviewData);
    
    // Use job data if provided (from job card), otherwise use diary data (from Add Job form)
    if (job) {
      setCustomerInfo({
        name: job.customerName || 'Unknown Customer',
        phone: job.customerPhone,
        email: job.customerEmail
      });
    } else {
      setCustomerInfo({
        name: diaryData.customerName || 'Unknown Customer',
        phone: diaryData.phone,
        email: diaryData.customerEmail
      });
    }
    
    setShowCustomerReviewModal(true);
  };

  // ── Confirm job with customer ─────────────────────────
  const handleConfirm = async (id) => {
    try {
      await axios.post(`/view-leads/confirm/${id}`);
      setJobs(js => js.map(j => 
        j._id === id ? { ...j, status: 'confirmed' } : j
      ));
      setMsg('Job confirmed with customer.');
    } catch (err) {
      console.error('Failed to confirm job:', err);
      setMsg('Failed to confirm job.');
    }
  };

  // ── Time buckets for rendering ─────────────────────────
  const now = new Date();
  
  // Use UTC dates to avoid timezone issues - the app is timezone independent
  const startToday = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  
  // Get tomorrow's date
  const startTomorrow = new Date(startToday);
  startTomorrow.setUTCDate(startTomorrow.getUTCDate() + 1);
  
  // Get yesterday's date
  const startYesterday = new Date(startToday);
  startYesterday.setUTCDate(startYesterday.getUTCDate() - 1);
  
  // Calculate end of current week (Sunday) - weeks are Monday-Sunday
  const endOfCurrentWeek = new Date(startToday);
  const currentDayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const daysUntilSunday = currentDayOfWeek === 0 ? 0 : 7 - currentDayOfWeek; // If today is Sunday, 0 days until Sunday
  endOfCurrentWeek.setUTCDate(endOfCurrentWeek.getUTCDate() + daysUntilSunday);
  endOfCurrentWeek.setUTCHours(23, 59, 59, 999); // End of Sunday
  
  // Calculate start of next week (Monday)
  const startOfNextWeek = new Date(endOfCurrentWeek);
  startOfNextWeek.setUTCDate(startOfNextWeek.getUTCDate() + 1);
  startOfNextWeek.setUTCHours(0, 0, 0, 0); // Start of Monday
  
  // Calculate end of next week (Sunday)
  const endOfNextWeek = new Date(startOfNextWeek);
  endOfNextWeek.setUTCDate(endOfNextWeek.getUTCDate() + 6);
  endOfNextWeek.setUTCHours(23, 59, 59, 999); // End of Sunday
  
  // Filter jobs into categories with non-overlapping conditions
  const yesterdayJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      return jobDateOnly.getTime() === startYesterday.getTime() && j.status !== 'completed';
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });
  
  const todayJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      return jobDateOnly.getTime() === startToday.getTime();
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });
  
  const tomorrowJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      return jobDateOnly.getTime() === startTomorrow.getTime();
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });
  
  const restOfWeekJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      const dayAfterTomorrow = new Date(startTomorrow);
      dayAfterTomorrow.setUTCDate(dayAfterTomorrow.getUTCDate() + 1);
      return jobDateOnly.getTime() >= dayAfterTomorrow.getTime() && jobDateOnly.getTime() < startOfNextWeek.getTime();
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });
  
  const nextWeekJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      return jobDateOnly.getTime() >= startOfNextWeek.getTime() && jobDateOnly.getTime() <= endOfNextWeek.getTime();
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });
  
  const futureJobs = filteredJobs.filter(j => {
    try {
      const jobDate = new Date(j.dateTime);
      const jobDateOnly = new Date(Date.UTC(jobDate.getUTCFullYear(), jobDate.getUTCMonth(), jobDate.getUTCDate()));
      return jobDateOnly.getTime() > endOfNextWeek.getTime();
    } catch (error) {
      console.warn('Error parsing job date:', j.dateTime, error);
      return false;
    }
  });

  // Check if tomorrow is Monday
  const tomorrowDate = new Date(startTomorrow);
  const isTomorrowMonday = tomorrowDate.getUTCDay() === 1; // 1 = Monday

  // If tomorrow is Monday, move tomorrow's jobs to next week
  const finalTomorrowJobs = isTomorrowMonday ? [] : tomorrowJobs;
  
  // When tomorrow is Monday, we need to merge tomorrow's jobs with next week jobs
  // But we need to avoid duplicates by checking if the job is already in nextWeekJobs
  let finalNextWeekJobs;
  if (isTomorrowMonday) {
    const tomorrowJobIds = new Set(tomorrowJobs.map(job => job._id.toString()));
    const nextWeekJobsWithoutTomorrow = nextWeekJobs.filter(job => !tomorrowJobIds.has(job._id.toString()));
    const mergedJobs = [...nextWeekJobsWithoutTomorrow, ...tomorrowJobs];
    
    // Sort the merged jobs chronologically by dateTime
    finalNextWeekJobs = mergedJobs.sort((a, b) => {
      try {
        const dateA = createSafeDate(a.dateTime);
        const dateB = createSafeDate(b.dateTime);
        return dateA - dateB;
      } catch (error) {
        console.warn('Error sorting merged jobs:', error);
        return 0;
      }
    });
  } else {
    finalNextWeekJobs = nextWeekJobs;
  }

  // Debug logging removed - issue resolved



  // ── Render each job ───────────────────────────────────
  const renderJobItem = (j, idx, allJobs = [], sectionType = '') => {
      // Check if this job has a pending handshake where current user is the receiver
  const handshakeJob = handshakeJobs.find(h => h.jobId === j._id);
  const isHandshakePending = handshakeJob && handshakeJob.status === 'pending';
  
  // Check if this is a reassigned job that needs acceptance
  // A job is considered reassigned if it has reassignedBy/reassignedAt fields and is accepted but acceptedAt is null
  // Once acceptedAt is set, it's no longer a pending reassigned job
  const isReassignedJob = j.reassignedBy && j.reassignedAt && j.status === 'accepted' && !j.acceptedAt;
  
  // Check if this is a reassigned job (either pending or already accepted)
  const isReassignedJobAnyStatus = j.reassignedBy && j.reassignedAt && j.status === 'accepted';

  // Identify Web-Link jobs and whether they still need review
  const isWebLinkJob = !j.bookingLinkId && !j.createdByDispatcher && !j.isManualDiaryEntry;
  const isWebLinkAssigned = j.webLinkAssignedToDrivers && j.webLinkAssignedToDrivers.length > 0 && j.status === 'pending';
  const isWebLinkPendingReview = isWebLinkJob && (!j.status || j.status === 'pending');

  // Check if this is the first job of a new day (for Rest of Week, Next Week, Future sections)
  const isFirstJobOfNewDay = (sectionType === 'restOfWeek' || sectionType === 'nextWeek' || sectionType === 'future') && 
    allJobs.length > 0 && 
    idx > 0 && 
    allJobs[idx - 1] && 
    new Date(j.dateTime).toDateString() !== new Date(allJobs[idx - 1].dateTime).toDateString();
    
    return (
    <Accordion.Item 
      eventKey={String(idx)} 
      key={j._id}
      className={`${isHandshakePending ? 'border-warning bg-warning bg-opacity-10' : ''} ${isFirstJobOfNewDay ? 'day-change-border' : ''}`}
      style={isFirstJobOfNewDay ? { borderTop: '3px solid #000' } : {}}
    >
      <Accordion.Header>
        <div className="d-flex flex-column w-100">
          {/* Booking Link header - Red when pending, Blue when accepted */}
          {j.bookingLinkId && (
            <div className={`${!j.acceptedAt ? 'bg-danger' : 'bg-primary'} mb-0 rounded-top booking-link-header`} style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <strong style={{ fontSize: '0.7rem', color: 'white', display: 'flex', alignItems: 'center' }}>
                🔗 Booking Link {!j.acceptedAt ? '(Action Required)' : '(Accepted)'}
                {!j.acceptedAt && <span className="booking-link-flash-arrow">««««</span>}
              </strong>
            </div>
          )}
          
          {/* Web-Link header - Green background for web bookings from Fare Calculator (not manual diary entries) */}
          {(isWebLinkJob || isWebLinkAssigned) && (
            <div className={`${isWebLinkAssigned && !j.acceptedAt ? 'bg-warning' : 'bg-success'} text-white mb-0 rounded-top`} style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.3rem 0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
              <strong style={{ fontSize: '0.7rem', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                🔗 Web-Link {isWebLinkAssigned && !j.acceptedAt ? '(Action Required)' : isWebLinkPendingReview ? '(Action Required)' : '(Accepted)'}
                {((isWebLinkAssigned && !j.acceptedAt) || isWebLinkPendingReview) && <span className="booking-link-flash-arrow">««««</span>}
              </strong>
            </div>
          )}
          
          {/* Dispatched Job header - Yellow background */}
          {j.createdByDispatcher && (
            <div className="bg-warning text-dark mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>🚛 Dispatched Job</strong>
            </div>
          )}
          
          {/* Pending Re-assigned Job header - Show for original driver when job is pending acceptance */}
          {j.reassignedBy?._id === localStorage.getItem('userId') && (j.status === 'accepted' || j.status === 'pending') && !j.acceptedAt && (
            <div className="bg-secondary text-white mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>
                🔄 Re-assigned to {(j.acceptedBy?.name || j.acceptedBy?.email || 'Driver').split(' ')[0]}
                {j.acceptedBy?.companyName && ` >${j.acceptedBy.companyName}`}
                {' (PENDING)'}
              </strong>
            </div>
          )}
          
          {/* Pending Re-assigned Job header - Show for original driver when job is pending acceptance (OUTGOING) */}
          {j.reassignedBy?._id === localStorage.getItem('userId') && j.status === 'accepted' && !j.acceptedAt && (
            <div className="bg-secondary text-white mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>
                {'>>>'} Re-assigned to {(j.acceptedBy?.name || j.acceptedBy?.email || 'Driver').split(' ')[0]}
                {j.acceptedBy?.companyName && ` >${j.acceptedBy.companyName}`}
                {' (PENDING)'}
              </strong>
            </div>
          )}
          
          {/* Re-assigned Job header - Show for new driver receiving the job (INCOMING) */}
          {j.acceptedBy?._id === localStorage.getItem('userId') && j.reassignedBy && j.reassignedBy._id !== localStorage.getItem('userId') && j.status === 'accepted' && (
            <div className={`${!j.acceptedAt ? 'bg-warning text-dark' : 'bg-info text-white'} mb-0 rounded-top`} style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>
                {'<<<'} Re-assigned from {(j.reassignedBy?.name || j.reassignedBy?.email || 'Driver').split(' ')[0]}
                {j.reassignedBy?.companyName && ` >${j.reassignedBy.companyName}`}
                {!j.acceptedAt && ' (PENDING)'}
              </strong>
            </div>
          )}
          
          {/* Declined Re-assigned Job header - Show for original driver when job was declined */}
          {(() => {
            const shouldShowDeclinedHeader = j.acceptedBy?._id === localStorage.getItem('userId') && j.status === 'accepted' && j.cancellationReason === 'Declined by driver from reassignment';
            if (shouldShowDeclinedHeader) {
              console.log('🔍 Showing declined header for job:', j._id, 'Customer:', j.customerName);
              console.log('  - AcceptedBy:', j.acceptedBy?._id);
              console.log('  - Current User:', localStorage.getItem('userId'));
              console.log('  - Status:', j.status);
              console.log('  - CancellationReason:', j.cancellationReason);
            }
            return shouldShowDeclinedHeader;
          })() && (
            <div className="bg-danger text-white mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>
                ⚠️ WARNING NOT ACCEPTED - {(j.acceptedBy?.name || j.acceptedBy?.email || 'Driver').split(' ')[0]}
                {j.acceptedBy?.companyName && ` >${j.acceptedBy.companyName}`}
              </strong>
            </div>
          )}
          
          {/* Re-assign header - Orange when being reassigned */}
          {reassigningJobs.has(j._id) && (
            <div className="bg-warning text-dark mb-0 rounded-top" style={{ marginTop: '-17px', marginLeft: '-21px', marginRight: '-42px', padding: '0.015rem' }}>
              <strong style={{ fontSize: '0.7rem' }}>🔄 Re-assigning to {reassigningTargetDrivers.get(j._id)?.name || reassigningTargetDrivers.get(j._id)?.email || 'Driver'}...</strong>
            </div>
          )}
          <div className="d-flex align-items-center gap-2">
            <strong>{formatWhen(j.dateTime)}</strong>
            {j.status === 'confirmed' && (
              <span className="badge bg-success" title="Confirmed with customer">
                ✅ Confirmed
              </span>
            )}
            {isHandshakePending && (
              <span className="badge bg-warning" title="Handshake pending">
                🤝 Handshake Pending
              </span>
            )}
          </div>
          <small>{extractTowns(j.from,j.to)}</small>
          
          {/* Wait and Return footer - Show at bottom of accordion header */}
          {j.waitAndReturn && j.waitHours && (
            <div className="bg-success mt-2 rounded-bottom wait-return-header" style={{ marginLeft: '-21px', marginRight: '-42px', marginBottom: '-17px', padding: '0.015rem', color: 'white', textAlign: 'right' }}>
              <strong style={{ fontSize: '0.7rem', color: 'white' }}>
                ⏰ Wait & Return - {calculateReturnTime(j.dateTime, j.waitHours)}
              </strong>
            </div>
          )}
        </div>
      </Accordion.Header>
      <Accordion.Body>
        <p className="d-flex align-items-center">
          <strong>Customer:</strong> 
          <span className="ms-1">{j.customerName || ''}</span>
          <JobCardReviewIndicator 
            job={j} 
            onReviewsClick={handleCustomerReviewClick}
            size="sm"
          />
        </p>
        <p><strong>Route:</strong> <span 
          className="text-primary" 
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => {
            setNavigationOrigin(null);
            setNavigationDestination(j.from);
            setNavigationJob(j);
            setFareEstimates(null);
            setSlidePanelType('navigation');
            setShowSlidePanel(true);
          }}
        >{j.from}</span> → <span 
          className="text-primary" 
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => {
            setNavigationOrigin(j.from);
            setNavigationDestination(j.to);
            setNavigationJob(j);
            setFareEstimates(null);
            setSlidePanelType('navigation');
            setShowSlidePanel(true);
          }}
        >{j.to}</span></p>
        {j.mileage && <p><strong>Distance:</strong> {j.mileage} miles</p>}
        {j.duration && <p><strong>Duration:</strong> {j.duration} minutes</p>}
        <div className="d-flex justify-content-between align-items-center">
          <p className="mb-0">
            <strong>Passengers:</strong> {j.passengers}
            {(() => {
              const driverSeats = parseInt(localStorage.getItem('userCarSeats'), 10);
              const jobPassengers = parseInt(j.passengers, 10);
              const isExceeded = !isNaN(driverSeats) && !isNaN(jobPassengers) && jobPassengers > driverSeats;
              return isExceeded && (
                <span className="badge bg-danger ms-2" style={{ fontSize: '0.75rem' }}>
                  ⚠️ EXCEEDS CAPACITY ({driverSeats} seats)
                </span>
              );
            })()}
            {(j.dog || j.disabled) && (
              <>
                {j.dog && <span className="badge bg-warning ms-2">🐕 Dog/Pet</span>}
                {j.disabled && <span className="badge bg-info ms-2">♿ Disabled</span>}
              </>
            )}
          </p>
          <Button 
            variant="outline-info" 
            size="sm" 
            onClick={() => showJobTimestamps(j)}
            title="View Job Timestamps"
            className="rounded-circle"
            style={{ fontSize: '0.7rem', padding: '0.2rem 0.4rem', width: '1.5rem', height: '1.5rem', backgroundColor: '#ffc107', borderColor: '#ffc107', color: '#000' }}
          >
            i
          </Button>
        </div>
        <div className="d-flex align-items-center mb-2" style={{ whiteSpace: 'nowrap' }}>
          <span className="me-2">📞</span>
          <div className="btn-group flex-grow-1">
            <a href={`tel:${j.customerPhone}`} className="btn btn-sm btn-outline-primary">
              {j.customerPhone}
            </a>
            <Dropdown>
              <Dropdown.Toggle variant="outline-secondary" size="sm">
                ✉️
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => {
                  sendSMSWithFallback(j.customerPhone, 'Hi, This is in Relation to Your Taxi booking', 'New Text');
                }}>
                  📝 New Text
                </Dropdown.Item>
                <Dropdown.Divider />
                {smsTemplates.length > 0 ? (
                  smsTemplates.map((template) => (
                    <Dropdown.Item
                      key={template._id}
                      onClick={() => handleSendSmsWithTemplate(j, j.customerPhone, template)}
                    >
                      {template.title}
                    </Dropdown.Item>
                  ))
                ) : (
                  <Dropdown.Item disabled>No SMS templates available</Dropdown.Item>
                )}
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => handleSendConfirmationSMS(j, j.customerPhone)}>
                  📧 Quick Confirmation (Default)
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {j.customerPhone2 && (
          <div className="d-flex align-items-center mb-2" style={{ whiteSpace: 'nowrap' }}>
            <span className="me-2">📞</span>
            <div className="btn-group flex-grow-1">
              <a href={`tel:${j.customerPhone2}`} className="btn btn-sm btn-outline-primary">
                {j.customerPhone2}
              </a>
              <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" size="sm">
                  ✉️
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => {
                    sendSMSWithFallback(j.customerPhone2, 'Hi, This is in Relation to Your Taxi booking', 'New Text');
                  }}>
                    📝 New Text
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  {smsTemplates.length > 0 ? (
                    smsTemplates.map((template) => (
                      <Dropdown.Item
                        key={template._id}
                        onClick={() => handleSendSmsWithTemplate(j, j.customerPhone2, template)}
                      >
                        {template.title}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No SMS templates available</Dropdown.Item>
                  )}
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => handleSendConfirmationSMS(j, j.customerPhone2)}>
                    📧 Quick Confirmation (Default)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        )}
        {j.customerEmail && (
          <>
            <div className="d-flex align-items-center mb-2" style={{ whiteSpace: 'nowrap' }}>
              <span className="me-2">📧</span>
              <a href={`mailto:${j.customerEmail}`} className="btn btn-sm btn-outline-info flex-grow-1">
                {j.customerEmail}
              </a>
            </div>
            <div className="d-flex justify-content-end mb-1">
              <Button 
                variant="outline-success" 
                size="sm"
                onClick={() => handleSendConfirmationEmail(j._id, j.customerEmail)}
                disabled={sendingEmails.has(j._id)}
              >
                {sendingEmails.has(j._id) ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Sending...
                  </>
                ) : (
                  <>
                    📤 Email Confirmation
                  </>
                )}
              </Button>
            </div>
          </>
        )}
        <p><strong>Price:</strong> £{j.fareAmount}</p>
        {j.notes && (
          <div className="mt-2">
            <strong>Notes:</strong> <span className="text-muted">{j.notes}</span>
          </div>
        )}
                        <div className="d-flex flex-column gap-2 mt-3 w-100">
                  {/* Booking Link Jobs - Show Accept/Decline/Re-assign when first received */}
                  {j.bookingLinkId && j.status === 'accepted' && !j.acceptedAt && (
                    <>
                      {/* Row 1: Accept, Decline */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="success" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleAcceptBookingLinkJob(j._id)}
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          Accept
                        </Button>
                        <Button 
                          variant="danger" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleDeclineBookingLinkJob(j._id)}
                        >
                          <i className="bi bi-x-circle me-1"></i>
                          Decline
                        </Button>
                      </div>

                      {/* Row 2: Re-assign */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="warning" 
                          size="md" 
                          className="flex-fill"
                          disabled={reassigningJobs.has(j._id)}
                          onClick={() => {
                            setReassignAction({ id: j._id, job: j });
                            fetchAvailableDrivers(j);
                          }}
                        >
                          {reassigningJobs.has(j._id) ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                              Re-assigning...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-arrow-left-right me-1"></i>
                              Re-assign
                            </>
                          )}
                        </Button>
                      </div>
                    </>
                  )}

                  {/* WebLink Assigned Jobs - Show Accept/Decline/Re-assign when first received (similar to MyLink) */}
                  {isWebLinkAssigned && j.status === 'pending' && (
                    <>
                      {/* Row 1: Accept, Decline */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="success" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleAcceptBookingLinkJob(j._id)}
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          Accept
                        </Button>
                        <Button 
                          variant="danger" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleDeclineBookingLinkJob(j._id)}
                        >
                          <i className="bi bi-x-circle me-1"></i>
                          Decline
                        </Button>
                      </div>

                      {/* Row 2: Re-assign */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="warning" 
                          size="md" 
                          className="flex-fill"
                          disabled={reassigningJobs.has(j._id)}
                          onClick={() => {
                            setReassignAction({ id: j._id, job: j });
                            fetchAvailableDrivers(j);
                          }}
                        >
                          {reassigningJobs.has(j._id) ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                              Re-assigning...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-arrow-left-right me-1"></i>
                              Re-assign
                            </>
                          )}
                        </Button>
                      </div>
                    </>
                  )}

                  {/* Incoming Reassigned Job - Show Accept/Decline for receiving driver */}
                  {j.acceptedBy?._id === localStorage.getItem('userId') && j.reassignedBy && j.reassignedBy._id !== localStorage.getItem('userId') && j.status === 'accepted' && !j.acceptedAt && (
                    <>
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="success" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleAcceptReassignedJob(j._id)}
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          Accept
                        </Button>
                        <Button 
                          variant="danger" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => handleDeclineReassignedJob(j._id)}
                        >
                          <i className="bi bi-x-circle me-1"></i>
                          Decline
                        </Button>
                      </div>
                    </>
                  )}

                  {/* Original Driver's Reassigned Job - Only show Edit button */}
                  {j.reassignedBy?._id === localStorage.getItem('userId') && j.status === 'accepted' && !j.acceptedAt && (
                    <>
                      {/* Row 1: Edit Button Only */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="secondary" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => openEdit(j)}
                        >
                          <i className="bi bi-pencil-square me-1"></i>
                          Edit
                        </Button>
                      </div>
                    </>
                  )}

                  {/* Standard Job Options - Show for all other jobs or after booking link/WebLink job is accepted */}
                  {(!j.bookingLinkId || (j.bookingLinkId && j.acceptedAt)) && (!isWebLinkAssigned || (isWebLinkAssigned && j.acceptedAt)) && (!isReassignedJob || (isReassignedJobAnyStatus && j.acceptedAt)) && !(j.reassignedBy?._id === localStorage.getItem('userId') && j.status === 'accepted' && !j.acceptedAt) && (
                    <>
                      {/* Row 1: Complete Button */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="success" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => {
                            setForm(f => ({
                              ...f,
                              customerEmail: j.customerEmail || j.email || '',
                              fareAmount: j.fareAmount || '',
                              paymentMethod: j.paymentMethod || 'Cash'
                            }));
                            setConfirmAction({ id: j._id, verb: 'complete' });
                          }}
                        >
                          <i className="bi bi-check-circle me-1"></i>
                          Complete
                        </Button>
                      </div>

                      {/* Row 2: Edit, Return Buttons */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="secondary" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => openEdit(j)}
                        >
                          <i className="bi bi-pencil-square me-1"></i>
                          Edit
                        </Button>
                        {!jobs.some(k => k.groupId === j._id) && (
                          <Button 
                            variant="info" 
                            size="md" 
                            className="flex-fill"
                            onClick={() => openReturn(j)}
                          >
                            <i className="bi bi-arrow-return-left me-1"></i>
                            Return
                          </Button>
                        )}
                      </div>

                      {/* Row 3: Cancel, Re-assign */}
                      <div className="d-flex gap-2 w-100">
                        <Button 
                          variant="danger" 
                          size="md" 
                          className="flex-fill"
                          onClick={() => {
                            setJobToCancel(j);
                            setShowCancellationModal(true);
                          }}
                        >
                          <i className="bi bi-x-circle me-1"></i>
                          Cancel
                        </Button>
                        <Button 
                          variant="warning" 
                          size="md" 
                          className="flex-fill"
                          disabled={reassigningJobs.has(j._id)}
                          onClick={() => {
                            setReassignAction({ id: j._id, job: j });
                            fetchAvailableDrivers(j);
                          }}
                        >
                          {reassigningJobs.has(j._id) ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                              Re-assigning...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-arrow-left-right me-1"></i>
                              Re-assign
                            </>
                          )}
                        </Button>
                      </div>

                      {/* Row 4: +Tomorrow, +Next Week, +Next Month */}
                      <div className="d-flex gap-1 w-100" style={{ maxWidth: '100%' }}>
                        <Button size="sm" variant="outline-secondary" className="flex-fill" style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }} onClick={()=>{
                          try {
                            const base = createSafeDate(j.dateTime);
                            const dt = createSafeDate(new Date(base.getTime()+24*60*60*1000));
                            setDuplicateAction({ 
                              job: j, 
                              dateTime: dt, 
                              from: j.from, 
                              to: j.to,
                              waitAndReturn: j.waitAndReturn,
                              waitHours: j.waitHours
                            });
                          } catch (error) {
                            console.warn('Error creating +Tomorrow date:', j.dateTime, error);
                            toast.error('Cannot duplicate job with invalid date');
                          }
                        }}>+Tomorrow</Button>
                        <Button size="sm" variant="outline-secondary" className="flex-fill" style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }} onClick={()=>{
                          try {
                            const base = createSafeDate(j.dateTime);
                            const dt = createSafeDate(new Date(base.getTime()+7*24*60*60*1000));
                            setDuplicateAction({ 
                              job: j, 
                              dateTime: dt, 
                              from: j.from, 
                              to: j.to,
                              waitAndReturn: j.waitAndReturn,
                              waitHours: j.waitHours
                            });
                          } catch (error) {
                            console.warn('Error creating +Next Week date:', j.dateTime, error);
                            toast.error('Cannot duplicate job with invalid date');
                          }
                        }}>+Next Week</Button>
                        <Button size="sm" variant="outline-secondary" className="flex-fill" style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }} onClick={()=>{
                          try {
                            const d = createSafeDate(j.dateTime);
                            const next = createSafeDate(d);
                            next.setMonth(d.getMonth()+1);
                            setDuplicateAction({ 
                              job: j, 
                              dateTime: next, 
                              from: j.from, 
                              to: j.to,
                              waitAndReturn: j.waitAndReturn,
                              waitHours: j.waitHours
                            });
                          } catch (error) {
                            console.warn('Error creating +Next Month date:', j.dateTime, error);
                            toast.error('Cannot duplicate job with invalid date');
                          }
                        }}>+Next Month</Button>
                      </div>

                    </>
                  )}

                  {/* Handshake buttons (if pending) */}
                  {isHandshakePending && (
                    <div className="d-flex gap-2 w-100">
                      <Button 
                        variant="success" 
                        size="md" 
                        className="flex-fill"
                        onClick={() => acceptHandshake(j._id, handshakeJob.fromDriverId)}
                      >
                        <i className="bi bi-check-circle me-1"></i>
                        Accept Handshake
                      </Button>
                      <Button 
                        variant="danger" 
                        size="md" 
                        className="flex-fill"
                        onClick={() => declineHandshake(j._id, handshakeJob.fromDriverId)}
                      >
                        <i className="bi bi-x-circle me-1"></i>
                        Decline Handshake
                      </Button>
                    </div>
                  )}
                </div>
      </Accordion.Body>
    </Accordion.Item>
    );
  };

  // ── Edit handlers ─────────────────────────────────────
  const openEdit = lead => {
    setEditLead(lead);
    
    // Safely handle the dateTime
    let safeDateTime;
    try {
      safeDateTime = createSafeDate(lead.dateTime);
    } catch (error) {
      console.warn('Error parsing dateTime in lead:', lead.dateTime, error);
      safeDateTime = createSafeDate(new Date()); // Default to current date
    }
    
    setForm({
      name: lead.customerName,
      email: lead.customerEmail,
      phone: lead.customerPhone,
      phone2: lead.customerPhone2 || '',
      from: lead.from,
      to: lead.to,
      dateTime: safeDateTime,
      passengers: String(lead.passengers),
      returnTrip: lead.returnTrip,
      fareAmount: lead.fareAmount ? `£${lead.fareAmount}` : '',
      dog: lead.dog || false,
      disabled: lead.disabled || false,
      notes: lead.notes || '',
      invoiced: lead.invoiced || false,
      paid: lead.paid || false,
      waitAndReturn: lead.waitAndReturn || false,
      waitHours: lead.waitHours || ''
    });
    setShowPhone2(!!(lead.customerPhone2 || lead.phone2));

  };
  const closeEdit = () => {
    setEditLead(null);
    setShowPhone2(false);
  };

  // Calculate job totals for different time periods
  const calculateDailyTotals = async (weekOffset = 0) => {
    try {
      console.log('calculateDailyTotals called with weekOffset:', weekOffset);
      // Fetch completed jobs from the completed jobs endpoint
      const { data: completedJobs } = await axios.get('/view-leads/completed');
      
      const now = createSafeDate(new Date());
      const today = createSafeDate(now);
      today.setHours(0, 0, 0, 0);
      
      const tomorrow = createSafeDate(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      
      // Calculate week start (Monday) and end (Sunday) with offset
      const weekStart = createSafeDate(today);
      const dayOfWeek = weekStart.getDay();
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Sunday = 0, Monday = 1
      weekStart.setDate(weekStart.getDate() - daysToSubtract);
      
      // Apply week offset with validation
      weekStart.setDate(weekStart.getDate() + (weekOffset * 7));
      weekStart.setHours(0, 0, 0, 0);
      
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekEnd.getDate() + 6); // Add 6 days to get to Sunday
      weekEnd.setHours(23, 59, 59, 999); // End of Sunday
      
      console.log('Debug - Date ranges:', {
        weekOffset,
        today: (() => {
          try {
            return today.toISOString();
          } catch (error) {
            console.warn('Error converting today to ISO string:', error);
            return 'Invalid Date';
          }
        })(),
        tomorrow: (() => {
          try {
            return tomorrow.toISOString();
          } catch (error) {
            console.warn('Error converting tomorrow to ISO string:', error);
            return 'Invalid Date';
          }
        })(),
        weekStart: (() => {
          try {
            return weekStart.toISOString();
          } catch (error) {
            console.warn('Error converting weekStart to ISO string:', error);
            return 'Invalid Date';
          }
        })(),
        weekEnd: (() => {
          try {
            return weekEnd.toISOString();
          } catch (error) {
            console.warn('Error converting weekEnd to ISO string:', error);
            return 'Invalid Date';
          }
        })(),
        totalCompletedJobs: completedJobs.length
      });
      
      // Filter completed jobs for different periods - only include jobs with fare amounts
      let todaysJobs;
      if (weekOffset === 0) {
        // For current week, show today's jobs
        todaysJobs = completedJobs.filter(job => {
          try {
            const jobDate = createSafeDate(job.dateTime);
            const amount = parseFloat(job.fareAmount) || 0;
            const isToday = jobDate >= today && jobDate < tomorrow;
            const hasAmount = amount > 0;
            
            return isToday && hasAmount;
          } catch (error) {
            console.warn('Invalid job date:', job.dateTime, error);
            return false;
          }
        });
      } else {
        // For past weeks, show the first day of that week
        const weekFirstDay = new Date(weekStart);
        const weekFirstDayEnd = new Date(weekStart);
        weekFirstDayEnd.setDate(weekFirstDayEnd.getDate() + 1);
        
        todaysJobs = completedJobs.filter(job => {
          try {
            const jobDate = createSafeDate(job.dateTime);
            const amount = parseFloat(job.fareAmount) || 0;
            const isFirstDay = jobDate >= weekFirstDay && jobDate < weekFirstDayEnd;
            const hasAmount = amount > 0;
            
            return isFirstDay && hasAmount;
          } catch (error) {
            console.warn('Invalid job date:', job.dateTime, error);
            return false;
          }
        });
      }
      
      const thisWeeksJobs = completedJobs.filter(job => {
        try {
          const jobDate = createSafeDate(job.dateTime);
          const amount = parseFloat(job.fareAmount) || 0;
          const isInWeek = jobDate >= weekStart && jobDate <= weekEnd;
          const hasAmount = amount > 0;
          
          return isInWeek && hasAmount;
        } catch (error) {
          console.warn('Invalid job date:', job.dateTime, error);
          return false;
        }
      });
      
      // Helper function to determine job input method
      const getJobInputMethod = (job) => {
        if (job.isManualDiaryEntry) {
          return 'Manual Add Job';
        } else if (job.bookingLinkId) {
          return 'MyLink';
        } else {
          return 'WebLink';
        }
      };

      // Helper function to calculate totals for a job array
      const calculateTotalsForJobs = (jobArray) => {
        const totals = {
          count: jobArray.length,
          total: 0,
          tipTotal: 0,
          byPaymentMethod: {
            Cash: { count: 0, total: 0, tipTotal: 0 },
            Card: { count: 0, total: 0, tipTotal: 0 },
            BankTransfer: { count: 0, total: 0, tipTotal: 0 },
            Invoiced: { count: 0, total: 0, tipTotal: 0 }
          },
          byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }
        };
        
        jobArray.forEach(job => {
          const amount = parseFloat(job.fareAmount) || 0;
          const tip = parseFloat(job.tipAmount) || 0;
          const paymentMethod = job.paymentMethod || 'Cash';
          const inputMethod = getJobInputMethod(job);
          
          totals.total += amount;
          totals.tipTotal += tip;
          
          // Track by payment method
          if (totals.byPaymentMethod[paymentMethod]) {
            totals.byPaymentMethod[paymentMethod].count += 1;
            totals.byPaymentMethod[paymentMethod].total += amount;
            totals.byPaymentMethod[paymentMethod].tipTotal += tip;
          } else {
            // If payment method is not recognized, default to Cash
            totals.byPaymentMethod.Cash.count += 1;
            totals.byPaymentMethod.Cash.total += amount;
            totals.byPaymentMethod.Cash.tipTotal += tip;
          }
          
          // Track by input method
          if (totals.byInputMethod[inputMethod]) {
            totals.byInputMethod[inputMethod].count += 1;
            totals.byInputMethod[inputMethod].total += amount;
            totals.byInputMethod[inputMethod].tipTotal += tip;
          }
        });
        
        return totals;
      };

      // Calculate daily totals for the current week
      const calculateDailyTotalsForWeek = (jobs, weekStart) => {
        const dailyTotals = {
          Monday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Tuesday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Wednesday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Thursday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Friday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Saturday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }},
          Sunday: { count: 0, total: 0, tipTotal: 0, byInputMethod: {
            'Manual Add Job': { count: 0, total: 0, tipTotal: 0 },
            'MyLink': { count: 0, total: 0, tipTotal: 0 },
            'WebLink': { count: 0, total: 0, tipTotal: 0 }
          }}
        };

        jobs.forEach(job => {
          try {
            const jobDate = createSafeDate(job.dateTime);
            const amount = parseFloat(job.fareAmount) || 0;
            const tip = parseFloat(job.tipAmount) || 0;
            const inputMethod = getJobInputMethod(job);
            
            if (amount > 0) {
              const dayOfWeek = jobDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
              const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              const dayName = dayNames[dayOfWeek];
              
              dailyTotals[dayName].count += 1;
              dailyTotals[dayName].total += amount;
              dailyTotals[dayName].tipTotal += tip;
              
              // Track by input method for this day
              if (dailyTotals[dayName].byInputMethod[inputMethod]) {
                dailyTotals[dayName].byInputMethod[inputMethod].count += 1;
                dailyTotals[dayName].byInputMethod[inputMethod].total += amount;
                dailyTotals[dayName].byInputMethod[inputMethod].tipTotal += tip;
              }
            }
          } catch (error) {
            console.warn('Invalid job date for daily totals:', job.dateTime, error);
          }
        });

        return dailyTotals;
      };
      
      const totals = {
        today: calculateTotalsForJobs(todaysJobs),
        thisWeek: calculateTotalsForJobs(thisWeeksJobs),
        daily: calculateDailyTotalsForWeek(thisWeeksJobs, weekStart)
      };
      
      console.log('Setting daily totals:', totals);
      console.log('Setting selectedWeekOffset to:', weekOffset);
      setDailyTotals(totals);
      setSelectedWeekOffset(weekOffset);
      setShowDailyTotalsModal(true);
    } catch (error) {
      console.error('Failed to calculate daily totals:', error);
      toast.error('Failed to load job totals. Please try again.');
    }
  };

  // Drill-down functionality
  const handleDrillDown = async (period, value, title, filterType = null, filterValue = null) => {
    try {
      setDrillDownLoading(true);
      console.log('Fetching drill-down data for:', { period, value, title, filterType, filterValue });
      
      // Build query parameters for filtering
      const params = new URLSearchParams();
      if (filterType === 'day') {
        params.append('day', filterValue);
      } else if (filterType === 'paymentMethod') {
        params.append('paymentMethod', filterValue);
      }
      
      const url = `/diary/job-breakdown/${period}/${value}${params.toString() ? '?' + params.toString() : ''}`;
      console.log('Requesting URL:', url);
      
      const response = await axios.get(url);
      console.log('Drill-down response:', response.data);
      console.log('Jobs array:', response.data.jobs);
      console.log('Summary:', response.data.summary);
      if (response.data.jobs && response.data.jobs.length > 0) {
        console.log('First job example:', response.data.jobs[0]);
      }
      
      setDrillDownData({
        ...response.data,
        title,
        period,
        value,
        filterType,
        filterValue
      });
      setShowDrillDown(true);
    } catch (error) {
      console.error('Error fetching drill-down data:', error);
      alert('Failed to load detailed breakdown');
    } finally {
      setDrillDownLoading(false);
    }
  };

  const formatPeriodDisplay = (period, value) => {
    if (period === 'week') {
      return `Week ${value}`;
    } else if (period === 'month') {
      const [year, month] = value.split('-');
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    } else if (period === 'year') {
      return value;
    }
    return value;
  };

  const getCurrentWeekValue = () => {
    const now = new Date();
    const year = now.getFullYear();
    const weekNumber = getWeekNumber(now);
    const weekValue = `${year}-W${String(weekNumber).padStart(2, '0')}`;
    console.log('Current week value:', weekValue, 'for date:', now);
    return weekValue;
  };

  const getSelectedWeekValue = () => {
    const now = new Date();
    const targetDate = new Date(now);
    targetDate.setDate(now.getDate() + (selectedWeekOffset * 7));
    
    const year = targetDate.getFullYear();
    const weekNumber = getWeekNumber(targetDate);
    const weekValue = `${year}-W${String(weekNumber).padStart(2, '0')}`;
    console.log('Selected week value:', weekValue, 'for offset:', selectedWeekOffset, 'target date:', targetDate);
    return weekValue;
  };

  const getTodayValue = () => {
    const today = new Date();
    const todayValue = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    console.log('Today value:', todayValue, 'for date:', today);
    return todayValue;
  };

  const getWeekNumber = (date) => {
    // ISO week calculation
    const target = new Date(date.valueOf());
    const dayNr = (date.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 3);
    const firstThursday = target.valueOf();
    target.setMonth(0, 1);
    if (target.getDay() !== 4) {
      target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }
    return 1 + Math.ceil((firstThursday - target) / 604800000);
  };

  // Helper functions for week navigation
  const goToPreviousWeek = () => {
    const newOffset = selectedWeekOffset - 1;
    // Limit to 52 weeks back (1 year) to prevent date calculation issues
    if (newOffset >= -52) {
      calculateDailyTotals(newOffset);
    } else {
      toast.error('Cannot go back more than 1 year');
    }
  };

  const goToCurrentWeek = () => {
    calculateDailyTotals(0);
  };

  const getWeekDisplayText = (weekOffset) => {
    if (weekOffset === 0) return 'This Week';
    if (weekOffset === -1) return 'Last Week';
    if (weekOffset < -1) return `${Math.abs(weekOffset)} Weeks Ago`;
    return `Week ${weekOffset + 1}`;
  };

  const getWeekDateRange = (weekOffset) => {
    try {
      const now = createSafeDate(new Date());
      const today = createSafeDate(now);
      today.setHours(0, 0, 0, 0);
      
      const weekStart = createSafeDate(today);
      const dayOfWeek = weekStart.getDay();
      const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      weekStart.setDate(weekStart.getDate() - daysToSubtract);
      
      // Apply week offset
      weekStart.setDate(weekStart.getDate() + (weekOffset * 7));
      
      const weekEnd = createSafeDate(weekStart);
      weekEnd.setDate(weekEnd.getDate() + 6);
      
      const formatDate = (date) => date.toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'short' 
      });
      
      return `${formatDate(weekStart)} - ${formatDate(weekEnd)}`;
    } catch (error) {
      console.error('Error calculating week date range:', error);
      return 'Date range unavailable';
    }
  };
  const onChange = e => {
    const { name,value,checked,type } = e.target;
    setForm(f=>({ ...f, [name]: type==='checkbox'?checked:value }));
  };
  const saveEdit = async e => {
  e.preventDefault();
  setMsg('');

  // Validate phone
  if (!form.phone || form.phone.trim() === '') {
    return setMsg('Enter a valid phone.');
  }

  // Convert date to ISO string
  const iso = toISOStringLocal(form.dateTime);

  try {
    setSaving(true);

    // 1️⃣ Update core fields (everything except fare)
    const { fareAmount, ...rest } = form;
    await axios.put(
      `/view-leads/edit/${editLead._id}`,
      { 
        ...rest, 
        dateTime: iso,
        customerPhone2: rest.phone2 || null
      }
    );

    // 2️⃣ If user entered a fare, send it to the fare-patch endpoint
    if (fareAmount?.trim()) {
      await axios.patch(
        `/view-leads/${editLead._id}/fare`,
        { fareAmount }
      );
    }

    // 3️⃣ Update local state for this job, including the new fare
    setJobs(js =>
      js.map(j => {
        if (j._id === editLead._id) {
          return {
            ...j,
            ...rest,
            dateTime: iso,
            customerPhone2: rest.phone2 || null,
            // strip any leading "£" and whitespace
            fareAmount: fareAmount
              ? fareAmount.trim().replace(/^£\s*/, '')
              : j.fareAmount,
            // ensure new fields are included
            dog: form.dog || false,
            disabled: form.disabled || false,
            notes: form.notes || '',
            invoiced: form.invoiced || false,
            paid: form.paid || false,
            waitAndReturn: form.waitAndReturn || false,
            waitHours: form.waitHours || null
          };
        }
        return j;
      })
    );

    // 4️⃣ Clear the edit form
    setForm({});
    closeEdit();
    // 5️⃣ Force accordion re-render to show updated job in correct category
    setAccordionResetKey(prev => prev + 1);
    toast.success('Job updated successfully!');
  } catch (err) {
    console.error('Save failed:', err);
    toast.error(err.response?.data?.message || 'Save failed');
  } finally {
    setSaving(false);
  }
};


  // ── Add-to-Diary handlers ─────────────────────────────
  const handleDiaryChange = (e) => {
    const { name, value, checked, type } = e.target;
    setDiaryData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));

    // Clear auto-detection indicator if phone is manually changed
    if (name === 'phone') {
      setIsPhoneAutoDetected(false);
      setIsContactAutoPopulated(false);
      
      // Debounced search by phone
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      
      if (value && value.trim().length >= 5) { // Search when at least 5 digits entered
        searchTimeoutRef.current = setTimeout(() => {
          searchByContact(value, null);
        }, 800); // Wait 800ms after user stops typing
      }
    }
    
    // Search by email when entered
    if (name === 'email') {
      setIsContactAutoPopulated(false);
      
      // Debounced search by email
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      
      // Check if email looks valid before searching
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && emailPattern.test(value)) {
        searchTimeoutRef.current = setTimeout(() => {
          searchByContact(null, value);
        }, 800); // Wait 800ms after user stops typing
      }
    }
    
    // Clear auto-populated flag if user manually changes name, from, or to
    if (name === 'name' || name === 'from' || name === 'to') {
      if (isContactAutoPopulated) {
        setIsContactAutoPopulated(false);
      }
    }
  };

  // Search customers function
  const searchCustomers = async (query) => {
    try {
      setSearchLoading(true);
      const { data } = await axios.get(`/diary/search-customers?query=${encodeURIComponent(query)}`);
      setSearchResults(data.customers || []);
      setShowSearchResults(data.customers && data.customers.length > 0);
    } catch (err) {
      console.error('Error searching customers:', err);
      setSearchResults([]);
      setShowSearchResults(false);
    } finally {
      setSearchLoading(false);
    }
  };

  // Select customer from search results
  const selectCustomer = (customer) => {
    setDiaryData(d => ({
      ...d,
      name: customer.customerName,
      email: customer.customerEmail,
      phone: customer.customerPhone,
      from: customer.from,
      to: customer.to
    }));
    setShowSearchResults(false);
    setSearchResults([]);
  };

  // Clear Add Job form
  const clearAddJobForm = () => {
    setDiaryData({
      name: '',
      email: 'NoReply@taxi-local.com',
      phone: '',
      phone2: '',
      from: '',
      to: '',
      dateTime: createSafeDate(new Date()),
      passengers: 1,
      returnTrip: false,
      dog: false,
      disabled: false,
      waitAndReturn: false,
      waitHours: null,
      notes: '',
      fareAmount: '',
      groupId: null,
      bookingLinkId: null
    });
    setShowPhone2(false);
    setIsPhoneAutoDetected(false);
    setIsContactAutoPopulated(false);
    setShowSearchResults(false);
    setSearchResults([]);
  };

  // Swap From and To fields in Add Job form
  const swapDiaryFromTo = () => {
    setDiaryData(d => ({
      ...d,
      from: d.to,
      to: d.from
    }));
  };

  // Swap From and To fields in Edit Job form
  const swapEditFromTo = () => {
    setForm(f => ({
      ...f,
      from: f.to,
      to: f.from
    }));
  };
  
  // Search by exact phone or email match
  const searchByContact = async (phone, email) => {
    try {
      // Build query parameters
      const params = new URLSearchParams();
      if (phone && phone.trim() !== '') {
        params.append('phone', phone.trim());
      }
      if (email && email.trim() !== '') {
        params.append('email', email.trim());
      }
      
      if (params.toString() === '') {
        return; // No search criteria
      }
      
      const { data } = await axios.get(`/diary/search-by-contact?${params.toString()}`);
      
      if (data.found && data.customer) {
        // Auto-populate all fields from the found customer
        setDiaryData(d => ({
          ...d,
          name: data.customer.customerName || d.name,
          email: data.customer.customerEmail || d.email,
          phone: data.customer.customerPhone || d.phone,
          from: data.customer.from || d.from,
          to: data.customer.to || d.to
        }));
        setIsContactAutoPopulated(true);
        toast.success(`Customer found: ${data.customer.customerName}`, {
          position: 'top-center',
          autoClose: 2000
        });
      } else {
        setIsContactAutoPopulated(false);
      }
      
      // Check for reviews and blacklist status
      try {
        const reviewParams = new URLSearchParams();
        if (phone && phone.trim() !== '') {
          reviewParams.append('phone', phone.trim());
        }
        if (email && email.trim() !== '') {
          reviewParams.append('email', email.trim());
        }
        
        const [reviewResponse, blacklistResponse] = await Promise.all([
          axios.get(`/customer-reviews/customer?${reviewParams.toString()}`),
          axios.get(`/customer-reviews/blacklist/check?${reviewParams.toString()}`)
        ]);
        
        // Show star rating in toast if exists
        if (reviewResponse.data.totalReviews > 0) {
          const avg = reviewResponse.data.averageRating;
          const stars = '⭐'.repeat(Math.round(avg));
          toast.info(`Customer Rating: ${stars} (${avg.toFixed(1)}/5 from ${reviewResponse.data.totalReviews} review${reviewResponse.data.totalReviews > 1 ? 's' : ''})`, {
            position: 'top-center',
            autoClose: 4000
          });
        }
        
        // Show blacklist warning modal if blacklisted
        if (blacklistResponse.data.isBlacklisted && blacklistResponse.data.blacklist) {
          setBlacklistWarningData(blacklistResponse.data.blacklist);
          setShowBlacklistWarning(true);
        }
      } catch (reviewErr) {
        console.error('Error checking reviews/blacklist:', reviewErr);
        // Non-fatal - continue with job creation
      }
    } catch (err) {
      console.error('Error searching by contact:', err);
      setIsContactAutoPopulated(false);
    }
  };
  
  // Journey Estimator functions
  const calculateFare = (miles, tariffs) => {
    const fares = {};
    Object.entries(tariffs).forEach(([key, t]) => {
      const extra = miles > 1 ? (miles - 1) * t.subsequentMile : 0;
      fares[key] = Math.round(t.firstMile + extra);
    });
    return fares;
  };

  const handleEstimateJourney = async () => {
    if (!estimatorFrom || !estimatorTo) {
      toast.error('Please enter both From and To locations');
      return;
    }

    // Check if Google Maps is loaded
    if (!isGoogleMapsLoaded) {
      toast.error('Google Maps is still loading. Please wait a moment and try again.');
      return;
    }

    if (googleMapsLoadError) {
      toast.error('Google Maps failed to load. Please refresh the page and try again.');
      return;
    }

    setEstimatorCalculating(true);
    
    try {
      // Double-check Google Maps is available
      if (!window.google || !window.google.maps || !window.google.maps.DirectionsService) {
        toast.error('Google Maps is not available. Please refresh the page and try again.');
        setEstimatorCalculating(false);
        return;
      }

      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route({
        origin: estimatorFrom,
        destination: estimatorTo,
        travelMode: window.google.maps.TravelMode.DRIVING
      }, (response, status) => {
        if (status === 'OK' && response.routes[0]?.legs[0]) {
          const leg = response.routes[0].legs[0];
          const miles = leg.distance.value / 1609.34;
          const mins = leg.duration.value / 60;
          
          // Get the appropriate council tariff
          const councilKey = councils[driverLicensingAuthority] ? driverLicensingAuthority : 'Default';
          const tariffs = councils[councilKey].tariffs;
          
          setEstimatorDistance(miles);
          setEstimatorDuration(mins);
          setEstimatorFares(calculateFare(miles, tariffs));
          setEstimatorCalculated(true);
        } else {
          toast.error('Could not calculate route. Please check the addresses.');
        }
        setEstimatorCalculating(false);
      });
    } catch (error) {
      console.error('Error calculating route:', error);
      toast.error('Error calculating route. Please try again.');
      setEstimatorCalculating(false);
    }
  };

  const handleAcceptEstimate = () => {
    // Populate the Add to Diary form with estimated journey details
    // Clean addresses before storing (they should already be cleaned, but ensure it)
    setDiaryData(d => ({
      ...d,
      from: cleanGoogleMapsAddress(estimatorFrom),
      to: cleanGoogleMapsAddress(estimatorTo),
      fareAmount: `£${estimatorFares.tariff1}`
    }));
    
    // Close estimator modal
    setShowJourneyEstimator(false);
    
    // Reset estimator state
    setEstimatorFrom('');
    setEstimatorTo('');
    setEstimatorDistance(0);
    setEstimatorDuration(0);
    setEstimatorFares({});
    setEstimatorCalculated(false);
    
    // Clear autocomplete refs
    fromAutocompleteRef.current = null;
    toAutocompleteRef.current = null;
    
    toast.success('Journey details added to form');
  };

  const handleDiaryPhoneChange = v => setDiaryData(d=>({ ...d, phone: v||'' }));
  const handleDiaryPhone2Change = v => setDiaryData(d=>({ ...d, phone2: v||'' }));
  const handleDiarySubmit = async e => {
    e.preventDefault();
    if (!diaryData.phone || diaryData.phone.trim() === '') return setMsg('Enter a valid phone.');
    const iso = toISOStringLocal(diaryData.dateTime);
    try {
      if (createSafeDate(iso) < createSafeDate(new Date())) return setMsg('Date must be future.');
    } catch (error) {
      console.warn('Error validating date:', error);
      return setMsg('Invalid date format.');
    }
    try {
      setDiaryLoading(true);
      await axios.post('/diary/add-entry', {
        customerName: diaryData.name,
        customerEmail: diaryData.email,
        customerPhone: diaryData.phone,
        customerPhone2: diaryData.phone2 || null,
        from: diaryData.from,
        to: diaryData.to,
        dateTime: iso,
        passengers: diaryData.passengers,
        returnTrip: diaryData.returnTrip,
        dog: diaryData.dog || false,
        disabled: diaryData.disabled || false,
        notes: diaryData.notes || '',
        // Pass groupId and bookingLinkId for return journeys
        groupId: diaryData.groupId || null,
        bookingLinkId: diaryData.bookingLinkId || null,
        // Wait and Return fields
        waitAndReturn: diaryData.waitAndReturn || false,
        waitHours: diaryData.waitHours || null
      });
      
      // Refresh the jobs list instead of reloading the page
      const me = localStorage.getItem('userId');
      const { data } = await axios.get('/view-leads');
      setJobs(
        data
          .filter(l => l.status === 'accepted' && l.acceptedBy?._id === me)
          .sort((a,b)=> {
            try {
              const dateA = createSafeDate(a.dateTime);
              const dateB = createSafeDate(b.dateTime);
              return dateA - dateB;
            } catch (error) {
              console.warn('Error sorting jobs by date:', error);
              return 0;
            }
          })
      );
      
      setShowAdd(false);
      setDiaryData({
        name:'', email:'NoReply@taxi-local.com', phone:'', phone2:'', from:'', to:'',
        dateTime:createSafeDate(new Date()), passengers:1, returnTrip:true,
        groupId: null, bookingLinkId: null, waitAndReturn: false, waitHours: null
      });
      setShowPhone2(false);
      setMsg('Diary entry added successfully!');
    } catch (err) {
      console.error('Diary add failed:', err);
      setMsg(err.response?.data?.error || 'Diary add failed.');
    } finally {
      setDiaryLoading(false);
    }
  };

  // ── Return handlers ───────────────────────────────────
  const openReturn = j => {
    if (jobs.find(k=>k.groupId===j._id)) {
      return setMsg('Return exists');
    }
    // Use the Add Job form instead of the old Return modal
    setDiaryData({
      name: j.customerName || j.name || '',
      email: j.customerEmail || j.email || '',
      phone: j.customerPhone || j.phone || '',
      phone2: j.customerPhone2 || j.phone2 || '',
      from: j.to || '',
      to: j.from || '',
      dateTime: createSafeDate(j.dateTime),
      passengers: j.passengers || 1,
      returnTrip: true,
      // Store the original job's ID and booking link ID for return journey creation
      groupId: j._id,
      bookingLinkId: j.bookingLinkId,
      waitAndReturn: j.waitAndReturn || false,
      waitHours: j.waitHours || null
    });
    setShowPhone2(!!(j.customerPhone2 || j.phone2));
    setShowAdd(true);
  };
  // Legacy return handlers removed

  // ── Send Diary via Email ─────────────────────────────
  const handleSendEmail = async () => {
    try {
      await axios.post('/diary/send-email', { entries: jobs });
      toast.success('Email sent successfully!');
    } catch (error) {
      toast.error('Failed to send email');
    }
  };

  // ── Send Confirmation Email ──────────────────────────
  const handleSendConfirmationEmail = async (jobId, customerEmail) => {
    try {
      setSendingEmails(prev => new Set(prev).add(jobId));
      
      await axios.post('/leads/email', {
        leadId: jobId,
        email: customerEmail
      });
      
      toast.success('Confirmation email sent successfully!');
    } catch (error) {
      console.error('Error sending confirmation email:', error);
      toast.error('Failed to send confirmation email');
    } finally {
      setSendingEmails(prev => {
        const newSet = new Set(prev);
        newSet.delete(jobId);
        return newSet;
      });
    }
  };

  // ── SMS Templates State ──────────────────────────
  const [smsTemplates, setSmsTemplates] = useState([]);

  // Load SMS templates on component mount
  useEffect(() => {
    const loadSmsTemplates = async () => {
      try {
        const response = await axios.get('/sms-templates/active');
        setSmsTemplates(response.data);
      } catch (error) {
        console.error('Error loading SMS templates:', error);
      }
    };
    loadSmsTemplates();
  }, []);

  // ── Send SMS with Template ──────────────────────────
  const handleSendSmsWithTemplate = (job, customerPhone, template) => {
    const ukDateTime = new Date(job.dateTime).toLocaleString('en-GB', {
      day: '2-digit', month: '2-digit', year: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Europe/London'
    });
    
    // Debug: Log payment methods data
    console.log('🔍 Payment Methods Debug:', {
      jobId: job._id,
      driverId: job.acceptedBy?._id,
      driverName: job.acceptedBy?.name,
      paymentMethods: job.acceptedBy?.paymentMethods,
      paymentMethodsType: typeof job.acceptedBy?.paymentMethods,
      isArray: Array.isArray(job.acceptedBy?.paymentMethods),
      length: job.acceptedBy?.paymentMethods?.length
    });
    
    // More robust payment methods handling
    let paymentMethodsDisplay = 'Cash'; // Default fallback
    
    if (job.acceptedBy?.paymentMethods) {
      if (Array.isArray(job.acceptedBy.paymentMethods)) {
        paymentMethodsDisplay = job.acceptedBy.paymentMethods.length > 0 
          ? job.acceptedBy.paymentMethods.join(', ') 
          : 'Cash';
      } else if (typeof job.acceptedBy.paymentMethods === 'string') {
        // Handle case where it might be a single string
        paymentMethodsDisplay = job.acceptedBy.paymentMethods;
      } else {
        console.warn('Unexpected paymentMethods format:', job.acceptedBy.paymentMethods);
        paymentMethodsDisplay = 'Cash';
      }
    }

    // Replace placeholders in the template
    const driverFirstName = job.acceptedBy?.name?.split(' ')[0] || 'Driver';
    const companyName = job.acceptedBy?.companyName || '';
    const driverDisplayName = companyName ? `${driverFirstName} (${companyName})` : driverFirstName;
    
    let smsMessage = template.message
      .replace(/{driverName}/g, driverDisplayName)
      .replace(/{driverPhone}/g, job.acceptedBy?.phoneNumber || 'N/A')
      .replace(/{from}/g, job.from || 'N/A')
      .replace(/{to}/g, job.to || 'N/A')
      .replace(/{dateTime}/g, ukDateTime)
      .replace(/{passengers}/g, job.passengers || 'N/A')
      .replace(/{fareAmount}/g, job.fareAmount ? `Cost: £${job.fareAmount}` : '')
      .replace(/{paymentMethods}/g, paymentMethodsDisplay)
      .replace(/{eta}/g, '5-10 minutes') // Default ETA
      .replace(/{newEta}/g, '10-15 minutes'); // Default new ETA

    const templateNameLower = (template?.name || template?.title || '').toLowerCase();
    if (templateNameLower === 'taxi on way') {
      const rawPhone =
        job.customerPhone ||
        job.customer?.phoneNumber ||
        customerPhone ||
        '';
      const digitsOnly = (rawPhone || '').replace(/\D+/g, '');
      const encodedPhone = encodeURIComponent(digitsOnly);
      const baseUrl = `${window.location.origin}/where-is-my-taxi`;
      const trackingUrl = encodedPhone ? `${baseUrl}?phone=${encodedPhone}` : baseUrl;
      smsMessage = `${smsMessage.trim()}\n\nTrack your driver: ${trackingUrl}`;
    }

    // Enhanced SMS handling with multiple fallback options
    sendSMSWithFallback(customerPhone, smsMessage, template.title);
  };

  // ── Enhanced SMS Function with Fallback Options ──────────────────────────
  const sendSMSWithFallback = (phoneNumber, message, templateName) => {
    // Clean phone number (remove spaces, dashes, etc.)
    const cleanPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');
    
    // Better mobile detection - check multiple indicators
    const isMobile = () => {
      // Check user agent
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone', 'mobile'];
      const hasMobileUserAgent = mobileKeywords.some(keyword => userAgent.includes(keyword));
      
      // Check screen size
      const isSmallScreen = window.innerWidth <= 768;
      
      // Check touch capability
      const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Check if running in a mobile app wrapper (like Capacitor, Cordova)
      const isInApp = window.cordova || window.Capacitor || window.ionic;
      
      console.log('📱 Mobile Detection:', {
        userAgent: navigator.userAgent,
        hasMobileUserAgent,
        isSmallScreen,
        hasTouchScreen,
        isInApp,
        maxTouchPoints: navigator.maxTouchPoints,
        innerWidth: window.innerWidth
      });
      
      // Consider it mobile if it has mobile user agent OR (small screen AND touch capability)
      return hasMobileUserAgent || (isSmallScreen && hasTouchScreen) || isInApp;
    };
    
    const mobile = isMobile();
    
    console.log('🔍 SMS Debug:', {
      phoneNumber,
      cleanPhone,
      message,
      templateName,
      isMobile: mobile,
      userAgent: navigator.userAgent,
      screenWidth: window.innerWidth,
      hasTouch: 'ontouchstart' in window,
      maxTouchPoints: navigator.maxTouchPoints
    });
    
    // Try multiple SMS methods in order of preference
    const smsMethods = [
      // Method 1: SMS protocol (only on mobile)
      () => {
        if (!mobile) {
          console.log('📱 Skipping SMS protocol - not on mobile device');
          return false;
        }
        
        const smsLink = `sms:${cleanPhone}?body=${encodeURIComponent(message)}`;
        console.log('📱 Trying SMS link:', smsLink);
        
        const link = document.createElement('a');
        link.href = smsLink;
        link.textContent = 'Text Us';
        link.style.display = 'none';
        link.target = '_blank';
        
        // Add to DOM temporarily
        document.body.appendChild(link);
        
        // Try to click it
        try {
          link.click();
          console.log('✅ SMS link clicked successfully');
          return true;
        } catch (error) {
          console.warn('❌ SMS link click failed:', error);
          return false;
        } finally {
          // Clean up
          document.body.removeChild(link);
        }
      },
      
      // Method 2: WhatsApp (works on both mobile and desktop)
      () => {
        const whatsappLink = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
        console.log('📱 Trying WhatsApp with:', whatsappLink);
        window.open(whatsappLink, '_blank');
        return true;
      },
      
      // Method 3: Copy to clipboard with instructions (best for desktop)
      () => {
        const fullMessage = `To: ${cleanPhone}\n\n${message}`;
        console.log('📱 Falling back to clipboard copy');
        
        navigator.clipboard.writeText(fullMessage).then(() => {
          if (mobile) {
            alert(`📱 SMS Template "${templateName}" copied to clipboard!\n\nPhone: ${cleanPhone}\n\nPlease paste this into your SMS app.`);
          } else {
            alert(`📱 SMS Template "${templateName}" copied to clipboard!\n\nPhone: ${cleanPhone}\n\nSince you're on desktop, please:\n1. Copy this message\n2. Use your phone to send the SMS\n3. Or use WhatsApp Web if available`);
          }
        }).catch(() => {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = fullMessage;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          
          if (mobile) {
            alert(`📱 SMS Template "${templateName}" copied to clipboard!\n\nPhone: ${cleanPhone}\n\nPlease paste this into your SMS app.`);
          } else {
            alert(`📱 SMS Template "${templateName}" copied to clipboard!\n\nPhone: ${cleanPhone}\n\nSince you're on desktop, please:\n1. Copy this message\n2. Use your phone to send the SMS\n3. Or use WhatsApp Web if available`);
          }
        });
        return true;
      }
    ];
    
    // Try each method until one works
    for (let i = 0; i < smsMethods.length; i++) {
      try {
        console.log(`🔄 Trying SMS method ${i + 1}`);
        if (smsMethods[i]()) {
          console.log(`✅ SMS method ${i + 1} succeeded for template: ${templateName}`);
          return;
        }
      } catch (error) {
        console.warn(`❌ SMS method ${i + 1} failed:`, error);
        continue;
      }
    }
    
    // If all methods fail, show error message
    console.error('❌ All SMS methods failed');
    if (mobile) {
      alert(`❌ Unable to send SMS for template "${templateName}".\n\nPhone: ${cleanPhone}\n\nPlease manually send the message to the customer.`);
    } else {
      alert(`❌ Unable to send SMS for template "${templateName}".\n\nPhone: ${cleanPhone}\n\nSince you're on desktop, please use your phone to send the SMS manually.`);
    }
  };

  // ── Send Confirmation SMS ──────────────────────────
  const handleSendConfirmationSMS = (job, customerPhone) => {
    const ukDateTime = new Date(job.dateTime).toLocaleString('en-GB', {
      day: '2-digit', month: '2-digit', year: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'Europe/London'
    });
    
    // Debug: Log payment methods data
    console.log('🔍 Payment Methods Debug (Confirmation):', {
      jobId: job._id,
      driverId: job.acceptedBy?._id,
      driverName: job.acceptedBy?.name,
      paymentMethods: job.acceptedBy?.paymentMethods,
      paymentMethodsType: typeof job.acceptedBy?.paymentMethods,
      isArray: Array.isArray(job.acceptedBy?.paymentMethods),
      length: job.acceptedBy?.paymentMethods?.length
    });
    
    // More robust payment methods handling
    let paymentMethodsDisplay = 'Cash'; // Default fallback
    
    if (job.acceptedBy?.paymentMethods) {
      if (Array.isArray(job.acceptedBy.paymentMethods)) {
        paymentMethodsDisplay = job.acceptedBy.paymentMethods.length > 0 
          ? job.acceptedBy.paymentMethods.join(', ') 
          : 'Cash';
      } else if (typeof job.acceptedBy.paymentMethods === 'string') {
        // Handle case where it might be a single string
        paymentMethodsDisplay = job.acceptedBy.paymentMethods;
      } else {
        console.warn('Unexpected paymentMethods format:', job.acceptedBy.paymentMethods);
        paymentMethodsDisplay = 'Cash';
      }
    }

    const smsMessage = `🚕 Taxi Confirmed!
Driver: ${job.acceptedBy?.name} (${job.acceptedBy?.phoneNumber})
From: ${job.from}
To: ${job.to}
Date: ${ukDateTime}
Passengers: ${job.passengers}
${job.fareAmount ? `Cost: £${job.fareAmount}` : ''}
Payment: ${paymentMethodsDisplay}

⚠️ IMPORTANT: Any variation to this booking must be made verbally to the driver directly. Do not text, email or leave answerphone messages as drivers may not be able to respond immediately.

Safe travels! 🚗`;

    // Enhanced SMS handling with multiple fallback options
    sendSMSWithFallback(customerPhone, smsMessage, 'Quick Confirmation');
  };

  // Advanced search removed (simple inline filter used instead)

  // Handle scroll to control sticky header
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsHeaderSticky(scrollTop > 100); // Only sticky after scrolling 100px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Advanced search UI/handlers removed

  // ── Handshake job to another driver ──────────────────
  const handleHandshake = async (jobId, targetDriverId) => {
    try {
      await axios.post(`/view-leads/handshake/${jobId}`, { 
        targetDriverId,
        handshakeType: 'offer'
      });
      
      // Add to handshake jobs for highlighting
      setHandshakeJobs(prev => [...prev, { jobId, targetDriverId, status: 'pending' }]);
      
      setHandshakeAction(null);
      setSelectedHandshakeDriver('');
      setMsg('Job handshake sent successfully.');
      toast.success('Job handshake sent!');
    } catch (err) {
      console.error('Failed to send handshake:', err);
      setMsg('Failed to send handshake.');
      toast.error('Failed to send handshake.');
    }
  };

  // ── Accept handshake offer ───────────────────────────
  const acceptHandshake = async (jobId, fromDriverId) => {
    try {
      await axios.post(`/view-leads/handshake/${jobId}/accept`, { 
        fromDriverId 
      });
      
      // Remove from handshake jobs
      setHandshakeJobs(prev => prev.filter(h => h.jobId !== jobId));
      // Refresh the incoming list
      try { await loadIncomingHandshakes(); } catch {}
      
      setMsg('Handshake accepted successfully.');
      toast.success('Handshake accepted!');
    } catch (err) {
      console.error('Failed to accept handshake:', err);
      setMsg('Failed to accept handshake.');
      toast.error('Failed to accept handshake.');
    }
  };

  // ── Decline handshake offer ──────────────────────────
  const declineHandshake = async (jobId, fromDriverId) => {
    try {
      await axios.post(`/view-leads/handshake/${jobId}/decline`, { 
        fromDriverId 
      });
      
      // Remove from handshake jobs
      setHandshakeJobs(prev => prev.filter(h => h.jobId !== jobId));
      // Refresh the incoming list
      try { await loadIncomingHandshakes(); } catch {}
      
      setMsg('Handshake declined.');
      toast.info('Handshake declined.');
    } catch (err) {
      console.error('Failed to decline handshake:', err);
      setMsg('Failed to decline handshake.');
      toast.error('Failed to decline handshake.');
    }
  };

  // ── Accept booking link job ──────────────────────────
  const handleAcceptBookingLinkJob = async (jobId) => {
    try {
      const response = await axios.put(`/leads/${jobId}`, {
        dateAccepted: new Date().toISOString()
      });
      
      // Remove from unprocessed MyLink jobs if it exists
      try {
        const { removeUnprocessedJob } = await import('./MyLinkJobPopup');
        removeUnprocessedJob(jobId);
      } catch (err) {
        // Ignore if module not available
      }
      
      toast.success('Booking link job accepted!');
      
      // Update the local state immediately for better UX
      const newAcceptedAt = new Date().toISOString();
      
      const currentUserId = localStorage.getItem('userId');
      
      setJobs(prevJobs => {
        const updatedJobs = prevJobs.map(job => 
          job._id === jobId 
            ? { ...job, acceptedAt: newAcceptedAt, status: 'accepted', acceptedBy: { _id: currentUserId } } // Ensure status is also 'accepted' and set acceptedBy
            : job
        );
        return updatedJobs;
      });
      
      // Also update filtered jobs to ensure consistency
      setFilteredJobs(prevFilteredJobs => 
        prevFilteredJobs.map(job => 
          job._id === jobId 
            ? { ...job, acceptedAt: newAcceptedAt, status: 'accepted', acceptedBy: { _id: currentUserId } } // Ensure status is also 'accepted' and set acceptedBy
            : job
        )
      );
      
      // Force accordion re-render to show updated job in correct category and close all accordions
      setAccordionResetKey(prev => prev + 1);
      
    } catch (err) {
      console.error('Failed to accept booking link job:', err);
      toast.error('Failed to accept booking link job.');
    }
  };

  // ── Decline booking link/web-link job ──────────────────────────
  const handleDeclineBookingLinkJob = async (jobId) => {
    try {
      // Find the job to determine if it's a booking link or web-link job
      const job = jobs.find(j => j._id === jobId);
      let cancellationReason = 'Declined by driver from booking link';
      
      // Check if it's a web-link job (not manual, not dispatcher, not booking link)
      // Also check if it's a WebLink assigned job (webLinkAssignedToDrivers array)
      if (job && (job.webLinkAssignedToDrivers?.length > 0 || (!job.bookingLinkId && !job.createdByDispatcher && !job.isManualDiaryEntry))) {
        cancellationReason = 'Declined by driver from web-link';
      }
      
      await axios.put(`/leads/${jobId}`, {
        status: 'cancelled',
        cancellationReason: cancellationReason
      });
      
      toast.success('Job declined. Customer will be notified by email.');
      
      // Remove the job from local state immediately for better UX
      setJobs(prevJobs => prevJobs.filter(job => job._id !== jobId));
      
      // Also remove from filtered jobs to ensure consistency
      setFilteredJobs(prevFilteredJobs => prevFilteredJobs.filter(job => job._id !== jobId));
    } catch (err) {
      console.error('Failed to decline job:', err);
      toast.error('Failed to decline job. Please try again.');
    }
  };

  // ── Accept reassigned job ──────────────────────────
  const handleAcceptReassignedJob = async (jobId) => {
    try {
      const response = await axios.put(`/leads/${jobId}`, {
        dateAccepted: new Date().toISOString()
      });
      
      toast.success('Reassigned job accepted!');
      
      // Update the local state immediately for better UX
      const newAcceptedAt = new Date().toISOString();
      
      const currentUserId = localStorage.getItem('userId');
      
      setJobs(prevJobs => {
        const updatedJobs = prevJobs.map(job => 
          job._id === jobId 
            ? { ...job, acceptedAt: newAcceptedAt, status: 'accepted', acceptedBy: { _id: currentUserId } }
            : job
        );
        return updatedJobs;
      });
      
      // Also update filtered jobs to ensure consistency
      setFilteredJobs(prevFilteredJobs => 
        prevFilteredJobs.map(job => 
          job._id === jobId 
            ? { ...job, acceptedAt: newAcceptedAt, status: 'accepted', acceptedBy: { _id: currentUserId } }
            : job
        )
      );
      
      // Refresh the diary for real-time synchronization
      setTimeout(() => {
        console.log('🔄 Refreshing diary after accepting reassigned job');
        refreshDiary();
      }, 1000);
      
    } catch (err) {
      console.error('Failed to accept reassigned job:', err);
      toast.error('Failed to accept reassigned job.');
    }
  };

  // ── Decline reassigned job ──────────────────────────
  const handleDeclineReassignedJob = async (jobId) => {
    try {
      console.log('🔄 Attempting to decline reassigned job:', jobId);
      const response = await axios.put(`/leads/${jobId}`, {
        status: 'cancelled',
        cancellationReason: 'Declined by driver from reassignment'
      });
      
      console.log('✅ Decline response:', response.data);
      toast.success('Reassigned job declined.');
      
      // Refresh the diary for real-time synchronization
      setTimeout(() => {
        console.log('🔄 Refreshing diary after declining reassigned job');
        refreshDiary();
      }, 1000);
    } catch (err) {
      console.error('❌ Failed to decline reassigned job:', err);
      console.error('❌ Error response:', err.response?.data);
      console.error('❌ Error status:', err.response?.status);
      toast.error('Failed to decline reassigned job.');
    }
  };

  // ── Handle handshake events ───────────────────────────
  useEffect(() => {
    // Listen for handshake events from server
    const handleHandshakeSent = (data) => {
      // Only add to handshake jobs if current user is the receiver (toDriver)
      if (data.toDriver === localStorage.getItem('userId')) {
        setHandshakeJobs(prev => [...prev, { 
          jobId: data.leadId, 
          fromDriverId: data.fromDriver, 
          status: 'pending' 
        }]);
        // Also refresh full list for explicit rendering
        try { loadIncomingHandshakes(); } catch {}
      }
    };

    const handleHandshakeAccepted = (data) => {
      setHandshakeJobs(prev => prev.filter(h => h.jobId !== data.leadId));
      // Refresh jobs to show updated status
      setTimeout(() => {
        console.log('🔄 Refreshing diary after handshake accepted');
        refreshDiary();
      }, 1000);
    };

    const handleHandshakeDeclined = (data) => {
      setHandshakeJobs(prev => prev.filter(h => h.jobId !== data.leadId));
    };

    // Handle reassigned job acceptance - refresh entire diary for real-time sync
    const handleReassignedJobAccepted = (data) => {
      // If this is the original driver who reassigned the job, refresh the entire diary
      if (data.reassignedBy === localStorage.getItem('userId')) {
        console.log('🔄 Reassigned job accepted - refreshing diary for real-time sync');
        refreshDiary();
        toast.info('Reassigned job has been accepted by the receiving driver.');
      }
    };

    // Handle reassigned job decline - refresh entire diary for real-time sync
    const handleReassignedJobDeclined = (data) => {
      // If this is the original driver who reassigned the job, refresh the entire diary
      if (data.reassignedBy === localStorage.getItem('userId')) {
        console.log('🔄 Reassigned job declined - refreshing diary for real-time sync');
        refreshDiary();
        toast.info('Reassigned job has been declined by the receiving driver.');
      }
    };

    // Add event listeners if socket is available
    if (window.socket) {
      window.socket.on('handshake-sent', handleHandshakeSent);
      window.socket.on('handshake-accepted', handleHandshakeAccepted);
      window.socket.on('handshake-declined', handleHandshakeDeclined);
      window.socket.on('reassigned-job-accepted', handleReassignedJobAccepted);
      window.socket.on('reassigned-job-declined', handleReassignedJobDeclined);
    }

    return () => {
      if (window.socket) {
        window.socket.off('handshake-sent', handleHandshakeSent);
        window.socket.off('handshake-accepted', handleHandshakeAccepted);
        window.socket.off('handshake-declined', handleHandshakeDeclined);
        window.socket.off('reassigned-job-accepted', handleReassignedJobAccepted);
        window.socket.off('reassigned-job-declined', handleReassignedJobDeclined);
      }
    };
  }, []);

  // ── Wait and Return Handlers ──────────────────────────
  const handleWaitAndReturnChange = async (jobId, isWaitAndReturn) => {
    try {
      await axios.patch(`${process.env.REACT_APP_API_URL}/api/leads/${jobId}/wait-return`, {
        waitAndReturn: isWaitAndReturn,
        waitHours: isWaitAndReturn ? 4.5 : null // Default to 4.5 hours if enabling
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Update local state
      setJobs(prevJobs => prevJobs.map(job => 
        job._id === jobId 
          ? { ...job, waitAndReturn: isWaitAndReturn, waitHours: isWaitAndReturn ? 4.5 : null }
          : job
      ));
      
      toast.success(`Wait and Return ${isWaitAndReturn ? 'enabled' : 'disabled'}`);
    } catch (error) {
      console.error('Error updating wait and return:', error);
      toast.error('Failed to update wait and return setting');
    }
  };

  const handleWaitHoursChange = async (jobId, hours) => {
    try {
      await axios.patch(`${process.env.REACT_APP_API_URL}/api/leads/${jobId}/wait-return`, {
        waitHours: hours
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Update local state
      setJobs(prevJobs => prevJobs.map(job => 
        job._id === jobId 
          ? { ...job, waitHours: hours }
          : job
      ));
    } catch (error) {
      console.error('Error updating wait hours:', error);
      toast.error('Failed to update wait hours');
    }
  };

  const calculateReturnTime = (pickupTime, waitHours) => {
    try {
      const pickup = new Date(pickupTime);
      const returnTime = new Date(pickup.getTime() + (waitHours * 60 * 60 * 1000));
      return returnTime.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      console.error('Error calculating return time:', error);
      return 'Invalid time';
    }
  };

  return (
    <>
      <ToastContainer position="top-center" />
              <div className="container mt-0" style={{ marginTop: '120px', paddingTop: '80px' }}>
        {/* Fixed Header - Page Content Only */}
        <div className="position-fixed border-bottom shadow-sm" style={{ 
          zIndex: 1029,
          top: '50px', // Position below the main navbar
          left: '0',
          right: '0',
          paddingTop: '8px',
          paddingBottom: '0px',
          borderTop: '2px solid #f8f9fa',
          backgroundColor: '#ffffff' // White background for day mode
        }}>
          <div className="container">
                <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: 'nowrap' }}>
              <div style={{ minWidth: 'fit-content' }}>
                <h4 
                  className="mb-0" 
                  onClick={async () => {
                    console.log('🔄 My Diary header clicked - refreshing...');
                    try {
                      // Refresh diary data - this will automatically check for MyLink jobs
                      const refreshResult = await refreshDiary();
                      
                      // Wait a moment for state to update, then check for waiting jobs
                      setTimeout(async () => {
                        // Use the jobs from refreshResult if available, otherwise use current state
                        const jobsToCheck = refreshResult?.uniqueJobs || jobs;
                        const handshakesToCheck = refreshResult?.loadedIncomingHandshakes || [];
                        
                        // Check for waiting jobs after refresh
                        const waitingJobsData = checkForWaitingJobs(jobsToCheck, handshakesToCheck);
                        if (waitingJobsData.totalCount > 0) {
                          notifyAboutWaitingJobs(waitingJobsData);
                        }
                      }, 500);
                    } catch (error) {
                      console.error('Error refreshing My Diary:', error);
                    }
                  }}
                  style={{ 
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(1.2rem, 4vw, 1.5rem)', // Responsive font size that scales down on smaller screens
                    cursor: 'pointer',
                    userSelect: 'none',
                    transition: 'opacity 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.opacity = '0.7'}
                  onMouseLeave={(e) => e.target.style.opacity = '1'}
                  title="Click to refresh My Diary and check for jobs waiting for action"
                >My Diary</h4>
              </div>
              <div className="d-flex align-items-center" style={{ 
                flexShrink: 0,
                marginLeft: '0.5rem', // Small gap between title and buttons
                gap: 'clamp(0.25rem, 1vw, 0.5rem)' // Responsive gap that gets smaller on mobile
              }}>
                <Button 
                  variant={locationTracking ? "success" : "danger"}
                  onClick={locationTracking ? stopLocationTracking : startLocationTracking}
                  title={locationTracking ? "Stop Location Tracking" : "Start Location Tracking"}
                  size="sm"
                  style={{
                    backgroundColor: locationTracking ? '#28a745' : '#dc3545',
                    borderColor: locationTracking ? '#28a745' : '#dc3545',
                    color: 'white',
                    padding: 'clamp(0.5rem, 2vw, 0.75rem) clamp(0.75rem, 3vw, 1rem)', // Larger mobile-friendly padding
                    fontSize: 'clamp(1rem, 3vw, 1.1rem)', // Larger mobile-friendly font size
                    minWidth: 'clamp(44px, 10vw, 48px)', // Ensure minimum touch target size
                    minHeight: 'clamp(44px, 10vw, 48px)'
                  }}
                >
                  {locationTracking ? "🏃" : "🚶"}
                </Button>
                <Button 
                  onClick={() => setShowDiaryModal(true)} 
                  title="View Upcoming Summary"
                  size="sm"
                  style={{
                    padding: 'clamp(0.5rem, 2vw, 0.75rem) clamp(0.75rem, 3vw, 1rem)', // Larger mobile-friendly padding
                    fontSize: 'clamp(1rem, 3vw, 1.1rem)', // Larger mobile-friendly font size
                    minWidth: 'clamp(44px, 10vw, 48px)', // Ensure minimum touch target size
                    minHeight: 'clamp(44px, 10vw, 48px)'
                  }}
                >
                  📖
                </Button>
                <Button 
                  onClick={() => calculateDailyTotals(0)} 
                  title="Daily Job Totals" 
                  variant="info"
                  size="sm"
                  style={{
                    padding: 'clamp(0.5rem, 2vw, 0.75rem) clamp(0.75rem, 3vw, 1rem)', // Larger mobile-friendly padding
                    fontSize: 'clamp(1rem, 3vw, 1.1rem)', // Larger mobile-friendly font size
                    minWidth: 'clamp(44px, 10vw, 48px)', // Ensure minimum touch target size
                    minHeight: 'clamp(44px, 10vw, 48px)'
                  }}
                >
                  📊
                </Button>
                <Button 
                  variant="success" 
                  onClick={() => setShowAdd(true)} 
                  title="Add to Diary"
                  size="sm"
                  style={{
                    padding: 'clamp(0.5rem, 2vw, 0.75rem) clamp(0.75rem, 3vw, 1rem)', // Larger mobile-friendly padding
                    fontSize: 'clamp(1rem, 3vw, 1.1rem)', // Larger mobile-friendly font size
                    minWidth: 'clamp(44px, 10vw, 48px)', // Ensure minimum touch target size
                    minHeight: 'clamp(44px, 10vw, 48px)'
                  }}
                >
                  ➕
                </Button>
              </div>
            </div>
            
            {/* Search Bar below icons */}
            <div className="mt-2 position-relative" style={{ maxWidth: 500 }}>
                  <Form.Control
                    type="text"
                placeholder="Search by customer name, phone, email, route, notes, or date..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                    size="sm"
                style={{ 
                  paddingRight: '2rem',
                  fontSize: '0.875rem' // Slightly smaller text
                }}
              />
              {searchTerm && (
                    <Button 
                  variant="link"
                  className="position-absolute top-50 end-0 translate-middle-y text-muted pe-3"
                  onClick={() => setSearchTerm('')}
                  aria-label="Clear search"
                  tabIndex={0}
                  style={{ fontSize: '1.5rem', lineHeight: 1, textDecoration: 'none' }}
                >
                  ×
                    </Button>
              )}
                      </div>
            
            {/* Real-time sync indicator */}

          </div>
        </div>

        {/* Alert */}
        {msg && <Alert variant="info">{msg}</Alert>}

        {/* Incoming Handshake Notifications */}
        {(handshakeJobs.length > 0 || incomingHandshakes.length > 0) && (
          <Alert variant="warning" className="mb-3">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <strong>🤝 Incoming Handshake Offers</strong>
                <br />
                <small>
                  You have {handshakeJobs.length || incomingHandshakes.length} pending handshake offer(s)
                </small>
                {incomingHandshakes.length > 0 && (
                  <div className="mt-2">
                    {incomingHandshakes.map(h => (
                      <div key={h._id} className="d-flex align-items-center justify-content-between py-1 border-top">
                        <div>
                          <div className="fw-semibold">{h.customerName?.split(' ')[0] || h.customerName || 'Job'}</div>
                          <small className="text-muted">
                            {formatWhen(h.dateTime)} • {h.from} → {h.to}
                          </small>
                        </div>
                        <div className="d-flex gap-2">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => acceptHandshake(h._id, h.handshake?.fromDriver?._id || h.handshake?.fromDriver)}
                          >
                            Accept
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => declineHandshake(h._id, h.handshake?.fromDriver?._id || h.handshake?.fromDriver)}
                          >
                            Decline
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="ms-2">
                <Button 
                  variant="outline-warning" 
                  size="sm"
                  onClick={() => { setHandshakeJobs([]); setIncomingHandshakes([]); }}
                >
                  Dismiss All
                </Button>
              </div>
            </div>
          </Alert>
        )}

        {/* Jobs List */}
        {loading
          ? <Spinner animation="border" />
          : jobs.length === 0
            ? <p>No jobs.</p>
            : <>
                {!!yesterdayJobs.length && <>
                  <h6 className="bg-dark text-warning text-center" style={{ marginTop: '20px' }}>Yesterday</h6>
                  <Accordion key={`yesterday-${accordionResetKey}`} alwaysOpen={false}>
                    {yesterdayJobs.map(renderJobItem)}
                  </Accordion>
                </>}
                {!!todayJobs.length && <>
                  <h6 className="bg-dark text-warning text-center">Today</h6>
                  <Accordion key={`today-${accordionResetKey}`} alwaysOpen={false}>
                    {todayJobs.map(renderJobItem)}
                  </Accordion>
                </>}
                {!!finalTomorrowJobs.length && <>
                  <h6 className="bg-dark text-warning text-center">Tomorrow</h6>
                  <Accordion key={`tomorrow-${accordionResetKey}`} alwaysOpen={false}>
                    {finalTomorrowJobs.map(renderJobItem)}
                  </Accordion>
                </>}
                {!!restOfWeekJobs.length && <>
                  <h6 className="bg-dark text-warning text-center">Rest of week to Sunday</h6>
                  <Accordion key={`rest-${accordionResetKey}`} alwaysOpen={false}>
                    {restOfWeekJobs.map((job, idx) => renderJobItem(job, idx, restOfWeekJobs, 'restOfWeek'))}
                  </Accordion>
                </>}
                {!!finalNextWeekJobs.length && <>
                  <h6 className="bg-dark text-warning text-center">Next Week From Monday({startOfNextWeek.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' })})</h6>
                  <Accordion key={`next-${accordionResetKey}`} alwaysOpen={false}>
                    {finalNextWeekJobs.map((job, idx) => renderJobItem(job, idx, finalNextWeekJobs, 'nextWeek'))}
                  </Accordion>
                </>}
                {!!futureJobs.length && <>
                  <h6 className="bg-dark text-warning text-center">Future Bookings</h6>
                  <Accordion key={`future-${accordionResetKey}`} alwaysOpen={false}>
                    {futureJobs.map((job, idx) => renderJobItem(job, idx, futureJobs, 'future'))}
                  </Accordion>
                </>}
              </>}

        {/* Add-to-Diary Modal */}
        <Modal show={showAdd} onHide={()=>{
          clearAddJobForm();
          setShowAdd(false);
        }} fullscreen>
          <Form onSubmit={handleDiarySubmit}>
            <Modal.Header closeButton className="sticky-top bg-white border-bottom" style={{ zIndex: 1050 }}>
              <Modal.Title>Add to Diary</Modal.Title>
              <Button type="submit" variant="success" disabled={diaryLoading} className="ms-auto">
                {diaryLoading ? 'Saving…' : 'Save & Accept'}
              </Button>
            </Modal.Header>
            <Modal.Body className="overflow-auto" style={{ 
              maxHeight: 'calc(100vh - 120px)'
            }}>
              {/* Phone Number Section - First Field */}
              <div className="border-bottom pb-2 mb-2">
                <Form.Group className="mb-2">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <Form.Label className="mb-0 fw-bold text-uppercase">PHONE</Form.Label>
                    {!showPhone2 && (
                      <Button
                        variant="link"
                        size="sm"
                        onClick={() => setShowPhone2(true)}
                        className="p-0 text-primary"
                        title="Add second phone number"
                      >
                        <FaPlus /> Add Phone
                      </Button>
                    )}
                  </div>
                  <div className="position-relative">
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={diaryData.phone}
                      onChange={handleDiaryChange}
                      placeholder="Enter phone number"
                      className={isPhoneAutoDetected ? 'border-success' : ''}
                      required
                      style={{ paddingRight: diaryData.phone ? '80px' : '40px' }}
                    />
                    <div className="position-absolute top-50 end-0 translate-middle-y d-flex align-items-center" style={{ right: '10px', zIndex: 15 }}>
                      {diaryData.phone && (
                        <button
                          type="button"
                          onClick={() => setDiaryData(d => ({ ...d, phone: '' }))}
                          className="border-0 bg-transparent text-danger p-0 me-2"
                          style={{ cursor: 'pointer', lineHeight: 1 }}
                          title="Clear field"
                        >
                          <FaTimes />
                        </button>
                      )}
                      <CustomerReviewIndicator
                        phone={diaryData.phone}
                        onReviewsClick={handleCustomerReviewClick}
                      />
                    </div>
                  </div>
                  {isPhoneAutoDetected && (
                    <small className="text-success">Phone number auto-detected</small>
                  )}
                </Form.Group>

                {/* Second Phone Number Field */}
                {showPhone2 && (
                  <Form.Group className="mb-2">
                    <Form.Label>Phone 2</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="tel"
                        name="phone2"
                        value={diaryData.phone2}
                        onChange={handleDiaryChange}
                        placeholder="Enter second phone number"
                        style={{ paddingRight: diaryData.phone2 ? '35px' : '35px' }}
                      />
                      {diaryData.phone2 ? (
                        <button
                          type="button"
                          onClick={() => setDiaryData(d => ({ ...d, phone2: '' }))}
                          className="position-absolute border-0 bg-transparent text-danger p-0"
                          style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                          title="Clear field"
                        >
                          <FaTimes />
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            setShowPhone2(false);
                            setDiaryData(d => ({ ...d, phone2: '' }));
                          }}
                          className="position-absolute border-0 bg-transparent text-danger p-0"
                          style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                          title="Remove second phone field"
                        >
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  </Form.Group>
                )}
              </div>

              {/* Date & Time Section */}
              <div className="border-bottom pb-2 mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="text-muted mb-0 fw-bold text-uppercase">📅 JOURNEY DATE</h6>
                  <Button 
                    variant="primary" 
                    size="sm"
                    onClick={() => setShowJourneyEstimator(true)}
                    disabled={!isGoogleMapsLoaded || !!googleMapsLoadError}
                    title={!isGoogleMapsLoaded ? 'Loading Google Maps...' : googleMapsLoadError ? 'Google Maps failed to load' : 'Calculate journey fare'}
                  >
                    {!isGoogleMapsLoaded ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-1" />
                        Loading...
                      </>
                    ) : (
                      '💰 Get Price'
                    )}
                  </Button>
                </div>
                <Row className="g-2">
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Month</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][diaryData.dateTime.getMonth()] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][new Date().getMonth()]}
                      onClick={() => setShowDiaryMonthModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select month"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? diaryData.dateTime.getDate() : new Date().getDate()}
                      onClick={() => setShowDateModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select date"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Year</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? diaryData.dateTime.getFullYear() : new Date().getFullYear()}
                      onClick={() => setShowDiaryYearModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select year"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </Col>
                </Row>
                <Row className="g-2 mt-0">
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Hour</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? (diaryData.dateTime.getHours() % 12 || 12) : (new Date().getHours() % 12 || 12)}
                      onClick={() => setShowDiaryHourModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select hour"
                      style={{ cursor: 'pointer' }}
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Minute</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? Math.floor(diaryData.dateTime.getMinutes() / 5) * 5 : Math.floor(new Date().getMinutes() / 5) * 5}
                      onClick={() => setShowDiaryMinuteModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select minute"
                      style={{ cursor: 'pointer' }}
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">AM/PM</Form.Label>
                    <Form.Control
                      type="text"
                      value={diaryData.dateTime ? (diaryData.dateTime.getHours() < 12 ? 'AM' : 'PM') : (new Date().getHours() < 12 ? 'AM' : 'PM')}
                      onClick={() => {
                        const newDate = new Date(diaryData.dateTime || new Date());
                        const currentHour = newDate.getHours();
                        if (currentHour >= 12) {
                          newDate.setHours(currentHour - 12);
                        } else {
                          newDate.setHours(currentHour + 12);
                        }
                        setDiaryData(d => ({ ...d, dateTime: newDate }));
                      }}
                      readOnly
                      size="sm"
                      placeholder="Click to toggle AM/PM"
                      style={{ 
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        textAlign: 'center'
                      }}
                    />
                  </Col>
                </Row>
              </div>

              {/* Wait and Return Section */}
              <div className="border-bottom pb-2 mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Check
                      type="checkbox"
                      label="Wait & Return"
                      name="waitAndReturn"
                      checked={diaryData.waitAndReturn || false}
                      onChange={handleDiaryChange}
                      className="mb-2"
                    />
                  </Col>
                  {diaryData.waitAndReturn && (
                    <Col xs={12} sm={6}>
                      <Form.Group className="mb-2">
                        <Form.Label className="small">Expected Return Time (hours)</Form.Label>
                        <Form.Control
                          type="number"
                          name="waitHours"
                          min="0.5"
                          max="24"
                          step="0.5"
                          value={diaryData.waitHours || ''}
                          onChange={handleDiaryChange}
                          placeholder="4.5"
                          size="sm"
                        />
                        <Form.Text className="text-muted small">
                          {diaryData.waitHours && diaryData.dateTime ? 
                            `Return time: ${calculateReturnTime(diaryData.dateTime, diaryData.waitHours)}` : 
                            'Enter hours to wait before return'
                          }
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </div>

              {/* Customer Information Section */}
              <div className="border-bottom pb-2 mb-2">
                <h6 className="text-muted mb-2 fw-bold text-uppercase">👤 CUSTOMER INFORMATION</h6>
                <Row className="g-2">
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small mb-1">Name</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="name" type="text"
                          value={diaryData.name}
                          onChange={handleDiaryChange}
                          placeholder="Enter name or #search"
                          required
                          size="sm"
                          className={isContactAutoPopulated ? 'border-success' : ''}
                          style={{ paddingRight: diaryData.name ? '35px' : undefined }}
                        />
                        {diaryData.name && (
                          <button
                            type="button"
                            onClick={() => setDiaryData(d => ({ ...d, name: '' }))}
                            className="position-absolute top-50 end-0 translate-middle-y me-2 border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 15, right: searchLoading ? '35px' : '10px' }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                        {searchLoading && (
                          <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                            <Spinner animation="border" size="sm" />
                          </div>
                        )}
                        {showSearchResults && searchResults.length > 0 && (
                          <div className="position-absolute w-100 bg-white border rounded shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {searchResults.map((customer, index) => (
                              <div
                                key={index}
                                className="p-2 border-bottom cursor-pointer hover-bg-light"
                                style={{ cursor: 'pointer' }}
                                onClick={() => selectCustomer(customer)}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                              >
                                <div className="fw-bold small">{customer.customerName?.split(' ')[0] || customer.customerName}</div>
                                <div className="text-muted small">{customer.customerPhone}</div>
                                <div className="text-muted small">{customer.from} → {customer.to}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {isContactAutoPopulated && (
                        <small className="text-success">Customer details auto-populated</small>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small mb-1">Email</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="email" type="email"
                          value={diaryData.email}
                          onChange={handleDiaryChange}
                          required
                          size="sm"
                          className={isContactAutoPopulated ? 'border-success' : ''}
                          style={{ paddingRight: diaryData.email ? '80px' : '40px' }}
                        />
                        <div className="position-absolute top-50 end-0 translate-middle-y d-flex align-items-center" style={{ right: '10px', zIndex: 15 }}>
                          {diaryData.email && (
                            <button
                              type="button"
                              onClick={() => setDiaryData(d => ({ ...d, email: 'NoReply@taxi-local.com' }))}
                              className="border-0 bg-transparent text-danger p-0 me-2"
                              style={{ cursor: 'pointer', lineHeight: 1 }}
                              title="Clear field"
                            >
                              <FaTimes />
                            </button>
                          )}
                          <CustomerReviewIndicator
                            phone={diaryData.phone}
                            onReviewsClick={handleCustomerReviewClick}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Journey Information Section */}
              <div className="border-bottom pb-2 mb-2">
                <h6 className="text-muted mb-2 fw-bold text-uppercase">🚗 JOURNEY DETAILS</h6>
                <Row className="g-2">
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small fw-bold text-uppercase">FROM</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="from" type="text"
                          value={diaryData.from}
                          onChange={handleDiaryChange}
                          required
                          size="sm"
                          className={isContactAutoPopulated ? 'border-success' : ''}
                          style={{ paddingRight: diaryData.from ? '35px' : undefined }}
                        />
                        {diaryData.from && (
                          <button
                            type="button"
                            onClick={() => setDiaryData(d => ({ ...d, from: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Label className="small mb-0 fw-bold text-uppercase">TO</Form.Label>
                        <Button 
                          variant="primary" 
                          size="sm"
                          onClick={swapDiaryFromTo}
                          title="Swap From and To"
                          style={{ 
                            width: '40px', 
                            height: '32px', 
                            padding: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: '0.7',
                            fontSize: '22px',
                            fontWeight: 'bold'
                          }}
                        >
                          <div>⌃</div>
                          <div>⌄</div>
                        </Button>
                      </div>
                      <div className="position-relative">
                        <Form.Control
                          name="to" type="text"
                          value={diaryData.to}
                          onChange={handleDiaryChange}
                          required
                          size="sm"
                          className={isContactAutoPopulated ? 'border-success' : ''}
                          style={{ paddingRight: diaryData.to ? '35px' : undefined }}
                        />
                        {diaryData.to && (
                          <button
                            type="button"
                            onClick={() => setDiaryData(d => ({ ...d, to: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="g-2">
                  <Col xs={6} sm={3}>
                    <Form.Group className="mb-1">
                      <Form.Label className="small fw-bold text-uppercase">PASSENGERS</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="passengers" type="number" min={1}
                          value={diaryData.passengers||''}
                          onChange={handleDiaryChange}
                          required
                          size="sm"
                          style={{ paddingRight: diaryData.passengers ? '35px' : undefined }}
                        />
                        {diaryData.passengers && (
                          <button
                            type="button"
                            onClick={() => setDiaryData(d => ({ ...d, passengers: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Check
                      type="checkbox" label="🐕 Dog/Pet"
                      name="dog"
                      checked={diaryData.dog || false}
                      onChange={handleDiaryChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                  <Row className="g-2 mb-1">
                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label className="small">Fare (£)</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="fareAmount"
                            type="number"
                            inputMode="decimal"
                            min="0"
                            step="0.01"
                            placeholder="e.g. 12.50"
                            value={diaryData.fareAmount || ''}
                            onChange={handleDiaryChange}
                            size="sm"
                            style={{ paddingRight: diaryData.fareAmount ? '35px' : undefined }}
                          />
                          {diaryData.fareAmount && (
                            <button
                              type="button"
                              onClick={() => setDiaryData(d => ({ ...d, fareAmount: '' }))}
                              className="position-absolute border-0 bg-transparent text-danger p-0"
                              style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                              title="Clear field"
                            >
                              <FaTimes />
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                    <Form.Check
                      type="checkbox" label="♿ Disabled"
                      name="disabled"
                      checked={diaryData.disabled || false}
                      onChange={handleDiaryChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                    <Form.Check
                      type="checkbox" label="💳 Paid"
                      name="paid"
                      checked={diaryData.paid || false}
                      onChange={handleDiaryChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                    <Form.Check
                      type="checkbox" label="📄 Invoiced"
                      name="invoiced"
                      checked={diaryData.invoiced || false}
                      onChange={handleDiaryChange}
                      className="mb-1"
                    />
                  </Col>
                </Row>
              </div>

              {/* Notes Section */}
              <div>
                <h6 className="text-muted mb-2 fw-bold text-uppercase">📝 NOTES</h6>
                <Form.Group className="mb-2">
                  <div className="position-relative">
                    <Form.Control
                      as="textarea"
                      rows="2"
                      name="notes"
                      value={diaryData.notes || ''}
                      onChange={handleDiaryChange}
                      maxLength={100}
                      placeholder="Any additional notes..."
                      size="sm"
                      style={{ paddingRight: diaryData.notes ? '35px' : undefined }}
                    />
                    {diaryData.notes && (
                      <button
                        type="button"
                        onClick={() => setDiaryData(d => ({ ...d, notes: '' }))}
                        className="position-absolute border-0 bg-transparent text-danger p-0"
                        style={{ cursor: 'pointer', zIndex: 10, top: '15px', right: '10px', lineHeight: 1 }}
                        title="Clear field"
                      >
                        <FaTimes />
                      </button>
                    )}
                  </div>
                  <Form.Text className="text-muted small">
                    {diaryData.notes ? diaryData.notes.length : 0}/100 characters
                  </Form.Text>
                </Form.Group>
              </div>
            </Modal.Body>
            <Modal.Footer className="sticky-bottom bg-white border-top" style={{ zIndex: 1050 }}>
              <Button variant="secondary" onClick={()=>{clearAddJobForm(); setShowAdd(false);}}>Cancel</Button>
              <Button type="submit" variant="success" disabled={diaryLoading} className="ms-auto">
                {diaryLoading ? 'Saving…' : 'Save & Accept'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* Journey Estimator Modal */}
        <Modal 
          show={showJourneyEstimator} 
          onHide={() => {
            setShowJourneyEstimator(false);
            setEstimatorFrom('');
            setEstimatorTo('');
            setEstimatorDistance(0);
            setEstimatorDuration(0);
            setEstimatorFares({});
            setEstimatorCalculated(false);
            fromAutocompleteRef.current = null;
            toAutocompleteRef.current = null;
          }} 
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>💰 Journey Estimator</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {googleMapsLoadError && (
              <Alert variant="danger" className="mb-3">
                <strong>⚠️ Google Maps Error:</strong> Google Maps failed to load. Please refresh the page and try again.
              </Alert>
            )}
            {!isGoogleMapsLoaded && !googleMapsLoadError && (
              <Alert variant="info" className="mb-3">
                <Spinner animation="border" size="sm" className="me-2" />
                Loading Google Maps...
              </Alert>
            )}
            {!estimatorCalculated ? (
              <>
                <Form.Group className="mb-3">
                  <Form.Label>From (Pickup Location)</Form.Label>
                  <input
                    ref={estimatorFromRef}
                    className="form-control"
                    type="text"
                    placeholder="Enter pickup address"
                    value={estimatorFrom}
                    onChange={(e) => setEstimatorFrom(e.target.value)}
                    onFocus={() => {
                      // Initialize autocomplete on focus as fallback
                      if (isGoogleMapsLoaded && !googleMapsLoadError && estimatorFromRef.current && !fromAutocompleteRef.current) {
                        try {
                          console.log('Initializing From autocomplete on focus...');
                          fromAutocompleteRef.current = new window.google.maps.places.Autocomplete(
                            estimatorFromRef.current,
                            { 
                              componentRestrictions: { country: 'uk' },
                              fields: ['formatted_address', 'geometry', 'name'],
                              types: ['address']
                            }
                          );
                          
                          fromAutocompleteRef.current.addListener('place_changed', () => {
                            const place = fromAutocompleteRef.current.getPlace();
                            if (place && place.formatted_address) {
                              const cleanedAddress = cleanGoogleMapsAddress(place.formatted_address);
                              setEstimatorFrom(cleanedAddress);
                            }
                          });
                        } catch (error) {
                          console.error('Error initializing From autocomplete on focus:', error);
                        }
                      }
                    }}
                    disabled={!isGoogleMapsLoaded || !!googleMapsLoadError}
                    autoFocus
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>To (Destination)</Form.Label>
                  <input
                    ref={estimatorToRef}
                    className="form-control"
                    type="text"
                    placeholder="Enter destination address"
                    value={estimatorTo}
                    onChange={(e) => setEstimatorTo(e.target.value)}
                    onFocus={() => {
                      // Initialize autocomplete on focus as fallback
                      if (isGoogleMapsLoaded && !googleMapsLoadError && estimatorToRef.current && !toAutocompleteRef.current) {
                        try {
                          console.log('Initializing To autocomplete on focus...');
                          toAutocompleteRef.current = new window.google.maps.places.Autocomplete(
                            estimatorToRef.current,
                            { 
                              componentRestrictions: { country: 'uk' },
                              fields: ['formatted_address', 'geometry', 'name'],
                              types: ['address']
                            }
                          );
                          
                          toAutocompleteRef.current.addListener('place_changed', () => {
                            const place = toAutocompleteRef.current.getPlace();
                            if (place && place.formatted_address) {
                              const cleanedAddress = cleanGoogleMapsAddress(place.formatted_address);
                              setEstimatorTo(cleanedAddress);
                            }
                          });
                        } catch (error) {
                          console.error('Error initializing To autocomplete on focus:', error);
                        }
                      }
                    }}
                    disabled={!isGoogleMapsLoaded || !!googleMapsLoadError}
                  />
                </Form.Group>
              </>
            ) : (
              <>
                <div className="border-bottom pb-3 mb-3">
                  <h5 className="mb-3">📍 Journey Details</h5>
                  <p className="mb-2"><strong>From:</strong> {estimatorFrom}</p>
                  <p className="mb-2"><strong>To:</strong> {estimatorTo}</p>
                  <p className="mb-2"><strong>Distance:</strong> {estimatorDistance.toFixed(1)} miles</p>
                  <p className="mb-2"><strong>Duration:</strong> {Math.round(estimatorDuration)} minutes</p>
                </div>
                
                <div className="mb-3">
                  <h5 className="mb-3">💷 Estimated Fares</h5>
                  {Object.entries(estimatorFares).map(([key, fare]) => {
                    const councilKey = councils[driverLicensingAuthority] ? driverLicensingAuthority : 'Default';
                    const tariff = councils[councilKey].tariffs[key];
                    return (
                      <div key={key} className="d-flex justify-content-between align-items-center py-2" style={{
                        borderBottom: key === 'tariff3' ? 'none' : '1px solid #dee2e6'
                      }}>
                        <strong>{tariff.name}</strong>
                        <h5 className="mb-0 text-primary">£{fare}</h5>
                      </div>
                    );
                  })}
                </div>
                
                <Alert variant="info" className="mb-0">
                  <small>
                    <strong>Note:</strong> These are estimates based on distance and standard tariffs. 
                    Actual fares may vary due to traffic, waiting time, or other factors.
                  </small>
                </Alert>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={() => {
                setShowJourneyEstimator(false);
                setEstimatorFrom('');
                setEstimatorTo('');
                setEstimatorDistance(0);
                setEstimatorDuration(0);
                setEstimatorFares({});
                setEstimatorCalculated(false);
                fromAutocompleteRef.current = null;
                toAutocompleteRef.current = null;
              }}
            >
              Cancel
            </Button>
            {!estimatorCalculated ? (
              <Button 
                variant="primary" 
                onClick={handleEstimateJourney}
                disabled={estimatorCalculating || !estimatorFrom || !estimatorTo || !isGoogleMapsLoaded || !!googleMapsLoadError}
              >
                {estimatorCalculating ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Calculating...
                  </>
                ) : !isGoogleMapsLoaded ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Loading Maps...
                  </>
                ) : (
                  'Calculate Fare'
                )}
              </Button>
            ) : (
              <>
                <Button 
                  variant="outline-primary" 
                  onClick={() => {
                    setEstimatorCalculated(false);
                    setEstimatorFrom('');
                    setEstimatorTo('');
                    setEstimatorDistance(0);
                    setEstimatorDuration(0);
                    setEstimatorFares({});
                    fromAutocompleteRef.current = null;
                    toAutocompleteRef.current = null;
                  }}
                >
                  New Estimate
                </Button>
                <Button 
                  variant="success" 
                  onClick={handleAcceptEstimate}
                >
                  ✓ Accept & Add to Form
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        {/* Duplicate Confirmation Modal */}
        <Modal show={!!duplicateAction} onHide={()=>setDuplicateAction(null)}>
          <Modal.Header closeButton><Modal.Title>Copy Job</Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Date & Time</label>
              <input
                type="datetime-local"
                className="form-control"
                value={toLocalInputValue(duplicateAction?.dateTime)}
                onChange={e => {
                  try {
                    const newDateTime = createSafeDate(e.target.value);
                    setDuplicateAction(a => ({ ...a, dateTime: newDateTime }));
                  } catch (error) {
                    console.warn('Error parsing datetime input:', e.target.value, error);
                    toast.error('Invalid date format');
                  }
                }}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">From</label>
              <input
                type="text"
                className="form-control"
                value={duplicateAction?.from || ''}
                onChange={e => setDuplicateAction(a => ({ ...a, from: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">To</label>
              <input
                type="text"
                className="form-control"
                value={duplicateAction?.to || ''}
                onChange={e => setDuplicateAction(a => ({ ...a, to: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="duplicateWaitAndReturn"
                  checked={duplicateAction?.waitAndReturn || false}
                  onChange={e => setDuplicateAction(a => ({ ...a, waitAndReturn: e.target.checked }))}
                />
                <label className="form-check-label" htmlFor="duplicateWaitAndReturn">
                  Wait & Return
                </label>
              </div>
            </div>
            {duplicateAction?.waitAndReturn && (
              <div className="mb-3">
                <label className="form-label">Expected Return Time (hours)</label>
                <input
                  type="number"
                  className="form-control"
                  min="0.5"
                  max="24"
                  step="0.5"
                  value={duplicateAction?.waitHours || ''}
                  onChange={e => setDuplicateAction(a => ({ ...a, waitHours: parseFloat(e.target.value) || null }))}
                  placeholder="4.5"
                />
                <div className="form-text text-muted">
                  {duplicateAction?.waitHours && duplicateAction?.dateTime ? 
                    `Return time: ${calculateReturnTime(duplicateAction.dateTime, duplicateAction.waitHours)}` : 
                    'Enter hours to wait before return'
                  }
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>setDuplicateAction(null)}>Cancel</Button>
            <Button variant="primary" onClick={async ()=>{
              try {
                await axios.post('/diary/add-entry', {
                  customerName: duplicateAction.job.customerName,
                  customerEmail: duplicateAction.job.customerEmail,
                  customerPhone: duplicateAction.job.customerPhone,
                  from: duplicateAction.from,
                  to: duplicateAction.to,
                  dateTime: duplicateAction.dateTime,
                  passengers: duplicateAction.job.passengers,
                  returnTrip: duplicateAction.job.returnTrip,
                  dog: duplicateAction.job.dog,
                  disabled: duplicateAction.job.disabled,
                  notes: duplicateAction.job.notes,
                  waitAndReturn: duplicateAction.waitAndReturn,
                  waitHours: duplicateAction.waitHours,
                });
                toast.success('Job copied to diary');
              } catch (e) {
                toast.error('Failed to copy job');
              } finally {
                setDuplicateAction(null);
              }
            }}>Add to My Diary</Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={!!editLead} onHide={closeEdit} size="lg">
          <Form onSubmit={saveEdit}>
            <Modal.Header closeButton className="sticky-top bg-white border-bottom">
              <Modal.Title>Edit Job</Modal.Title>
              <Button type="submit" variant="primary" disabled={saving} className="ms-auto">
                {saving ? 'Saving...' : 'Save Changes'}
              </Button>
            </Modal.Header>
            <Modal.Body className="overflow-auto" style={{ maxHeight: '70vh' }}>
              {/* Phone Number Section - First Field */}
              <div className="border-bottom pb-2 mb-2">
                <Form.Group className="mb-2">
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <Form.Label className="mb-0">Phone</Form.Label>
                    {!showPhone2 && (
                      <Button
                        variant="link"
                        size="sm"
                        onClick={() => setShowPhone2(true)}
                        className="p-0 text-primary"
                        title="Add second phone number"
                      >
                        <FaPlus /> Add Phone
                      </Button>
                    )}
                  </div>
                  <div className="position-relative">
                    <Form.Control
                      name="phone"
                      type="tel"
                      value={form.phone || ''}
                      onChange={onChange}
                      placeholder="Enter phone number"
                      required
                      size="sm"
                      style={{ paddingRight: form.phone ? '35px' : undefined }}
                    />
                    {form.phone && (
                      <button
                        type="button"
                        onClick={() => setForm(f => ({ ...f, phone: '' }))}
                        className="position-absolute border-0 bg-transparent text-danger p-0"
                        style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                        title="Clear field"
                      >
                        <FaTimes />
                      </button>
                    )}
                  </div>
                </Form.Group>

                {/* Second Phone Number Field */}
                {showPhone2 && (
                  <Form.Group className="mb-2">
                    <Form.Label>Phone 2</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="tel"
                        name="phone2"
                        value={form.phone2 || ''}
                        onChange={onChange}
                        placeholder="Enter second phone number"
                        size="sm"
                        style={{ paddingRight: form.phone2 ? '35px' : '35px' }}
                      />
                      {form.phone2 ? (
                        <button
                          type="button"
                          onClick={() => setForm(f => ({ ...f, phone2: '' }))}
                          className="position-absolute border-0 bg-transparent text-danger p-0"
                          style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                          title="Clear field"
                        >
                          <FaTimes />
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            setShowPhone2(false);
                            setForm(f => ({ ...f, phone2: '' }));
                          }}
                          className="position-absolute border-0 bg-transparent text-danger p-0"
                          style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                          title="Remove second phone field"
                        >
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  </Form.Group>
                )}
              </div>

              {/* Date & Time Section */}
              <div className="border-bottom pb-2 mb-2">
                <h6 className="text-muted mb-2">📅 Journey Date</h6>
                <Row className="g-2">
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Month</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][form.dateTime.getMonth()] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][new Date().getMonth()]}
                      onClick={() => setShowEditMonthModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select month"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? form.dateTime.getDate() : new Date().getDate()}
                      onClick={() => setShowDateModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select date"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Year</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? form.dateTime.getFullYear() : new Date().getFullYear()}
                      onClick={() => setShowEditYearModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select year"
                      style={{ cursor: 'pointer' }}
                      autoComplete="off"
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  </Col>
                </Row>
                <Row className="g-2 mt-0">
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Hour</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? (form.dateTime.getHours() % 12 || 12) : (new Date().getHours() % 12 || 12)}
                      onClick={() => setShowEditHourModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select hour"
                      style={{ cursor: 'pointer' }}
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">Minute</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? Math.floor(form.dateTime.getMinutes() / 5) * 5 : Math.floor(new Date().getMinutes() / 5) * 5}
                      onClick={() => setShowEditMinuteModal(true)}
                      readOnly
                      size="sm"
                      placeholder="Click to select minute"
                      style={{ cursor: 'pointer' }}
                    />
                  </Col>
                  <Col xs={4}>
                    <Form.Label className="small mb-1">AM/PM</Form.Label>
                    <Form.Control
                      type="text"
                      value={form.dateTime ? (form.dateTime.getHours() < 12 ? 'AM' : 'PM') : (new Date().getHours() < 12 ? 'AM' : 'PM')}
                      onClick={() => {
                        const newDate = new Date(form.dateTime || new Date());
                        const currentHour = newDate.getHours();
                        if (currentHour >= 12) {
                          newDate.setHours(currentHour - 12);
                        } else {
                          newDate.setHours(currentHour + 12);
                        }
                        setForm(f => ({ ...f, dateTime: newDate }));
                      }}
                      readOnly
                      size="sm"
                      placeholder="Click to toggle AM/PM"
                      style={{ 
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        textAlign: 'center'
                      }}
                    />
                  </Col>
                </Row>
              </div>

              {/* Wait and Return Section */}
              <div className="border-bottom pb-2 mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Check
                      type="checkbox"
                      label="Wait & Return"
                      name="waitAndReturn"
                      checked={form.waitAndReturn || false}
                      onChange={onChange}
                      className="mb-2"
                    />
                  </Col>
                  {form.waitAndReturn && (
                    <Col xs={12} sm={6}>
                      <Form.Group className="mb-2">
                        <Form.Label className="small">Expected Return Time (hours)</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="number"
                            name="waitHours"
                            min="0.5"
                            max="24"
                            step="0.5"
                            value={form.waitHours || ''}
                            onChange={onChange}
                            placeholder="4.5"
                            size="sm"
                            style={{ paddingRight: form.waitHours ? '35px' : undefined }}
                          />
                          {form.waitHours && (
                            <button
                              type="button"
                              onClick={() => setForm(f => ({ ...f, waitHours: '' }))}
                              className="position-absolute border-0 bg-transparent text-danger p-0"
                              style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                              title="Clear field"
                            >
                              <FaTimes />
                            </button>
                          )}
                        </div>
                        <Form.Text className="text-muted small">
                          {form.waitHours && form.dateTime ? 
                            `Return time: ${calculateReturnTime(form.dateTime, form.waitHours)}` : 
                            'Enter hours to wait before return'
                          }
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
              </div>

              {/* Customer Information Section */}
              <div className="border-bottom pb-3 mb-3">
                <h6 className="text-muted mb-2">👤 Customer Information</h6>
                <Row className="g-2">
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small">Name</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="name" type="text"
                          value={form.name||''}
                          onChange={onChange}
                          required
                          size="sm"
                          style={{ paddingRight: form.name ? '35px' : undefined }}
                        />
                        {form.name && (
                          <button
                            type="button"
                            onClick={() => setForm(f => ({ ...f, name: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small">Email</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="email" type="email"
                          value={form.email||''}
                          onChange={onChange}
                          required
                          size="sm"
                          style={{ paddingRight: form.email ? '35px' : undefined }}
                        />
                        {form.email && (
                          <button
                            type="button"
                            onClick={() => setForm(f => ({ ...f, email: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Journey Information Section */}
              <div className="border-bottom pb-3 mb-3">
                <h6 className="text-muted mb-2">🚗 Journey Details</h6>
                <Row className="g-2">
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small">From</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="from" type="text"
                          value={form.from||''}
                          onChange={onChange}
                          required
                          size="sm"
                          style={{ paddingRight: form.from ? '35px' : undefined }}
                        />
                        {form.from && (
                          <button
                            type="button"
                            onClick={() => setForm(f => ({ ...f, from: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Group className="mb-2">
                      <div className="d-flex align-items-center justify-content-between mb-1">
                        <Form.Label className="small mb-0">To</Form.Label>
                        <Button 
                          variant="primary" 
                          size="sm"
                          onClick={swapEditFromTo}
                          title="Swap From and To"
                          style={{ 
                            width: '40px', 
                            height: '32px', 
                            padding: '0',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: '0.7',
                            fontSize: '22px',
                            fontWeight: 'bold'
                          }}
                        >
                          <div>⌃</div>
                          <div>⌄</div>
                        </Button>
                      </div>
                      <div className="position-relative">
                        <Form.Control
                          name="to" type="text"
                          value={form.to||''}
                          onChange={onChange}
                          required
                          size="sm"
                          style={{ paddingRight: form.to ? '35px' : undefined }}
                        />
                        {form.to && (
                          <button
                            type="button"
                            onClick={() => setForm(f => ({ ...f, to: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="g-2">
                  <Col xs={6} sm={3}>
                    <Form.Group className="mb-1">
                      <Form.Label className="small">Passengers</Form.Label>
                      <div className="position-relative">
                        <Form.Control
                          name="passengers" type="number" min={1}
                          value={form.passengers||''}
                          onChange={onChange}
                          required
                          size="sm"
                          style={{ paddingRight: form.passengers ? '35px' : undefined }}
                        />
                        {form.passengers && (
                          <button
                            type="button"
                            onClick={() => setForm(f => ({ ...f, passengers: '' }))}
                            className="position-absolute border-0 bg-transparent text-danger p-0"
                            style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                            title="Clear field"
                          >
                            <FaTimes />
                          </button>
                        )}
                      </div>
                    </Form.Group>
                    <Form.Check
                      type="checkbox" label="🐕 Dog/Pet"
                      name="dog"
                      checked={form.dog||false}
                      onChange={onChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                  <Row className="g-2 mb-1">
                    <Col xs={6}>
                      <Form.Group>
                        <Form.Label className="small">Fare (£)</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="fareAmount"
                            type="number"
                            inputMode="decimal"
                            min="0"
                            step="0.01"
                            placeholder="e.g. 12.50"
                            value={form.fareAmount || ''}
                            onChange={onChange}
                            disabled={saving}
                            size="sm"
                            style={{ paddingRight: form.fareAmount ? '35px' : undefined }}
                          />
                          {form.fareAmount && (
                            <button
                              type="button"
                              onClick={() => setForm(f => ({ ...f, fareAmount: '' }))}
                              className="position-absolute border-0 bg-transparent text-danger p-0"
                              style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                              title="Clear field"
                            >
                              <FaTimes />
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                    <Col xs={6}>
                      <Form.Group>
                        <Form.Label className="small">Tips (£)</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            name="tipAmount"
                            type="number"
                            inputMode="decimal"
                            min="0"
                            step="0.01"
                            placeholder="e.g. 2.00"
                            value={form.tipAmount || ''}
                            onChange={onChange}
                            disabled={saving}
                            size="sm"
                            style={{ paddingRight: form.tipAmount ? '35px' : undefined }}
                          />
                          {form.tipAmount && (
                            <button
                              type="button"
                              onClick={() => setForm(f => ({ ...f, tipAmount: '' }))}
                              className="position-absolute border-0 bg-transparent text-danger p-0"
                              style={{ cursor: 'pointer', zIndex: 10, top: '50%', right: '10px', transform: 'translateY(-50%)', lineHeight: 1 }}
                              title="Clear field"
                            >
                              <FaTimes />
                            </button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                    <Form.Check
                      type="checkbox" label="♿ Disabled"
                      name="disabled"
                      checked={form.disabled||false}
                      onChange={onChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                    <Form.Check
                      type="checkbox" label="💳 Paid"
                      name="paid"
                      checked={form.paid||false}
                      onChange={onChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={6} sm={3}>
                    <Form.Check
                      type="checkbox" label="📄 Invoiced"
                      name="invoiced"
                      checked={form.invoiced||false}
                      onChange={onChange}
                      className="mb-1"
                    />
                  </Col>
                  <Col xs={12}>
                    <Form.Check
                      type="checkbox" label="Return Trip"
                      name="returnTrip"
                      checked={form.returnTrip||false}
                      onChange={onChange}
                      className="mb-1"
                    />
                  </Col>
                </Row>
              </div>

              {/* Notes Section */}
              <div>
                <h6 className="text-muted mb-2">📝 Notes</h6>
                <Form.Group className="mb-2">
                  <div className="position-relative">
                    <Form.Control
                      as="textarea"
                      rows="2"
                      name="notes"
                      value={form.notes||''}
                      onChange={onChange}
                      maxLength={100}
                      placeholder="Any additional notes..."
                      size="sm"
                      style={{ paddingRight: form.notes ? '35px' : undefined }}
                    />
                    {form.notes && (
                      <button
                        type="button"
                        onClick={() => setForm(f => ({ ...f, notes: '' }))}
                        className="position-absolute border-0 bg-transparent text-danger p-0"
                        style={{ cursor: 'pointer', zIndex: 10, top: '15px', right: '10px', lineHeight: 1 }}
                        title="Clear field"
                      >
                        <FaTimes />
                      </button>
                    )}
                  </div>
                  <Form.Text className="text-muted small">
                    {form.notes ? form.notes.length : 0}/100 characters
                  </Form.Text>
                </Form.Group>
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeEdit}>Cancel</Button>
              <Button type="submit" variant="primary" disabled={saving} className="ms-auto">
                {saving ? 'Saving...' : 'Save Changes'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* Return Modal removed: Return now uses the Add Job form */}

        {/* Confirm-action Modal */}
        <Modal show={!!confirmAction} onHide={()=>{
          setConfirmAction(null);
          setStarRating(5);
          setReviewText('');
          setIsBlacklisted(false);
          setBlacklistReason('');
          setCompletionReason('');
        }} size="lg">
          <Modal.Header closeButton><Modal.Title>Confirm</Modal.Title></Modal.Header>
          <Modal.Body>
            {confirmAction?.verb === 'complete' ? (
              <>
                {jobBeingConfirmed && (
                  <div className="mb-3 p-3 border rounded bg-light small">
                    <div className="fw-bold text-uppercase text-muted mb-2" style={{ letterSpacing: '0.08em' }}>
                      Job Details
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="text-muted">When</span>
                      <span className="fw-semibold text-end">{formatWhen(jobBeingConfirmed.dateTime)}</span>
                    </div>
                    <div className="mt-1 text-truncate">
                      <strong>Route:</strong> {extractTowns(jobBeingConfirmed.from, jobBeingConfirmed.to)}
                    </div>
                    <div className="d-flex flex-wrap gap-3 mt-2">
                      <span><strong>Cust:</strong> {jobBeingConfirmed.customerName || '—'}</span>
                      <span><strong>Passengers:</strong> {jobBeingConfirmed.passengers || '—'}</span>
                      {jobBeingConfirmed.customerPhone && (
                        <span><strong>☎</strong> {jobBeingConfirmed.customerPhone}</span>
                      )}
                      {jobBeingConfirmed.customerPhone2 && (
                        <span><strong>☎2</strong> {jobBeingConfirmed.customerPhone2}</span>
                      )}
                    </div>
                    {(jobBeingConfirmed.waitAndReturn || jobBeingConfirmed.notes) && (
                      <div className="mt-2">
                        {jobBeingConfirmed.waitAndReturn && jobBeingConfirmed.waitHours && (
                          <span className="badge bg-primary me-2">
                            Wait &amp; Return {jobBeingConfirmed.waitHours}h
                          </span>
                        )}
                        {jobBeingConfirmed.notes && (
                          <span className="d-block text-muted"><strong>Notes:</strong> {jobBeingConfirmed.notes}</span>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Star Rating */}
                <div className="mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <strong>⭐</strong>
                    {[1, 2, 3, 4, 5].map((star) => (
                      <FaStar
                        key={star}
                        size={28}
                        style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                        color={(hoverRating || starRating) >= star ? '#ffc107' : '#e4e5e9'}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                        onClick={() => setStarRating(star)}
                      />
                    ))}
                    <span className="ms-1" style={{ fontWeight: 'bold' }}>
                      {starRating}/5
                    </span>
                  </div>
                </div>

                {/* Completion Reason Section - Show when rating is less than 5 */}
                {starRating < 5 && (
                  <div className="mb-3 p-2" style={{ 
                    backgroundColor: '#fff3cd', 
                    borderRadius: '6px',
                    border: '2px solid #ffc107'
                  }}>
                    <Form.Label className="mb-2">
                      <span style={{ fontWeight: 'bold' }}>⚠️ Reason for Low Rating *</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={completionReason}
                      onChange={(e) => setCompletionReason(e.target.value)}
                      placeholder="Please explain why the rating is less than 5 stars..."
                      maxLength={1000}
                      required={starRating < 5}
                      size="sm"
                      style={{ borderColor: starRating < 5 && !completionReason ? '#dc3545' : undefined }}
                    />
                  </div>
                )}

                {/* Blacklist Checkbox */}
                <div className="mb-3 p-2" style={{ 
                  backgroundColor: isBlacklisted ? '#fff3cd' : '#f8f9fa', 
                  borderRadius: '6px',
                  border: isBlacklisted ? '2px solid #ffc107' : '1px solid #dee2e6'
                }}>
                  <Form.Check
                    type="checkbox"
                    id="blacklistCheckboxConfirm"
                    checked={isBlacklisted}
                    onChange={(e) => setIsBlacklisted(e.target.checked)}
                    label={<span style={{ fontWeight: 'bold' }}>⚠️ Blacklist</span>}
                  />
                  {isBlacklisted && (
                    <Form.Control
                      className="mt-2"
                      as="textarea"
                      rows={2}
                      value={blacklistReason}
                      onChange={(e) => setBlacklistReason(e.target.value)}
                      placeholder="Reason *"
                      maxLength={1000}
                      size="sm"
                      style={{ borderColor: isBlacklisted && !blacklistReason ? '#dc3545' : undefined }}
                    />
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Customer Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={form?.customerEmail || ''}
                    onChange={e => setForm(f => ({ ...f, customerEmail: e.target.value }))}
                    placeholder="name@example.com"
                  />
                </div>
                <div className="mb-3">
                  <Row className="g-2 align-items-center">
                    <Col xs={6}>
                      <div className="d-flex align-items-center">
                        <label className="form-label mb-0 me-2">Fare (£)</label>
                        <input
                          type="number"
                          inputMode="decimal"
                          min="0"
                          step="0.01"
                          className="form-control"
                          value={form?.fareAmount || ''}
                          onChange={e => setForm(f => ({ ...f, fareAmount: e.target.value }))}
                          placeholder="e.g. 35.00"
                        />
                      </div>
                    </Col>
                    <Col xs={6}>
                      <div className="d-flex align-items-center">
                        <label className="form-label mb-0 me-2">Tips (£)</label>
                        <input
                          type="number"
                          inputMode="decimal"
                          min="0"
                          step="0.01"
                          className="form-control"
                          value={form?.tipAmount || ''}
                          onChange={e => setForm(f => ({ ...f, tipAmount: e.target.value }))}
                          placeholder="e.g. 2.00"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="mb-3">
                  <label className="form-label">Method of Payment</label>
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="paymentCash"
                          value="Cash"
                          checked={form?.paymentMethod === 'Cash'}
                          onChange={e => setForm(f => ({ ...f, paymentMethod: e.target.value }))}
                        />
                        <label className="form-check-label" htmlFor="paymentCash">
                          Cash
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="paymentBankTransfer"
                          value="BankTransfer"
                          checked={form?.paymentMethod === 'BankTransfer'}
                          onChange={e => setForm(f => ({ ...f, paymentMethod: e.target.value }))}
                        />
                        <label className="form-check-label" htmlFor="paymentBankTransfer">
                          Bank Transfer
                        </label>
                      </div>
                    </div>
                    <div className="d-flex gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="paymentCard"
                          value="Card"
                          checked={form?.paymentMethod === 'Card'}
                          onChange={e => setForm(f => ({ ...f, paymentMethod: e.target.value }))}
                        />
                        <label className="form-check-label" htmlFor="paymentCard">
                          Card
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="paymentMethod"
                          id="paymentInvoiced"
                          value="Invoiced"
                          checked={form?.paymentMethod === 'Invoiced'}
                          onChange={e => setForm(f => ({ ...f, paymentMethod: e.target.value }))}
                        />
                        <label className="form-check-label" htmlFor="paymentInvoiced">
                          Invoiced
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : confirmAction?.verb === 'cancel' ? (
              <>
                <p>Are you sure you want to <strong>cancel</strong> this job?</p>
                <p className="text-muted mb-3">Please select a reason for cancellation:</p>
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="within15min"
                      value="within15min"
                      checked={cancellationReason === 'within15min'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="within15min">
                      Within 15 minutes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="within30min"
                      value="within30min"
                      checked={cancellationReason === 'within30min'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="within30min">
                      Within 30 minutes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="within1hr"
                      value="within1hr"
                      checked={cancellationReason === 'within1hr'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="within1hr">
                      Within 1 hour
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="noShow"
                      value="noShow"
                      checked={cancellationReason === 'noShow'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="noShow">
                      No Show
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="abusive"
                      value="abusive"
                      checked={cancellationReason === 'abusive'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="abusive">
                      Abusive
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="cancellationReason"
                      id="inputError"
                      value="inputError"
                      checked={cancellationReason === 'inputError'}
                      onChange={(e) => setCancellationReason(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="inputError">
                      Input Error
                    </label>
                  </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cancellationReason"
                        id="trainBusCancellation"
                        value="trainBusCancellation"
                        checked={cancellationReason === 'trainBusCancellation'}
                        onChange={(e) => setCancellationReason(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="trainBusCancellation">
                        Train/Bus Cancellation
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cancellationReason"
                        id="duplicate"
                        value="duplicate"
                        checked={cancellationReason === 'duplicate'}
                        onChange={(e) => setCancellationReason(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="duplicate">
                        Duplicate
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cancellationReason"
                        id="noLongerRequired"
                        value="noLongerRequired"
                        checked={cancellationReason === 'noLongerRequired'}
                        onChange={(e) => setCancellationReason(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="noLongerRequired">
                        No Longer Required
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cancellationReason"
                        id="test"
                        value="test"
                        checked={cancellationReason === 'test'}
                        onChange={(e) => setCancellationReason(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="test">
                        Test
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="cancellationReason"
                        id="other"
                        value="other"
                        checked={cancellationReason === 'other'}
                        onChange={(e) => setCancellationReason(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="other">
                        Other
                      </label>
                    </div>
                </div>
              </>
            ) : (
              <>Are you sure you want to <strong>{confirmAction?.verb}</strong> this job?</>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{
              setConfirmAction(null);
              setCancellationReason('');
              setStarRating(5);
              setReviewText('');
              setIsBlacklisted(false);
              setBlacklistReason('');
            }}>Cancel</Button>
            {confirmAction?.verb === 'complete' ? (
              <>
                <Button
                  variant="primary"
                  disabled={!confirmAction?.id || (isBlacklisted && !blacklistReason.trim()) || (starRating < 5 && !completionReason.trim())}
                  onClick={async () => {
                    try {
                      const job = jobs.find(j => j._id === confirmAction.id);
                      if (!job) throw new Error('Job not found');

                      // Update job details if changed
                      const nextEmail = (form?.customerEmail ?? job.customerEmail) || '';
                      const nextFare  = String(form?.fareAmount ?? job.fareAmount ?? '').trim();
                      const nextPaymentMethod = form?.paymentMethod ?? job.paymentMethod ?? 'Cash';
                      
                      if (nextEmail !== job.customerEmail || 
                          (nextFare && nextFare !== String(job.fareAmount ?? '')) ||
                          nextPaymentMethod !== job.paymentMethod) {
                        await axios.put(`/view-leads/edit/${confirmAction.id}`, {
                          name: job.customerName,
                          email: nextEmail,
                          phone: job.customerPhone,
                          from: job.from,
                          to: job.to,
                          dateTime: job.dateTime,
                          passengers: job.passengers,
                          fareAmount: nextFare,
                          paymentMethod: nextPaymentMethod,
                          returnTrip: job.returnTrip,
                          dog: job.dog,
                          disabled: job.disabled,
                          notes: job.notes || ''
                        });
                      }

                      // Mark complete with review and blacklist data
                      await axios.post(`/view-leads/complete/${confirmAction.id}`, {
                        starRating,
                        reviewText: reviewText.trim(),
                        isBlacklisted,
                        blacklistReason: isBlacklisted ? blacklistReason.trim() : '',
                        completionReason: starRating < 5 ? completionReason.trim() : '',
                        tipAmount: String(form?.tipAmount || '').trim()
                      });
                      
                      // Refresh and reset
                      await refreshDiary();
                      setMsg('Job completed.');
                      setConfirmAction(null);
                      setStarRating(5);
                      setReviewText('');
                      setIsBlacklisted(false);
                      setBlacklistReason('');
                    } catch (err) {
                      console.error('Complete failed:', err);
                      setMsg('Failed to complete job.');
                    }
                  }}
                >
                  Mark Complete
                </Button>
                <Button
                  variant="success"
                  disabled={!confirmAction?.id || (isBlacklisted && !blacklistReason.trim()) || (starRating < 5 && !completionReason.trim())}
                  onClick={async () => {
                    try {
                      const job = jobs.find(j => j._id === confirmAction.id);
                      if (!job) throw new Error('Job not found');

                      const nextEmail = (form?.customerEmail ?? job.customerEmail) || '';
                      const nextFareStr  = String(form?.fareAmount ?? job.fareAmount ?? '').trim();
                      const nextPaymentMethod = form?.paymentMethod ?? job.paymentMethod ?? 'Cash';

                      // Persist email, fare, and payment method via edit
                      await axios.put(`/view-leads/edit/${confirmAction.id}`, {
                        name: job.customerName,
                        email: nextEmail,
                        phone: job.customerPhone,
                        from: job.from,
                        to: job.to,
                        dateTime: job.dateTime,
                        passengers: job.passengers,
                        fareAmount: nextFareStr,
                        paymentMethod: nextPaymentMethod,
                        returnTrip: job.returnTrip,
                        dog: job.dog,
                        disabled: job.disabled,
                        notes: job.notes || ''
                      });

                      // Complete with review and blacklist data
                      await axios.post(`/view-leads/complete/${confirmAction.id}`, {
                        starRating,
                        reviewText: reviewText.trim(),
                        isBlacklisted,
                        blacklistReason: isBlacklisted ? blacklistReason.trim() : '',
                        completionReason: starRating < 5 ? completionReason.trim() : '',
                        tipAmount: String(form?.tipAmount || '').trim()
                      });

                      // Send receipt
                      const amountNumber = Number(String(nextFareStr || '0').replace(/[^0-9.]/g, '')) || 0;
                      await sendReceiptWithRetry(confirmAction.id, amountNumber, nextEmail);

                      // Refresh and reset
                      await refreshDiary();
                      setMsg('Receipt sent and job completed.');
                      setConfirmAction(null);
                      setStarRating(5);
                      setReviewText('');
                      setIsBlacklisted(false);
                      setBlacklistReason('');
                    } catch (err) {
                      console.error('Send receipt/complete failed:', err);
                      setMsg('Failed to send receipt and complete.');
                    }
                  }}
                >
                  Send Receipt and Complete
                </Button>
                <Button
                  variant="info"
                  disabled={!confirmAction?.id || (isBlacklisted && !blacklistReason.trim()) || (starRating < 5 && !completionReason.trim())}
                  onClick={async () => {
                    try {
                      const job = jobs.find(j => j._id === confirmAction.id);
                      if (!job) throw new Error('Job not found');

                      const nextEmail = (form?.customerEmail ?? job.customerEmail) || '';
                      const nextFare  = String(form?.fareAmount ?? job.fareAmount ?? '').trim();
                      const nextPaymentMethod = form?.paymentMethod ?? job.paymentMethod ?? 'Cash';
                      
                      // Update job details if changed
                      if (nextEmail !== job.customerEmail || 
                          (nextFare && nextFare !== String(job.fareAmount ?? '')) ||
                          nextPaymentMethod !== job.paymentMethod) {
                        await axios.put(`/view-leads/edit/${confirmAction.id}`, {
                          name: job.customerName,
                          email: nextEmail,
                          phone: job.customerPhone,
                          from: job.from,
                          to: job.to,
                          dateTime: job.dateTime,
                          passengers: job.passengers,
                          fareAmount: nextFare,
                          paymentMethod: nextPaymentMethod,
                          returnTrip: job.returnTrip,
                          dog: job.dog,
                          disabled: job.disabled,
                          notes: job.notes || ''
                        });
                      }

                      // Mark complete with review and blacklist data
                      await axios.post(`/view-leads/complete/${confirmAction.id}`, {
                        starRating,
                        reviewText: reviewText.trim(),
                        isBlacklisted,
                        blacklistReason: isBlacklisted ? blacklistReason.trim() : '',
                        completionReason: starRating < 5 ? completionReason.trim() : '',
                        tipAmount: String(form?.tipAmount || '').trim()
                      });

                      // Send SMS with review link
                      const reviewUrl = `${window.location.origin}/review-driver/${confirmAction.id}`;
                      const smsMessage = `🚕 Thank you for using Taxi-Local!\n\nYour journey is complete. We hope you had a great experience!\n\nPlease rate your journey:\n${reviewUrl}\n\nYour feedback helps us improve! ⭐`;
                      
                      sendSMSWithFallback(job.customerPhone, smsMessage, 'Review Request');

                      // Refresh and reset
                      await refreshDiary();
                      setMsg('Job completed and review SMS sent.');
                      setConfirmAction(null);
                      setStarRating(5);
                      setReviewText('');
                      setIsBlacklisted(false);
                      setBlacklistReason('');
                    } catch (err) {
                      console.error('Complete and SMS failed:', err);
                      setMsg('Failed to complete job and send SMS.');
                    }
                  }}
                >
                  Complete & Send SMS Review
                </Button>
              </>
            ) : confirmAction?.verb === 'cancel' ? (
              <Button
                variant="danger"
                disabled={!confirmAction?.id || !cancellationReason}
                onClick={() => {
                  if (confirmAction?.id && cancellationReason) {
                    doAction(confirmAction.id, confirmAction.verb);
                  }
                }}
              >
                Cancel Job
              </Button>
            ) : (
              <Button
                variant={
                  confirmAction?.verb==='release' ? 'warning'
                  : 'success'
                }
                disabled={!confirmAction?.id || !confirmAction?.verb}
                onClick={() => {
                  if (confirmAction?.id && confirmAction?.verb) {
                    doAction(confirmAction.id, confirmAction.verb);
                  }
                }}
              >
                Confirm
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        {/* Enhanced Reassign Modal */}
        <Modal show={!!reassignAction} onHide={() => setReassignAction(null)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Re-assign Job
              {reassignAction?.job?.reassignedBy && reassignAction?.job?.acceptedBy?.companyName && (
                <span className="text-muted ms-2">({reassignAction.job.acceptedBy.companyName})</span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6>Job Details:</h6>
              <p><strong>Customer:</strong> {reassignAction?.job?.customerName?.split(' ')[0] || reassignAction?.job?.customerName}</p>
              <p><strong>Route:</strong> {reassignAction?.job?.from} → {reassignAction?.job?.to}</p>
              <p><strong>Date:</strong> {reassignAction?.job?.dateTime ? formatWhen(reassignAction.job.dateTime) : 'N/A'}</p>
            </div>
            
            <div className="mb-3">
              <h6>Re-assign Options:</h6>
              <div className="d-grid gap-2">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={() => handleReassign(reassignAction.id, 'pool')}
                >
                  <i className="bi bi-people me-2"></i>
                  Re-Assign to Pool
                </Button>
                
                <div className="text-center">
                  <strong>OR</strong>
                </div>
                
                <div>
                  <label className="form-label">Select Specific Driver:</label>
                  
                  {/* Enhanced Driver Selection */}
                  <div className="border rounded p-3" style={{maxHeight: '400px', overflowY: 'auto'}}>
                    {getSortedDrivers(availableDrivers).map(driver => (
                      <div key={driver._id} className="d-flex align-items-start justify-content-between p-2 border-bottom">
                        <div className="flex-grow-1 d-flex align-items-start">
                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 me-2 mt-1"
                            onClick={() => toggleFavouriteDriver(driver._id)}
                          >
                            <i className={`bi ${favouriteDrivers.includes(driver._id) ? 'bi-star-fill text-warning' : 'bi-star'}`}></i>
                          </Button>
                          <div>
                            <div><strong>{driver.companyName || 'No company'}</strong></div>
                            <div className="text-primary">{driver.name || driver.email}</div>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => handleReassign(reassignAction.id, 'driver', driver._id)}
                          >
                            <i className="bi bi-person-check me-1"></i>
                            Re-assign
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setReassignAction(null)}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Handshake Modal */}
        <Modal show={!!handshakeAction} onHide={() => setHandshakeAction(null)}>
          <Modal.Header closeButton>
            <Modal.Title>Send Job Handshake</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <h6>Job Details:</h6>
              <p><strong>Customer:</strong> {reassignAction?.job?.customerName?.split(' ')[0] || reassignAction?.job?.customerName}</p>
              <p><strong>Route:</strong> {reassignAction?.job?.from} → {reassignAction?.job?.to}</p>
              <p><strong>Date:</strong> {reassignAction?.job?.dateTime ? formatWhen(reassignAction.job.dateTime) : 'N/A'}</p>
            </div>
            
            <div className="mb-3">
              <h6>Handshake to Driver:</h6>
              <p><strong>{handshakeAction?.driver?.name || handshakeAction?.driver?.email}</strong></p>
              <p className="text-muted">
                This will send a handshake offer to the selected driver. 
                The job will remain in your diary until they accept or decline.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setHandshakeAction(null)}>
              Cancel
            </Button>
            <Button 
              variant="primary" 
              onClick={() => handleHandshake(handshakeAction.jobId, handshakeAction.driver._id)}
            >
              <i className="bi bi-handshake me-2"></i>
              Send Handshake
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Diary viewer */}
        <DiaryModal
          show={showDiaryModal}
          onHide={()=>setShowDiaryModal(false)}
          diaryEntries={jobs}
          onSendEmail={handleSendEmail}
          onDownloadCsv={handleDownloadCsv}
          onEmailCsv={handleEmailCsv}
        />

        {/* Date Picker Modal */}
        <Modal show={showDateModal} onHide={() => setShowDateModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Date</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            {/* Day of week headers */}
            <div className="row g-1 mb-2">
              {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
                <div key={index} className="col text-center">
                  <small className="fw-bold text-muted">{day}</small>
                </div>
              ))}
            </div>
            
            {/* Date buttons in calendar grid */}
            {(() => {
              const currentDate = editLead ? (form.dateTime || new Date()) : (diaryData.dateTime || new Date());
              const year = currentDate.getFullYear();
              const month = currentDate.getMonth();
              const daysInMonth = new Date(year, month + 1, 0).getDate();
              const firstDayOfMonth = new Date(year, month, 1).getDay(); // 0 = Sunday, 1 = Monday, etc.
              
              const rows = [];
              let dayCounter = 1;
              
              // Calculate number of weeks needed
              const totalCells = firstDayOfMonth + daysInMonth;
              const numWeeks = Math.ceil(totalCells / 7);
              
              for (let week = 0; week < numWeeks; week++) {
                const weekDays = [];
                
                for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                  const cellIndex = week * 7 + dayOfWeek;
                  
                  if (cellIndex < firstDayOfMonth || dayCounter > daysInMonth) {
                    // Empty cell
                    weekDays.push(
                      <div key={`empty-${cellIndex}`} className="col">
                        <div style={{ height: '32px' }}></div>
                      </div>
                    );
                  } else {
                    // Day button
                    const day = dayCounter;
                    const isSelected = day === currentDate.getDate();
                    const isToday = day === new Date().getDate() && 
                                   month === new Date().getMonth() && 
                                   year === new Date().getFullYear();
                    
                    weekDays.push(
                      <div key={day} className="col">
                        <Button
                          variant={isSelected ? "primary" : "outline-primary"}
                          size="sm"
                          onClick={() => {
                            if (editLead) {
                              const newDate = new Date(form.dateTime || new Date());
                              newDate.setDate(day);
                              setForm(f => ({ ...f, dateTime: newDate }));
                            } else {
                              const newDate = new Date(diaryData.dateTime || new Date());
                              newDate.setDate(day);
                              setDiaryData(d => ({ ...d, dateTime: newDate }));
                            }
                          }}
                          className={`w-100 ${isToday ? 'border-warning' : ''}`}
                          style={{ fontSize: '0.75rem', padding: '4px 2px', height: '32px' }}
                        >
                          {day}
                        </Button>
                      </div>
                    );
                    dayCounter++;
                  }
                }
                
                rows.push(
                  <div key={`week-${week}`} className="row g-1 mb-1">
                    {weekDays}
                  </div>
                );
              }
              
              return rows;
            })()}
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowDateModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => {
              // Check if selected date is in the past
              const selectedDate = editLead ? (form.dateTime || new Date()) : (diaryData.dateTime || new Date());
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const selected = new Date(selectedDate);
              selected.setHours(0, 0, 0, 0);
              
              if (selected < today) {
                // Date is in the past, show warning
                setPendingDateSelection({ isEdit: editLead });
                setShowPastDateWarning(true);
              } else {
                // Date is today or future, proceed
                setShowDateModal(false);
              }
            }}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>
        
        {/* Past Date Warning Modal */}
        <Modal show={showPastDateWarning} onHide={() => setShowPastDateWarning(false)} centered size="sm">
          <Modal.Header closeButton style={{ backgroundColor: '#ffc107', color: '#000' }}>
            <Modal.Title className="fs-6">⚠️ Past Date Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-2">
              <strong>The selected date is in the past.</strong>
            </p>
            <p className="mb-0 small text-muted">
              Are you sure you want to schedule a job for a past date?
            </p>
          </Modal.Body>
          <Modal.Footer className="py-2">
            <Button variant="secondary" size="sm" onClick={() => {
              setShowPastDateWarning(false);
              setPendingDateSelection(null);
            }}>
              Go Back
            </Button>
            <Button variant="warning" size="sm" onClick={() => {
              setShowPastDateWarning(false);
              setShowDateModal(false);
              setPendingDateSelection(null);
            }}>
              Override & Continue
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add to Diary - Month Picker Modal */}
        <Modal show={showDiaryMonthModal} onHide={() => setShowDiaryMonthModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Month</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex flex-wrap gap-2">
              {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
                <Button
                  key={index}
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(diaryData.dateTime || new Date());
                    newDate.setMonth(index);
                    setDiaryData(d => ({ ...d, dateTime: newDate }));
                  }}
                  className={`${diaryData.dateTime && diaryData.dateTime.getMonth() === index ? 'active' : ''}`}
                >
                  {month}
                </Button>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowDiaryMonthModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowDiaryMonthModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add to Diary - Year Picker Modal */}
        <Modal show={showDiaryYearModal} onHide={() => setShowDiaryYearModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Year</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex flex-wrap gap-2">
              {[2025, 2026, 2027].map((year) => (
                <Button
                  key={year}
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(diaryData.dateTime || new Date());
                    newDate.setFullYear(year);
                    setDiaryData(d => ({ ...d, dateTime: newDate }));
                  }}
                  className={`${diaryData.dateTime && diaryData.dateTime.getFullYear() === year ? 'active' : ''}`}
                >
                  {year}
                </Button>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowDiaryYearModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowDiaryYearModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add to Diary - Hour Picker Modal */}
        <Modal show={showDiaryHourModal} onHide={() => setShowDiaryHourModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Time Required</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex">
              <div className="flex-grow-1">
                {/* Row 1: Hours 1-6 */}
                <div className="row mb-2 g-1">
                  {[1, 2, 3, 4, 5, 6].map((hour) => (
                    <div key={hour} className="col-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          const newDate = new Date(diaryData.dateTime || new Date());
                          const currentHour = newDate.getHours();
                          const isPM = currentHour >= 12;
                          const newHour = isPM ? hour + 12 : hour;
                          if (hour === 12) {
                            newDate.setHours(isPM ? 12 : 0);
                          } else {
                            newDate.setHours(newHour);
                          }
                          setDiaryData(d => ({ ...d, dateTime: newDate }));
                          setShowDiaryHourModal(false);
                        }}
                        className={`${diaryData.dateTime && (diaryData.dateTime.getHours() % 12 || 12) === hour ? 'active' : ''} w-100`}
                        style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                      >
                        {hour}
                      </Button>
                    </div>
                  ))}
                </div>
                {/* Row 2: Hours 7-12 */}
                <div className="row g-1">
                  {[7, 8, 9, 10, 11, 12].map((hour) => (
                    <div key={hour} className="col-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          const newDate = new Date(diaryData.dateTime || new Date());
                          const currentHour = newDate.getHours();
                          const isPM = currentHour >= 12;
                          const newHour = isPM ? hour + 12 : hour;
                          if (hour === 12) {
                            newDate.setHours(isPM ? 12 : 0);
                          } else {
                            newDate.setHours(newHour);
                          }
                          setDiaryData(d => ({ ...d, dateTime: newDate }));
                          setShowDiaryHourModal(false);
                        }}
                        className={`${diaryData.dateTime && (diaryData.dateTime.getHours() % 12 || 12) === hour ? 'active' : ''} w-100`}
                        style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                      >
                        {hour}
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="ms-2 d-flex flex-column gap-1">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(diaryData.dateTime || new Date());
                    const currentHour = newDate.getHours();
                    if (currentHour >= 12) {
                      newDate.setHours(currentHour - 12);
                    }
                    setDiaryData(d => ({ ...d, dateTime: newDate }));
                  }}
                  className={`${diaryData.dateTime && diaryData.dateTime.getHours() < 12 ? 'active' : ''}`}
                  style={{ minWidth: '45px', fontSize: '0.8rem' }}
                >
                  am
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(diaryData.dateTime || new Date());
                    const currentHour = newDate.getHours();
                    if (currentHour < 12) {
                      newDate.setHours(currentHour + 12);
                    }
                    setDiaryData(d => ({ ...d, dateTime: newDate }));
                  }}
                  className={`${diaryData.dateTime && diaryData.dateTime.getHours() >= 12 ? 'active' : ''}`}
                  style={{ minWidth: '45px', fontSize: '0.8rem' }}
                >
                  pm
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowDiaryHourModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowDiaryHourModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add to Diary - Minute Picker Modal */}
        <Modal show={showDiaryMinuteModal} onHide={() => setShowDiaryMinuteModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Minute</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            {/* Row 1: Minutes 00, 05, 10, 15, 20, 25 */}
            <div className="row mb-2 g-1">
              {[0, 5, 10, 15, 20, 25].map((minute) => (
                <div key={minute} className="col-2">
                  <Button
                    variant={minute === 0 || minute === 15 ? "outline-success" : "outline-primary"}
                    size="sm"
                    onClick={() => {
                      const newDate = new Date(diaryData.dateTime || new Date());
                      newDate.setMinutes(minute);
                      setDiaryData(d => ({ ...d, dateTime: newDate }));
                      setShowDiaryMinuteModal(false);
                    }}
                    className={`${diaryData.dateTime && Math.floor(diaryData.dateTime.getMinutes() / 5) * 5 === minute ? 'active' : ''} w-100`}
                    style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                  >
                    {minute.toString().padStart(2, '0')}
                  </Button>
                </div>
              ))}
            </div>
            {/* Row 2: Minutes 30, 35, 40, 45, 50, 55 */}
            <div className="row g-1">
              {[30, 35, 40, 45, 50, 55].map((minute) => (
                <div key={minute} className="col-2">
                  <Button
                    variant={minute === 30 || minute === 45 ? "outline-success" : "outline-primary"}
                    size="sm"
                    onClick={() => {
                      const newDate = new Date(diaryData.dateTime || new Date());
                      newDate.setMinutes(minute);
                      setDiaryData(d => ({ ...d, dateTime: newDate }));
                      setShowDiaryMinuteModal(false);
                    }}
                    className={`${diaryData.dateTime && Math.floor(diaryData.dateTime.getMinutes() / 5) * 5 === minute ? 'active' : ''} w-100`}
                    style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                  >
                    {minute.toString().padStart(2, '0')}
                  </Button>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowDiaryMinuteModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowDiaryMinuteModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>



        {/* Edit Job - Month Picker Modal */}
        <Modal show={showEditMonthModal} onHide={() => setShowEditMonthModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Month</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex flex-wrap gap-2">
              {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month, index) => (
                <Button
                  key={index}
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(form.dateTime || new Date());
                    newDate.setMonth(index);
                    setForm(f => ({ ...f, dateTime: newDate }));
                  }}
                  className={`${form.dateTime && form.dateTime.getMonth() === index ? 'active' : ''}`}
                >
                  {month}
                </Button>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowEditMonthModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowEditMonthModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Job - Year Picker Modal */}
        <Modal show={showEditYearModal} onHide={() => setShowEditYearModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Year</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex flex-wrap gap-2">
              {[2025, 2026, 2027].map((year) => (
                <Button
                  key={year}
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(form.dateTime || new Date());
                    newDate.setFullYear(year);
                    setForm(f => ({ ...f, dateTime: newDate }));
                  }}
                  className={`${form.dateTime && form.dateTime.getFullYear() === year ? 'active' : ''}`}
                >
                  {year}
                </Button>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowEditYearModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowEditYearModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Job - Hour Picker Modal */}
        <Modal show={showEditHourModal} onHide={() => setShowEditHourModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Time Required</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            <div className="d-flex">
              <div className="flex-grow-1">
                {/* Row 1: Hours 1-6 */}
                <div className="row mb-2 g-1">
                  {[1, 2, 3, 4, 5, 6].map((hour) => (
                    <div key={hour} className="col-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          const newDate = new Date(form.dateTime || new Date());
                          const currentHour = newDate.getHours();
                          const isPM = currentHour >= 12;
                          const newHour = isPM ? hour + 12 : hour;
                          if (hour === 12) {
                            newDate.setHours(isPM ? 12 : 0);
                          } else {
                            newDate.setHours(newHour);
                          }
                          setForm(f => ({ ...f, dateTime: newDate }));
                          setShowEditHourModal(false);
                        }}
                        className={`${form.dateTime && (form.dateTime.getHours() % 12 || 12) === hour ? 'active' : ''} w-100`}
                        style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                      >
                        {hour}
                      </Button>
                    </div>
                  ))}
                </div>
                {/* Row 2: Hours 7-12 */}
                <div className="row g-1">
                  {[7, 8, 9, 10, 11, 12].map((hour) => (
                    <div key={hour} className="col-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          const newDate = new Date(form.dateTime || new Date());
                          const currentHour = newDate.getHours();
                          const isPM = currentHour >= 12;
                          const newHour = isPM ? hour + 12 : hour;
                          if (hour === 12) {
                            newDate.setHours(isPM ? 12 : 0);
                          } else {
                            newDate.setHours(newHour);
                          }
                          setForm(f => ({ ...f, dateTime: newDate }));
                          setShowEditHourModal(false);
                        }}
                        className={`${form.dateTime && (form.dateTime.getHours() % 12 || 12) === hour ? 'active' : ''} w-100`}
                        style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                      >
                        {hour}
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="ms-2 d-flex flex-column gap-1">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(form.dateTime || new Date());
                    const currentHour = newDate.getHours();
                    if (currentHour >= 12) {
                      newDate.setHours(currentHour - 12);
                    }
                    setForm(f => ({ ...f, dateTime: newDate }));
                  }}
                  className={`${form.dateTime && form.dateTime.getHours() < 12 ? 'active' : ''}`}
                  style={{ minWidth: '45px', fontSize: '0.8rem' }}
                >
                  am
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    const newDate = new Date(form.dateTime || new Date());
                    const currentHour = newDate.getHours();
                    if (currentHour < 12) {
                      newDate.setHours(currentHour + 12);
                    }
                    setForm(f => ({ ...f, dateTime: newDate }));
                  }}
                  className={`${form.dateTime && form.dateTime.getHours() >= 12 ? 'active' : ''}`}
                  style={{ minWidth: '45px', fontSize: '0.8rem' }}
                >
                  pm
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowEditHourModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowEditHourModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Job - Minute Picker Modal */}
        <Modal show={showEditMinuteModal} onHide={() => setShowEditMinuteModal(false)} size="sm" dialogClassName="modal-sm">
          <Modal.Header closeButton className="py-2">
            <Modal.Title className="fs-6 text-center w-100">Select Minute</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            {/* Row 1: Minutes 00, 05, 10, 15, 20, 25 */}
            <div className="row mb-2 g-1">
              {[0, 5, 10, 15, 20, 25].map((minute) => (
                <div key={minute} className="col-2">
                  <Button
                    variant={minute === 0 || minute === 15 ? "outline-success" : "outline-primary"}
                    size="sm"
                    onClick={() => {
                      const newDate = new Date(form.dateTime || new Date());
                      newDate.setMinutes(minute);
                      setForm(f => ({ ...f, dateTime: newDate }));
                      setShowEditMinuteModal(false);
                    }}
                    className={`${form.dateTime && Math.floor(form.dateTime.getMinutes() / 5) * 5 === minute ? 'active' : ''} w-100`}
                    style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                  >
                    {minute.toString().padStart(2, '0')}
                  </Button>
                </div>
              ))}
            </div>
            {/* Row 2: Minutes 30, 35, 40, 45, 50, 55 */}
            <div className="row g-1">
              {[30, 35, 40, 45, 50, 55].map((minute) => (
                <div key={minute} className="col-2">
                  <Button
                    variant={minute === 30 || minute === 45 ? "outline-success" : "outline-primary"}
                    size="sm"
                    onClick={() => {
                      const newDate = new Date(form.dateTime || new Date());
                      newDate.setMinutes(minute);
                      setForm(f => ({ ...f, dateTime: newDate }));
                      setShowEditMinuteModal(false);
                    }}
                    className={`${form.dateTime && Math.floor(form.dateTime.getMinutes() / 5) * 5 === minute ? 'active' : ''} w-100`}
                    style={{ fontSize: '0.8rem', padding: '4px 2px' }}
                  >
                    {minute.toString().padStart(2, '0')}
                  </Button>
                </div>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <Button variant="secondary" size="sm" onClick={() => setShowEditMinuteModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" size="sm" onClick={() => setShowEditMinuteModal(false)}>
              SET
            </Button>
          </Modal.Footer>
        </Modal>



        {/* Job Totals Modal */}
        <Modal show={showDailyTotalsModal} onHide={() => {
          setShowDailyTotalsModal(false);
          setSelectedWeekOffset(0); // Reset to current week when modal is closed
        }} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>💰 Job Totals Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Week Navigation */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                              <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={goToPreviousWeek}
                  disabled={selectedWeekOffset <= -52} // Limit to 1 year back
                  title="Previous Week"
                >
                  &lt;
                </Button>
              
              <div className="text-center">
                <h5>Financial Summary</h5>
                <p className="text-muted mb-0">
                  {getWeekDisplayText(selectedWeekOffset)}
                </p>
                <small className="text-muted">
                  {getWeekDateRange(selectedWeekOffset)}
                </small>
              </div>
              
                              <Button 
                  variant="outline-primary" 
                  size="sm"
                  onClick={goToCurrentWeek}
                  disabled={selectedWeekOffset === 0}
                  title="Current Week"
                >
                  &gt;I
                </Button>
            </div>
            
            {/* Time Period Tabs */}
            <div className="row mb-4">
              <div className="col-6">
                <div className="border rounded p-3 text-center">
                  <h6 className="text-muted mb-1">{selectedWeekOffset === 0 ? 'Today' : 'First Day'}</h6>
                  <h4 className="text-primary mb-1">{dailyTotals.today?.count || 0}</h4>
                  <small 
                    className="text-success" 
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDrillDown('day', getTodayValue(), 'Today Jobs')}
                    title="Click to see how this amount was made up"
                  >
                    £{(dailyTotals.today?.total || 0).toFixed(0)}
                  </small>
                  <div className="text-muted small">Tips £{(dailyTotals.today?.tipTotal || 0).toFixed(0)}</div>
                </div>
              </div>
              <div className="col-6">
                <div className="border rounded p-3 text-center">
                  <h6 className="text-muted mb-1">{getWeekDisplayText(selectedWeekOffset)}</h6>
                  <h4 className="text-primary mb-1">{dailyTotals.thisWeek?.count || 0}</h4>
                  <small 
                    className="text-success" 
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleDrillDown('week', getSelectedWeekValue(), `${getWeekDisplayText(selectedWeekOffset)} Jobs`)}
                    title="Click to see how this amount was made up"
                  >
                    £{(dailyTotals.thisWeek?.total || 0).toFixed(0)}
                  </small>
                  <div className="text-muted small">Tips £{(dailyTotals.thisWeek?.tipTotal || 0).toFixed(0)}</div>
                </div>
              </div>
            </div>

            {/* Daily Totals Section */}
            {selectedWeekOffset === 0 && dailyTotals.daily && (
              <div className="mb-4">
                <h6 className="mb-3">Daily Totals (This Week)</h6>
                <div className="border rounded p-3 bg-light">
                  <div className="row text-center">
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Monday Jobs', 'day', 'Monday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Monday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Mon</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Monday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Tuesday Jobs', 'day', 'Tuesday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Tuesday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Tue</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Tuesday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Wednesday Jobs', 'day', 'Wednesday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Wednesday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Wed</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Wednesday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Thursday Jobs', 'day', 'Thursday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Thursday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Thu</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Thursday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Friday Jobs', 'day', 'Friday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Friday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Fri</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Friday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Saturday Jobs', 'day', 'Saturday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Saturday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Sat</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Saturday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                    <div className="col">
                      <div 
                        className="fw-bold fs-6 text-primary" 
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDrillDown('week', getSelectedWeekValue(), 'Sunday Jobs', 'day', 'Sunday')}
                        title="Click to see how this amount was made up"
                      >
                        £{(dailyTotals.daily.Sunday?.total || 0).toFixed(0)}
                      </div>
                      <div className="text-muted small">Sun</div>
                      <div className="text-muted small">Tips £{(dailyTotals.daily.Sunday?.tipTotal || 0).toFixed(0)}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Payment Method Breakdown (Today) Section */}
            {selectedWeekOffset === 0 && dailyTotals.today && (
              <div className="mb-4">
                <h6 className="mb-3">Payment Method Breakdown (Today)</h6>
                <div className="space-y-2">
                  {Object.entries(dailyTotals.today?.byPaymentMethod || {}).map(([method, data]) => (
                    data.count > 0 && (
                      <div key={method} className="d-flex justify-content-between align-items-center p-2 border rounded">
                        <div>
                          <strong>{method}</strong>
                          <br />
                          <small className="text-muted">{data.count} job{data.count !== 1 ? 's' : ''}</small>
                        </div>
                        <div 
                          className="text-end"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDrillDown('day', getTodayValue(), `Today - ${method} Jobs`, 'paymentMethod', method)}
                          title="Click to see how this amount was made up"
                        >
                          <strong className="text-primary">£{data.total.toFixed(0)}</strong>
                        </div>
                      </div>
                    )
                  ))}
                  {(!dailyTotals.today?.byPaymentMethod || Object.values(dailyTotals.today.byPaymentMethod).every(data => data.count === 0)) && (
                    <div className="text-center text-muted py-2">
                      <small>No jobs with payment methods found today</small>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Payment Method Breakdown */}
            <h6 className="mb-3">Payment Method Breakdown ({getWeekDisplayText(selectedWeekOffset)})</h6>
            <div className="space-y-2">
              {Object.entries(dailyTotals.thisWeek?.byPaymentMethod || {}).map(([method, data]) => (
                data.count > 0 && (
                  <div key={method} className="d-flex justify-content-between align-items-center p-2 border rounded">
                    <div>
                      <strong>{method}</strong>
                      <br />
                      <small className="text-muted">{data.count} job{data.count !== 1 ? 's' : ''}</small>
                    </div>
                    <div 
                      className="text-end"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDrillDown('week', getSelectedWeekValue(), `${getWeekDisplayText(selectedWeekOffset)} - ${method} Jobs`, 'paymentMethod', method)}
                      title="Click to see how this amount was made up"
                    >
                      <strong className="text-primary">£{data.total.toFixed(0)}</strong>
                    </div>
                  </div>
                )
              ))}
            </div>

            {/* Input Method Breakdown (Today) Section */}
            {selectedWeekOffset === 0 && dailyTotals.today && (
              <div className="mb-4 mt-4">
                <h6 className="mb-3">Input Method Analysis (Today)</h6>
                <div className="space-y-2">
                  {Object.entries(dailyTotals.today?.byInputMethod || {}).map(([method, data]) => (
                    data.count > 0 && (
                      <div key={method} className="d-flex justify-content-between align-items-center p-2 border rounded">
                        <div>
                          <strong>{method}</strong>
                          <br />
                          <small className="text-muted">{data.count} job{data.count !== 1 ? 's' : ''}</small>
                        </div>
                        <div className="text-end">
                          <strong className="text-primary">£{data.total.toFixed(0)}</strong>
                          <br />
                          <small className="text-muted">Tips £{data.tipTotal.toFixed(0)}</small>
                        </div>
                      </div>
                    )
                  ))}
                  {(!dailyTotals.today?.byInputMethod || Object.values(dailyTotals.today.byInputMethod).every(data => data.count === 0)) && (
                    <div className="text-center text-muted py-2">
                      <small>No jobs found today</small>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Input Method Breakdown (This Week) Section */}
            <div className="mb-4 mt-4">
              <h6 className="mb-3">Input Method Analysis ({getWeekDisplayText(selectedWeekOffset)})</h6>
              <div className="space-y-2">
                {Object.entries(dailyTotals.thisWeek?.byInputMethod || {}).map(([method, data]) => (
                  data.count > 0 && (
                    <div key={method} className="d-flex justify-content-between align-items-center p-2 border rounded">
                      <div>
                        <strong>{method}</strong>
                        <br />
                        <small className="text-muted">{data.count} job{data.count !== 1 ? 's' : ''}</small>
                      </div>
                      <div className="text-end">
                        <strong className="text-primary">£{data.total.toFixed(0)}</strong>
                        <br />
                        <small className="text-muted">Tips £{data.tipTotal.toFixed(0)}</small>
                      </div>
                    </div>
                  )
                ))}
                {(!dailyTotals.thisWeek?.byInputMethod || Object.values(dailyTotals.thisWeek.byInputMethod || {}).every(data => data.count === 0)) && (
                  <div className="text-center text-muted py-2">
                    <small>No jobs found {getWeekDisplayText(selectedWeekOffset).toLowerCase()}</small>
                  </div>
                )}
              </div>
            </div>

            {(!dailyTotals.thisWeek || dailyTotals.thisWeek.count === 0) && (
              <div className="text-center text-muted py-4">
                <p>No jobs with fare amounts found {getWeekDisplayText(selectedWeekOffset).toLowerCase()}</p>
                <small>Showing data for: {getWeekDateRange(selectedWeekOffset)}</small>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDailyTotalsModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>


        <style>{`
          .calendar-grid {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 2px;
          }
          
          .calendar-header {
            display: contents;
          }
          
          .calendar-day-header {
            text-align: center;
            font-weight: bold;
            font-size: 0.7rem;
            color: #6c757d;
            padding: 2px;
          }
          
          .calendar-body {
            display: contents;
          }
          
          .calendar-day {
            text-align: center;
            padding: 4px 2px;
            border-radius: 3px;
            cursor: pointer;
            font-size: 0.75rem;
            transition: background-color 0.2s;
            min-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .calendar-day:hover {
            background-color: #e9ecef;
          }
          
          .calendar-day.selected {
            background-color: #007bff;
            color: white;
          }
          
          .calendar-day.today {
            background-color: #28a745;
            color: white;
          }
          
          .calendar-day.text-muted {
            color: #6c757d;
            cursor: default;
          }
        `}</style>

        {/* Drill-down Modal */}
        <Modal show={showDrillDown} onHide={() => setShowDrillDown(false)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{drillDownData?.title || 'Job Breakdown'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {drillDownData && (
              <>
                {/* Summary Cards */}
                <Row className="mb-4">
                  <Col md={6}>
                    <Card className="text-center">
                      <Card.Body>
                        <h4 className="text-primary">{drillDownData.summary?.totalJobs || 0}</h4>
                        <small className="text-muted">Total Jobs</small>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="text-center">
                      <Card.Body>
                        <h4 className="text-success">£{(drillDownData.summary?.totalAmount || 0).toFixed(2)}</h4>
                        <small className="text-muted">Total Amount</small>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* Job Breakdown - Simple View */}
                <Card className="mb-4">
                  <Card.Header>How This Amount Was Made Up</Card.Header>
                  <Card.Body>
                    {(() => {
                      // Get jobs from either direct jobs array or dailyBreakdown
                      let jobsToShow = [];
                      
                      if (drillDownData.jobs && drillDownData.jobs.length > 0) {
                        jobsToShow = drillDownData.jobs;
                      } else if (drillDownData.dailyBreakdown) {
                        // Flatten all jobs from daily breakdown
                        jobsToShow = Object.values(drillDownData.dailyBreakdown)
                          .flatMap(dayData => dayData.jobs || [])
                          .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime));
                      }
                      
                      console.log('Jobs to show:', jobsToShow);
                      
                      return jobsToShow.length > 0 ? (
                        <Table size="sm" striped>
                          <thead>
                            <tr>
                              <th>Time</th>
                              <th>Payment Method</th>
                              <th className="text-end">Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {jobsToShow.map((job, index) => {
                              // Debug the job object structure
                              console.log('Job object:', job);
                              
                              // Try multiple possible amount fields
                              const amount = parseFloat(
                                job.fareAmount || 
                                job.amount || 
                                job.total || 
                                job.price || 
                                0
                              );
                              
                              console.log('Parsed amount:', amount, 'from fields:', {
                                fareAmount: job.fareAmount,
                                amount: job.amount,
                                total: job.total,
                                price: job.price
                              });
                              
                              return (
                                <tr key={index}>
                                  <td>{new Date(job.dateTime).toLocaleTimeString('en-GB', { 
                                    hour: '2-digit', 
                                    minute: '2-digit',
                                    hour12: false 
                                  })}</td>
                                  <td>
                                    <Badge bg="secondary">{job.paymentMethod || 'Cash'}</Badge>
                                  </td>
                                  <td className="text-end fw-bold">£{amount.toFixed(2)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                          <tfoot>
                            <tr className="table-active">
                              <th colSpan="2">Total</th>
                              <th className="text-end">£{(drillDownData.summary?.totalAmount || 0).toFixed(2)}</th>
                            </tr>
                          </tfoot>
                        </Table>
                      ) : (
                        <div className="text-center text-muted py-4">
                          <p>No job details available</p>
                          <small>Unable to load individual job breakdown</small>
                        </div>
                      );
                    })()}
                  </Card.Body>
                </Card>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDrillDown(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Blacklist Warning Modal */}
        <Modal 
          show={showBlacklistWarning} 
          onHide={() => setShowBlacklistWarning(false)} 
          centered
          size="lg"
        >
          <Modal.Header closeButton style={{ backgroundColor: '#dc3545', color: 'white' }}>
            <Modal.Title>⚠️ Customer Blacklisted</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {blacklistWarningData && (
              <>
                <Alert variant="danger" className="mb-3">
                  <strong>WARNING:</strong> This customer has been blacklisted by another driver.
                </Alert>
                
                <div className="mb-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                  <h6 className="mb-2"><strong>Customer Details:</strong></h6>
                  <div><strong>Name:</strong> {blacklistWarningData.customerName}</div>
                  <div><strong>Phone:</strong> {blacklistWarningData.customerPhone}</div>
                  <div><strong>Email:</strong> {blacklistWarningData.customerEmail}</div>
                </div>

                <div className="mb-3 p-3" style={{ backgroundColor: '#fff3cd', borderRadius: '8px', border: '2px solid #ffc107' }}>
                  <h6 className="mb-2"><strong>Blacklist Information:</strong></h6>
                  <div className="mb-2">
                    <strong>Added by:</strong> {blacklistWarningData.addedByDriverId?.companyName || 
                                                 `${blacklistWarningData.addedByDriverId?.firstName} ${blacklistWarningData.addedByDriverId?.surname}` ||
                                                 blacklistWarningData.addedByDriverId?.email}
                  </div>
                  <div className="mb-2">
                    <strong>Date added:</strong> {new Date(blacklistWarningData.createdAt).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                  <div>
                    <strong>Reason:</strong>
                    <div className="mt-2 p-2" style={{ backgroundColor: 'white', borderRadius: '4px', whiteSpace: 'pre-wrap' }}>
                      {blacklistWarningData.reason}
                    </div>
                  </div>
                </div>

                <Alert variant="warning" className="mb-0">
                  <small>
                    <strong>Note:</strong> You can still proceed with this booking at your own discretion. 
                    This is a warning based on another driver's experience.
                  </small>
                </Alert>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBlacklistWarning(false)}>
              Close
            </Button>
            <Button variant="warning" onClick={() => setShowBlacklistWarning(false)}>
              Proceed Anyway
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Job Cancellation Modal */}
        <JobCancellationModal
          show={showCancellationModal}
          onHide={() => {
            setShowCancellationModal(false);
            setJobToCancel(null);
          }}
          onSubmit={handleJobCancellation}
          job={jobToCancel}
          isSubmitting={saving}
        />

        {/* Customer Review Modal */}
        <CustomerReviewModal
          show={showCustomerReviewModal}
          onHide={() => {
            setShowCustomerReviewModal(false);
            setCustomerReviewData(null);
            setCustomerInfo(null);
          }}
          reviewData={customerReviewData}
          customerInfo={customerInfo}
        />

        {/* Slide Panel for Navigation and Taxi Meter */}
        <div 
          className={`slide-panel-overlay ${showSlidePanel ? 'show' : ''}`}
          onClick={handleCloseSlidePanel}
        >
          <div 
            className={`slide-panel ${showSlidePanel ? 'show' : ''} ${navigationNightMode ? 'night-mode' : ''}`}
            onClick={(e) => e.stopPropagation()}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            style={{
              backgroundColor: navigationNightMode ? '#2c2c2c' : '#ffffff',
              color: navigationNightMode ? '#e0e0e0' : '#000000'
            }}
          >
            <div 
              className="slide-panel-header"
              style={{
                backgroundColor: navigationNightMode ? '#404040' : '#ffffff',
                color: navigationNightMode ? '#e0e0e0' : '#000000',
                borderBottom: navigationNightMode ? '1px solid #666666' : '1px solid #dee2e6',
                position: 'sticky',
                top: 0,
                zIndex: 100,
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                padding: '12px 16px'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <h5 className="mb-0" style={{ color: navigationNightMode ? '#e0e0e0' : '#000000' }}>
                  {slidePanelType === 'navigation' ? '🧭 Navigation' : '🚖 Taxi Meter'}
                </h5>
                {/* Clock display (exact match to app header) - Clickable to toggle night mode */}
                <div 
                  className="btn btn-outline-dark rounded d-flex align-items-center justify-content-center" 
                  onClick={() => setNavigationNightMode(!navigationNightMode)}
                  style={{ 
                    fontFamily: 'monospace', 
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    padding: '0.5rem 0.75rem',
                    border: '1px solid #6c757d',
                    backgroundColor: navigationNightMode ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)',
                    color: navigationNightMode ? '#ffffff' : '#000000',
                    minWidth: '80px',
                    height: '38px',
                    lineHeight: '1',
                    textAlign: 'center',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease, color 0.3s ease'
                  }}
                  title="Click to toggle night mode"
                >
                  {formatTime(currentTime)}
                </div>
                <Button
                  variant="link"
                  onClick={handleCloseSlidePanel}
                  style={{ 
                    color: navigationNightMode ? '#e0e0e0' : '#000', 
                    textDecoration: 'none', 
                    padding: 0, 
                    minWidth: 'auto' 
                  }}
                >
                  ✕
                </Button>
              </div>
              
              {/* Travel Time, Distance, ETA Information Panel in Header - Accordion */}
              {slidePanelType === 'navigation' && navigationDestination && (
                <Accordion 
                  activeKey={navigationAccordionExpanded ? "0" : ""}
                  onSelect={(e) => setNavigationAccordionExpanded(e === "0")}
                  style={{
                    marginTop: '8px',
                    borderTop: navigationNightMode ? '1px solid #666666' : '1px solid #e9ecef',
                    paddingTop: '8px'
                  }}
                >
                  <Accordion.Item 
                    eventKey="0"
                    className={navigationNightMode ? 'navigation-night-mode-accordion' : ''}
                    style={{
                      backgroundColor: navigationNightMode ? '#000000' : 'transparent',
                      border: 'none',
                      borderBottom: 'none'
                    }}
                  >
                    <Accordion.Header
                      className={navigationNightMode ? 'navigation-night-mode-accordion' : ''}
                      style={{
                        backgroundColor: navigationNightMode ? '#000000' : 'transparent',
                        padding: '0',
                        fontSize: '0.9rem',
                        color: navigationNightMode ? '#ffffff' : '#000000'
                      }}
                    >
                      <div style={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '12px', 
                        width: '100%',
                        alignItems: 'center',
                        color: navigationNightMode ? '#ffffff' : '#000000'
                      }}>
                        {/* ETA */}
                        {(navigationOrigin && etaFromTo) || (!navigationOrigin && etaFromCurrent) ? (
                          <div>
                            <strong>ETA:</strong>{' '}
                            <strong style={{ fontWeight: 'bold' }}>
                              {(navigationOrigin && etaFromTo) 
                                ? etaFromTo.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })
                                : etaFromCurrent.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true })
                              }
                            </strong>
                          </div>
                        ) : null}
                        
                        {/* From */}
                        {navigationOrigin && (
                          <div>
                            <strong>From:</strong> {navigationOrigin}
                          </div>
                        )}
                        
                        {/* To */}
                        <div>
                          <strong>To:</strong> {navigationDestination}
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body
                      className={navigationNightMode ? 'navigation-night-mode-accordion' : ''}
                      style={{
                        padding: '12px 0 0 0',
                        backgroundColor: navigationNightMode ? '#000000' : 'transparent',
                        color: navigationNightMode ? '#ffffff' : '#000000'
                      }}
                    >
                      <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        gap: '8px',
                        fontSize: '0.9rem',
                        color: navigationNightMode ? '#ffffff' : '#000000'
                      }}>
                        {/* Travel Time and Distance on same line */}
                        {(((navigationOrigin && routeTime !== null) || (!navigationOrigin && travelTimeFromCurrent !== null)) ||
                          ((navigationOrigin && Number.isFinite(routeDistance)) || (!navigationOrigin && Number.isFinite(travelDistanceFromCurrent)))) && (
                          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', color: navigationNightMode ? '#ffffff' : '#000000' }}>
                            {/* Travel Time */}
                            {((navigationOrigin && routeTime !== null) || (!navigationOrigin && travelTimeFromCurrent !== null)) && (
                              <div style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>
                                <strong style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>Travel Time:</strong>{' '}
                                {navigationOrigin ? routeTime : travelTimeFromCurrent} min
                              </div>
                            )}
                            
                            {/* Distance */}
                            {((navigationOrigin && Number.isFinite(routeDistance)) || (!navigationOrigin && Number.isFinite(travelDistanceFromCurrent))) && (
                              <div style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>
                                <strong style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>Distance:</strong>{' '}
                                {navigationOrigin 
                                  ? routeDistance.toFixed(2) 
                                  : travelDistanceFromCurrent.toFixed(2)
                                } m
                              </div>
                            )}
                          </div>
                        )}
                        
                        {/* Estimated Fare */}
                        {fareEstimates && (
                          (hasFareEstimateValue(fareEstimates.T1) ||
                           hasFareEstimateValue(fareEstimates.T2) ||
                           hasFareEstimateValue(fareEstimates.T3))
                        ) && (
                          <div style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>
                            <strong style={{ color: navigationNightMode ? '#ffffff' : '#000000' }}>Estimated Fare:</strong>{' '}
                            T1 £{Math.round(fareEstimates.T1 || 0)} |{' '}
                            T2 £{Math.round(fareEstimates.T2 || 0)} |{' '}
                            T3 £{Math.round(fareEstimates.T3 || 0)}
                          </div>
                        )}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              )}
            </div>
            <div 
              className="slide-panel-body"
              style={{
                backgroundColor: navigationNightMode ? '#2c2c2c' : '#ffffff',
                color: navigationNightMode ? '#e0e0e0' : '#000000'
              }}
            >
              {slidePanelType === 'navigation' && navigationDestination && (
                <div style={{ padding: '1rem', color: navigationNightMode ? '#e0e0e0' : '#000000' }}>
                  {/* Show loading/error states only - From, To, and Estimated Fare are in header accordion */}
                  {navigationOrigin && routeTime === null && !directionsError && (
                    <Alert variant="info" className="mb-3 py-2">
                      <small>📍 Calculating route...</small>
                    </Alert>
                  )}
                  
                  {!navigationOrigin && isGettingCurrentLocation && (
                    <Alert variant="info" className="mb-3 py-2">
                      <small>📍 Getting your current location...</small>
                    </Alert>
                  )}
                  
                  {!navigationOrigin && !isGettingCurrentLocation && travelTimeFromCurrent === null && !directionsError && (
                    <Alert variant="warning" className="mb-3 py-2">
                      <small>⚠️ Unable to calculate travel time. Please enable location services.</small>
                    </Alert>
                  )}
                  
                  {/* Google Maps Navigation Window */}
                  {isGoogleMapsLoaded && (
                    <div className="navigation-map-container mb-3">
                      <GoogleMap
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        center={
                          directionsResponse && directionsResponse.routes && directionsResponse.routes[0]
                            ? null // Let DirectionsRenderer handle it
                            : destinationCoords || { lat: 52.3555, lng: -1.1743 }
                        }
                        zoom={null} // No initial zoom
                        options={{
                          disableDefaultUI: false, // Keep fullscreen control
                          zoomControl: false,
                          streetViewControl: false,
                          mapTypeControl: false,
                          fullscreenControl: true, // Leave full screen icon
                          mapTypeId: window.google?.maps?.MapTypeId?.ROADMAP || 'roadmap',
                          gestureHandling: 'greedy', // Allow finger panning and pinch zoom
                          disableDoubleClickZoom: false, // Allow double-click zoom
                          scrollwheel: true, // Allow scroll wheel zoom (for desktop)
                          tilt: 45, // Slight tilt for navigation view
                          heading: currentHeading || 0, // Orient in direction of travel
                          styles: navigationNightMode ? googleMapsNightModeStyles : [
                            {
                              featureType: 'poi',
                              elementType: 'labels',
                              stylers: [{ visibility: 'off' }] // Hide business names/POI labels
                            },
                            {
                              featureType: 'poi.business',
                              stylers: [{ visibility: 'off' }] // Hide business POIs
                            },
                            {
                              featureType: 'poi.attraction',
                              stylers: [{ visibility: 'off' }] // Hide attractions
                            },
                            {
                              featureType: 'poi.place_of_worship',
                              stylers: [{ visibility: 'off' }] // Hide places of worship
                            },
                            {
                              featureType: 'poi.school',
                              stylers: [{ visibility: 'off' }] // Hide schools
                            },
                            {
                              featureType: 'poi.sports_complex',
                              stylers: [{ visibility: 'off' }] // Hide sports complexes
                            },
                            {
                              featureType: 'poi.park',
                              stylers: [{ visibility: 'off' }] // Hide parks
                            },
                            {
                              featureType: 'poi.government',
                              stylers: [{ visibility: 'off' }] // Hide government buildings
                            },
                            {
                              featureType: 'poi.medical',
                              stylers: [{ visibility: 'off' }] // Hide medical facilities
                            },
                            {
                              featureType: 'poi',
                              elementType: 'geometry',
                              stylers: [{ visibility: 'off' }] // Hide POI geometry
                            },
                            {
                              featureType: 'transit',
                              elementType: 'labels',
                              stylers: [{ visibility: 'off' }] // Hide transit labels
                            },
                            {
                              featureType: 'road',
                              elementType: 'labels',
                              stylers: [{ visibility: 'on' }] // Show road labels (includes house numbers)
                            }
                          ]
                        }}
                        onLoad={(map) => {
                          // Store map reference for zoom control
                          mapRef.current = map;
                          
                          // Mark map as initialized
                          setMapInitialized(true);
                          
                          // Track user zoom/pan interactions
                          map.addListener('zoom_changed', () => {
                            userHasZoomed.current = true;
                          });
                          map.addListener('dragend', () => {
                            userHasZoomed.current = true;
                          });
                          
                          // Instantly set bounds when coordinates are available (no delay)
                          // Priority: If we have A to B (origin to destination), show both with 3% padding on left/right
                          // This handles the "To" link case
                          if (originCoords && destinationCoords) {
                            const bounds = new window.google.maps.LatLngBounds();
                            bounds.extend(new window.google.maps.LatLng(originCoords.lat, originCoords.lng));
                            bounds.extend(new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng));
                            map.fitBounds(bounds, { 
                              left: window.innerWidth * 0.03,
                              right: window.innerWidth * 0.03,
                              top: 0,
                              bottom: 0
                            });
                          }
                          // If we have A (origin) and Driver location, show both with 3% padding on left/right
                          else if (originCoords && currentLocationCoords) {
                            const bounds = new window.google.maps.LatLngBounds();
                            bounds.extend(new window.google.maps.LatLng(originCoords.lat, originCoords.lng));
                            bounds.extend(new window.google.maps.LatLng(currentLocationCoords.lat, currentLocationCoords.lng));
                            map.fitBounds(bounds, { 
                              left: window.innerWidth * 0.03,
                              right: window.innerWidth * 0.03,
                              top: 0,
                              bottom: 0
                            });
                          }
                          // If we have a route, use route bounds with 3% padding on left/right
                          else if (directionsResponse && directionsResponse.routes && directionsResponse.routes[0]) {
                            const bounds = directionsResponse.routes[0].bounds;
                            if (bounds) {
                              map.fitBounds(bounds, { 
                                left: window.innerWidth * 0.03,
                                right: window.innerWidth * 0.03,
                                top: 0,
                                bottom: 0
                              });
                            }
                          }
                          // If we have Driver location and destination, show both with 3% padding on left/right
                          else if (currentLocationCoords && destinationCoords) {
                            const bounds = new window.google.maps.LatLngBounds();
                            bounds.extend(new window.google.maps.LatLng(currentLocationCoords.lat, currentLocationCoords.lng));
                            bounds.extend(new window.google.maps.LatLng(destinationCoords.lat, destinationCoords.lng));
                            map.fitBounds(bounds, { 
                              left: window.innerWidth * 0.03,
                              right: window.innerWidth * 0.03,
                              top: 0,
                              bottom: 0
                            });
                          }
                        }}
                      >
                        {directionsResponse && (
                          <DirectionsRenderer directions={directionsResponse} />
                        )}
                        {!directionsResponse && destinationCoords && (
                          <Marker
                            position={destinationCoords}
                            title={navigationDestination}
                          />
                        )}
                        {!directionsResponse && originCoords && navigationOrigin && (
                          <Marker
                            position={originCoords}
                            title={navigationOrigin}
                            label={{ text: 'A', color: 'white' }}
                          />
                        )}
                        {/* Always show driver pin when location is available */}
                        {currentLocationCoords && (
                          <Marker
                            position={currentLocationCoords}
                            title="Your Current Location"
                            icon={{
                              url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
                            }}
                          />
                        )}
                      </GoogleMap>
                      
                      
                      {/* Junction Details Popup - appears when within 100m of junction */}
                      {junctionPopup && junctionPopup.visible && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '20px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: 'rgba(0, 123, 255, 0.95)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '12px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            zIndex: 1001,
                            boxShadow: '0 4px 15px rgba(0,0,0,0.4)',
                            border: '2px solid #fff',
                            maxWidth: '90%',
                            textAlign: 'center',
                            minWidth: '250px'
                          }}
                        >
                          <div style={{ marginBottom: '8px', fontSize: '1.1rem' }}>
                            🚦 Junction Ahead
                          </div>
                          <div style={{ fontSize: '0.9rem', marginBottom: '5px' }}>
                            {junctionPopup.instruction}
                          </div>
                          {junctionPopup.distanceText && (
                            <div style={{ fontSize: '0.85rem', opacity: 0.9 }}>
                              {junctionPopup.distanceText}
                            </div>
                          )}
                        </div>
                      )}
                      
                      {/* Destination Details Popup - appears when within 50m of destination */}
                      {destinationDetails && destinationDetails.visible && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: junctionPopup && junctionPopup.visible ? '120px' : '20px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: 'rgba(40, 167, 69, 0.95)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '12px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            zIndex: 1002,
                            boxShadow: '0 4px 15px rgba(0,0,0,0.4)',
                            border: '2px solid #fff',
                            maxWidth: '90%',
                            textAlign: 'center',
                            minWidth: '250px'
                          }}
                        >
                          <div style={{ marginBottom: '8px', fontSize: '1.1rem' }}>
                            🏠 Destination Nearby
                          </div>
                          {destinationDetails.houseName && (
                            <div style={{ fontSize: '1.3rem', marginBottom: '5px', fontWeight: 'bold' }}>
                              {destinationDetails.houseName}
                            </div>
                          )}
                          {destinationDetails.houseNumber && (
                            <div style={{ fontSize: '1.2rem', marginBottom: '5px' }}>
                              {destinationDetails.houseNumber}
                            </div>
                          )}
                          <div style={{ fontSize: '0.85rem', opacity: 0.9 }}>
                            {destinationDetails.address}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  
                  {!isGoogleMapsLoaded && (
                    <Alert variant="warning" className="mb-3">
                      <small>Loading Google Maps...</small>
                    </Alert>
                  )}
                  
                  {directionsError && (
                    <Alert variant="danger" className="mb-3">
                      <small>Unable to calculate route: {directionsError}</small>
                      {geocodeOriginError && (
                        <div className="mt-2">
                          <small className="text-muted">💡 Hint: Use Postcode</small>
                        </div>
                      )}
                    </Alert>
                  )}
                  {geocodeOriginError && !directionsError && (
                    <Alert variant="warning" className="mb-3">
                      <small>⚠️ Unable to calculate travel time due to inaccurate "From" location.</small>
                      <div className="mt-2">
                        <small className="text-muted">💡 Hint: Use Postcode</small>
                      </div>
                    </Alert>
                  )}
                </div>
              )}
              {slidePanelType === 'taximeter' && (
                <div>
                  <TaxiMeter />
                </div>
              )}
            </div>
            {/* Navigation Footer - Open in Google Maps */}
            {slidePanelType === 'navigation' && (
              <div
                style={{
                  position: 'relative',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: navigationNightMode ? '#404040' : '#f8f9fa',
                  borderTop: navigationNightMode ? '2px solid #666666' : '2px solid #dee2e6',
                  zIndex: 1000,
                  padding: '12px 16px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0
                }}
              >
                <Button
                  variant="primary"
                  onClick={() => {
                    if (destinationCoords) {
                      // Build Google Maps URL
                      let mapsUrl = 'https://www.google.com/maps/dir/';
                      
                      // Add origin if available
                      if (originCoords) {
                        mapsUrl += `${originCoords.lat},${originCoords.lng}/`;
                      } else if (currentLocationCoords) {
                        mapsUrl += `${currentLocationCoords.lat},${currentLocationCoords.lng}/`;
                      }
                      
                      // Add destination
                      mapsUrl += `${destinationCoords.lat},${destinationCoords.lng}`;
                      
                      // Open in new tab
                      window.open(mapsUrl, '_blank');
                    } else if (navigationDestination) {
                      // Fallback: use destination address
                      const encodedDestination = encodeURIComponent(navigationDestination);
                      const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedDestination}`;
                      window.open(mapsUrl, '_blank');
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '12px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    backgroundColor: navigationNightMode ? '#007bff' : '#007bff',
                    border: 'none',
                    borderRadius: '8px',
                    color: '#fff',
                    cursor: 'pointer'
                  }}
                  disabled={!destinationCoords && !navigationDestination}
                >
                  🗺️ Open in Google Maps
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
